webpackJsonp([1],{

/***/ "+nda":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/p3-1.82ffb64.jpg";

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "03Ll":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/p3-4.e6b8c77.jpg";

/***/ }),

/***/ "1DlP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1Q6r":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/banner_05.6009b7e.jpg";

/***/ }),

/***/ "1go9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"case-nav"}),_vm._v(" "),_c('div',{staticClass:"com-detail"},[_c('div',{staticClass:"com-top-top"},[_c('ul',_vm._l((_vm.navli),function(navli){return _c('li',{staticClass:"casenav",class:{caseacli : _vm.lijudge == navli.id},on:{"click":function($event){return _vm.seltab(navli.id)}}},[_vm._v(_vm._s(navli.litit))])}),0)]),_vm._v(" "),_c('div',{staticClass:"cominfo"},_vm._l((_vm.navli),function(sel){return (sel.id == _vm.lijudge)?_c('div',{staticClass:"sel-tab"},[(_vm.lijudge == 0)?_c('div',{staticClass:"caseone"},[_vm._m(1,true),_vm._v(" "),_vm._m(2,true),_vm._v(" "),_vm._m(3,true)]):_vm._e(),_vm._v(" "),(_vm.lijudge == 1)?_c('div',{staticClass:"caseone"},[_vm._m(4,true),_vm._v(" "),_vm._m(5,true)]):_vm._e(),_vm._v(" "),(_vm.lijudge == 2)?_c('div',{staticClass:"caseone"},[_vm._m(6,true),_vm._v(" "),_vm._m(7,true),_vm._v(" "),_vm._m(8,true)]):_vm._e(),_vm._v(" "),(_vm.lijudge == 3)?_c('div',{staticClass:"caseone"},[_vm._m(9,true)]):_vm._e(),_vm._v(" "),(_vm.lijudge == 4)?_c('div',{staticClass:"caseone"},[_vm._m(10,true)]):_vm._e(),_vm._v(" "),(_vm.lijudge == 5)?_c('div',{staticClass:"caseone"},[_vm._m(11,true)]):_vm._e(),_vm._v(" "),(_vm.lijudge == 6)?_c('div',{staticClass:"caseone"},[_vm._m(12,true)]):_vm._e(),_vm._v(" "),(_vm.lijudge == 7)?_c('div',{staticClass:"caseone"},[_vm._m(13,true)]):_vm._e()]):_vm._e()}),0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comtop"},[_c('img',{attrs:{"src":__webpack_require__("jwzE")}}),_vm._v(" "),_c('div',{staticClass:"bannerMask"},[_c('div')]),_vm._v(" "),_c('div',{staticClass:"com-tit"},[_c('span',[_c('img',{attrs:{"src":__webpack_require__("q5Xz")}}),_c('b',[_vm._v("案例展示")])]),_vm._v(" "),_c('p',[_vm._v("深入洞察行业需求，在各行业中广泛使用，并正在为更多的客"),_c('br'),_vm._v("户带来效率和价值的提升")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"casetab"},[_c('div',{staticClass:"tab-tit"},[_c('h2',[_vm._v("阳江市公共资源交易统一管理系统")]),_vm._v(" "),_c('b',[_vm._v("建设单位：阳江市公共资源交易中心 ")]),_vm._v(" "),_c('b',[_vm._v("项目类型：软件开发 ")]),_vm._v(" "),_c('b',[_vm._v("所属行业：服务事业单位")]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"tab-contents"},[_c('div',{staticClass:"t-c-left"},[_c('b',[_vm._v("项目概况：")]),_c('p',[_vm._v("阳江市公共资源交易统一管理系统是专门为公共资源交易业务而设计、开发的管理系统，对用户的多种交易业务类型，达到了相关业\n\t\t\t\t\t\t\t\t\t\t务的网上全流程化，实现了网上报名、网上交保证金、网上竞价、网上评标、网上公示等功能，整体系统安全、保密性强，有效的提升了交易中心的整\n\t\t\t\t\t\t\t\t\t\t体业务水平，体现了公共资源交易的“公开、公平、公正”的交易原则。\n\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('b',[_vm._v("建设内容：")]),_c('p',[_vm._v("系统主要包括1、门户网站，2、政府采购、土地交易、产权交易、工程交易四大业务系统 3、统一业务管理，4、安全认证子系统。")])]),_vm._v(" "),_c('div',{staticClass:"t-c-right"},[_c('img',{attrs:{"src":__webpack_require__("4kaR")}}),_vm._v(" "),_c('p',[_vm._v("阳江市公共资源交易统一管理系统图示")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"casetab"},[_c('div',{staticClass:"tab-tit"},[_c('h2',[_vm._v("惠州市海洋与渔业项目系统")]),_vm._v(" "),_c('b',[_vm._v("建设单位：惠州市海洋与渔业局 ")]),_vm._v(" "),_c('b',[_vm._v("项目类型：软件开发 ")]),_vm._v(" "),_c('b',[_vm._v("所属行业：服务事业单位")]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"tab-contents"},[_c('div',{staticClass:"t-c-left"},[_c('b',[_vm._v("项目概况：")]),_c('p',[_vm._v("通过计算机技术和海洋渔业管理的具体业务结合，建立标准化的数字信息收集、处理、网络传输、信息可视化、信息输入输出的软硬件技术平台--海洋\n\t\t\t\t\t\t\t\t与渔业信息管理系统；提供了从应用、优化到门户展现全方位的图形化流程信息，通过个性化授权，可以将常用的流程推送到个人门户便于调用，进一步加强海洋渔业局业\n\t\t\t\t\t\t\t\t务管理的信息化、办公效率化。\n\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('b',[_vm._v("建设内容：")]),_c('p',[_vm._v("本系统主要功能模块包括：1、网上注册、2、项目申报，3、项目实施管理与监控、4、合同管理、5、验收管理、6、归档等。")])]),_vm._v(" "),_c('div',{staticClass:"t-c-right"},[_c('img',{attrs:{"src":__webpack_require__("8wZ0")}}),_vm._v(" "),_c('p',[_vm._v("惠州市海洋与渔业项目系统图示")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"casetab"},[_c('div',{staticClass:"tab-tit"},[_c('h2',[_vm._v("大亚湾管委会政务中心网上综合办事系统建设项目")]),_vm._v(" "),_c('b',[_vm._v("建设单位：惠州大亚湾经济技术开发区管理委员会办公室 ")]),_vm._v(" "),_c('b',[_vm._v("项目类型：软件开发 ")]),_vm._v(" "),_c('b',[_vm._v("所属行业：服务事业单位")]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"tab-contents"},[_c('div',{staticClass:"t-c-left"},[_c('b',[_vm._v("项目概况：")]),_c('p',[_vm._v("大亚湾区政务服务中心为贯彻落实区委区政务对“实体大厅”、“虚拟大厅”、“监察大厅”有机结合实现三网合一的建设要求，进一步简\n\t\t\t\t\t\t\t\t\t\t化办事环节，优化办事程序，做到办事服务全面覆盖、办事过程透明规范、办事效率显著提高、监督机制健全有效。加快推进大亚湾区电子政务领域改革、创新\n\t\t\t\t\t\t\t\t\t\t电子政务运维模式，加快转型升级、提高综合竞争力、建设幸福大亚湾。\n\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('b',[_vm._v("建设内容：")]),_c('p',[_vm._v("大亚湾区政务服务中心综合业务管理系统的建设，通过对各业务系统与软硬件设备的对接与整合，集中统一解决诸多无业务处理系统的部门办理\n\t\t\t\t\t\t\t\t\t\t业务的需求，打破多业务平台的界限，对当前服务中心的多种软硬件管理系统提供统一管理平台。")])]),_vm._v(" "),_c('div',{staticClass:"t-c-right"},[_c('img',{attrs:{"src":__webpack_require__("CVZP")}}),_vm._v(" "),_c('p',[_vm._v("大亚湾管委会政务中心网上综合办事系统图示")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"casetab"},[_c('div',{staticClass:"tab-tit"},[_c('h2',[_vm._v("罗浮山健康生态城项目")]),_vm._v(" "),_c('b',[_vm._v("建设单位：惠州宝能泰丰置业有限公司 ")]),_vm._v(" "),_c('b',[_vm._v("项目类型：弱电智能化、系统集成 ")]),_vm._v(" "),_c('b',[_vm._v("所属行业：房地产")]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"tab-contents"},[_c('div',{staticClass:"t-c-left"},[_c('b',[_vm._v("项目概况：")]),_c('p',[_vm._v("罗浮山健康生态城规划建筑面积约30万平方米，包括文化体验、滨水风情、田园养生、商务休闲等四大特色主题区，并涵盖健康、旅游、度假、养生、休闲、娱\n\t\t\t\t\t\t\t\t\t\t乐、商务、居住和文化体验等多种功能和业态组合。本项目为罗浮山健康生态城二区CA01栋智能化工程，位于惠州市博罗县长宁镇澜石村委会长澜公路边红花坑。\n\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('b',[_vm._v("建设内容：")]),_c('p',[_vm._v("1、视频监控系统；2、门禁系统；3、停车场管理系统；4、电子巡更系统；5、五方通话系统；6、BA系统。")])]),_vm._v(" "),_c('div',{staticClass:"t-c-right"},[_c('img',{attrs:{"src":__webpack_require__("gkch")}}),_vm._v(" "),_c('p',[_vm._v("罗浮山健康生态城图示")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"casetab"},[_c('div',{staticClass:"tab-tit"},[_c('h2',[_vm._v("阳江国际五金刀剪商贸中心弱电智能化系统工程")]),_vm._v(" "),_c('b',[_vm._v("建设单位：阳江市丰泰投资股份有限公司 ")]),_vm._v(" "),_c('b',[_vm._v("项目类型：弱电智能化、系统集成 ")]),_vm._v(" "),_c('b',[_vm._v("所属行业：商业")])]),_vm._v(" "),_c('div',{staticClass:"tab-contents"},[_c('div',{staticClass:"t-c-left"},[_c('b',[_vm._v("项目概况：")]),_c('p',[_vm._v("阳江国际五金刀剪商贸城位于阳江市中央商贸区核心地段，总建筑面积75183.2㎡，其中地上63235.44㎡，地下11947.76㎡；建筑物\n\t\t\t\t\t\t\t\t\t\t栋数为3栋，分别为1#楼地上5层，建筑高度23.4㎡；2#楼地上5层，地下1层，建筑高度23.4米，3#楼地上15层，地下1层，建筑高度为67.9米。\n\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('b',[_vm._v("建设内容：")]),_c('p',[_vm._v("工程包括以下八个系统：1、综合布线系统；2、监控系统；3、广播系统；4、停车场系统；5、网络设备；6、有线电视；7、程控电话；8、机房建设。")])]),_vm._v(" "),_c('div',{staticClass:"t-c-right"},[_c('img',{attrs:{"src":__webpack_require__("tkYC")}}),_vm._v(" "),_c('p',[_vm._v("阳江国际五金刀剪商贸中心弱电智能化系统工程图示")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"casetab"},[_c('div',{staticClass:"tab-tit"},[_c('h2',[_vm._v("惠城区人民法院数字化庭审项目")]),_vm._v(" "),_c('b',[_vm._v("建设单位：惠州市惠城区人民法院")]),_vm._v(" "),_c('b',[_vm._v("项目类型：弱电智能化、系统集成、软件开发 ")]),_vm._v(" "),_c('b',[_vm._v("所属行业：政府 ")]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"tab-contents"},[_c('div',{staticClass:"t-c-left"},[_c('b',[_vm._v("项目概况：")]),_c('p',[_vm._v("惠州市惠城区人民法院积极采用数字法庭、智能化审判等新技术，以建设智慧法院为目标，是法院工作与时俱进、司法为民的体现。\n\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('b',[_vm._v("建设内容：")]),_c('p',[_vm._v("1、数字庭审系统；2、视频监控系统；3、审判智能辅助系统；4、智能语音识别系统；5、法院内勤管理系统。")])]),_vm._v(" "),_c('div',{staticClass:"t-c-right"},[_c('img',{attrs:{"src":__webpack_require__("fJPC")}}),_vm._v(" "),_c('p',[_vm._v("惠城区人民法院数字化庭审项目图示")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"casetab"},[_c('div',{staticClass:"tab-tit"},[_c('h2',[_vm._v("云南保山市110联网报警服务系统")]),_vm._v(" "),_c('b',[_vm._v("建设单位：保山市公安局")]),_vm._v(" "),_c('b',[_vm._v("项目类型：弱电智能化、安防 ")]),_vm._v(" "),_c('b',[_vm._v("所属行业：政府")]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"tab-contents"},[_c('div',{staticClass:"t-c-left"},[_c('b',[_vm._v("项目概况：")]),_c('p',[_vm._v("110视频联网报警服务平台通过互联网、通信网络平台、云平台等先进信息技术的支持，为广大群众提供了一种快速， 高效\n\t\t\t\t\t\t\t\t\t\t的报警方式。警务人员通过综合服务平台实时监控报警情况，做到实时收取信息，及时做出响应。\n\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('b',[_vm._v("建设内容：")]),_c('p',[_vm._v("1、银行；2、商铺；3、企业；4、家庭。")])]),_vm._v(" "),_c('div',{staticClass:"t-c-right"},[_c('img',{attrs:{"src":__webpack_require__("oReE")}}),_vm._v(" "),_c('p',[_vm._v("云南保山市110联网报警服务系统图示")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"casetab"},[_c('div',{staticClass:"tab-tit"},[_c('h2',[_vm._v("惠州市公安局视频会议系统与会议室LED屏项目")]),_vm._v(" "),_c('b',[_vm._v("建设单位：惠州市公安局")]),_vm._v(" "),_c('b',[_vm._v("项目类型：弱电智能化、系统集成 ")]),_vm._v(" "),_c('b',[_vm._v("所属行业：政府 ")]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"tab-contents"},[_c('div',{staticClass:"t-c-left"},[_c('b',[_vm._v("项目概况：")]),_c('p',[_vm._v("为了进一步加快推进惠州市公安局数字信息化建设步伐，更好的加强惠州市公安局的会议交流，提高会议质量，配合好惠州市公安局的相关工作，建设\n\t\t\t\t\t\t\t\t\t\t一套先进实用的智能化会议系统。\n\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('b',[_vm._v("建设内容：")]),_c('p',[_vm._v("1、数字会议系统；2、音响系统；3、中控矩阵系统；4、LED大屏及投影显示系统。")])]),_vm._v(" "),_c('div',{staticClass:"t-c-right"},[_c('img',{attrs:{"src":__webpack_require__("i3ah")}}),_vm._v(" "),_c('p',[_vm._v("惠州市公安局视频会议系统与会议室LED屏项目图示")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"casetab"},[_c('div',{staticClass:"tab-tit"},[_c('h2',[_vm._v("惠州市西湖5A综合管理系统")]),_vm._v(" "),_c('b',[_vm._v("建设单位：惠州市园林局    ")]),_vm._v(" "),_c('b',[_vm._v("项目类型：软件开发     ")]),_vm._v(" "),_c('b',[_vm._v("所属行业：旅游     ")]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"tab-contents"},[_c('div',{staticClass:"t-c-left"},[_c('b',[_vm._v("项目概况：")]),_c('p',[_vm._v("惠州市西湖风景名胜区数字化景区项目建设是以国家AAAAA级景区标准建设为目标，紧跟全国智慧景区发展的趋\n\t\t\t\t\t\t\t\t势，打造一个AAAAA级标准的数字化智慧旅游景区。智慧景区是指通过数据网络、物联网、GIS等数字化技术对景区人文环境、自然\n\t\t\t\t\t\t\t\t资源、旅游者行为、景区工作人员行迹、景区基础设施和服务设施进行全面、及时的感知；通过景区业务系统优化景区业务流程以\n\t\t\t\t\t\t\t\t实现智能化运营管理；协调处理好游客需求与自然环境及历史遗产资源的保护的矛盾，提升对旅游者的服务质量，最终实现景区环\n\t\t\t\t\t\t\t\t境、社会和经济的全面、协调和可持续发展。\n\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('b',[_vm._v("建设内容：")]),_c('p',[_vm._v("①景区门户网站PC版，②手机WAP官网，③数字导游APP，④微博微信公众号，⑤业务办公系统，⑥人流统计系\n\t\t\t\t\t\t\t\t统、环境监测、森林防火、统一指挥平台等；")])]),_vm._v(" "),_c('div',{staticClass:"t-c-right"},[_c('img',{attrs:{"src":__webpack_require__("NTPD")}}),_vm._v(" "),_c('p',[_vm._v("惠州市西湖5A综合管理系统图示")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"casetab"},[_c('div',{staticClass:"tab-tit"},[_c('h2',[_vm._v("惠州报业传媒集团数据平台建设项目")]),_vm._v(" "),_c('b',[_vm._v("建设单位：惠州报业传媒集团 ")]),_vm._v(" "),_c('b',[_vm._v("项目类型：系统集成 ")]),_vm._v(" "),_c('b',[_vm._v("所属行业：企业")]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"tab-contents"},[_c('div',{staticClass:"t-c-left"},[_c('b',[_vm._v("项目概况：")]),_c('p',[_vm._v("惠州报业传媒集团于2007年9月26日正式挂牌成立。这是继广日南方、羊城、深圳、佛山、中山之后，广东成立的第七家报\n\t\t\t\t\t\t\t\t业集团。项目为惠州报业传媒集团数据中心打造核心数据集中存储、服务器虚拟化、存储级容灾等一体化整合方案，完成了应用系统服务器虚\n\t\t\t\t\t\t\t\t拟化，在惠州报业传媒集团新大楼机房内网中部署建设应用系统服务器虚拟化平台，并将惠州报业传媒集团的网站（含今日惠州网）及应用、视\n\t\t\t\t\t\t\t\t频直播点播系统、DNS服务器、采编系统、广告系统、财务系统、工分系统、资料管理系统等目前在线应用服务器平稳迁移到平台中。\n\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('b',[_vm._v("建设内容：")]),_c('p',[_vm._v("1、数据、存储平台；2、虚拟化系统；3、直播系统")])]),_vm._v(" "),_c('div',{staticClass:"t-c-right"},[_c('img',{attrs:{"src":__webpack_require__("XWwE")}}),_vm._v(" "),_c('p',[_vm._v("惠州报业传媒集团数据平台建设图示")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"casetab"},[_c('div',{staticClass:"tab-tit"},[_c('h2',[_vm._v("律师事务所业务综合管理系统")]),_vm._v(" "),_c('b',[_vm._v("建设单位：惠州市惟城管理咨询有限公司 ")]),_vm._v(" "),_c('b',[_vm._v("项目类型：软件开发 ")]),_vm._v(" "),_c('b',[_vm._v("所属行业：律师")]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"tab-contents"},[_c('div',{staticClass:"t-c-left"},[_c('b',[_vm._v("项目概况：")]),_c('p',[_vm._v("惟城综合客户管理系统（简称“惟城CRM”）是针对惟城管理咨询有限公司的相关业务（比如免费咨询业务、法律服务业务等）和\n\t\t\t\t\t\t\t\t客户关系进行定制的系统。旨在帮助用户集中管理法律业务、客户服务团队和客户之间的所有联系，有效帮助从客户到法律业务跟进到法律业务分析\n\t\t\t\t\t\t\t\t的全流程、精细化管理，有效缩短法律业务的管理周期；基于网络、通讯、计算机等信息技术，能实现不同职能部门的无缝连接，能够协助管理者更好\n\t\t\t\t\t\t\t\t地完成客户关系的两项基本任务：识别和保持有价值的客户。\n\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('b',[_vm._v("建设内容：")]),_c('p',[_vm._v("本系统实现PC端与微信端应用一体化的管理，主要模块包括①客户管理、②诉讼业务管理、③非诉讼业务管理、④常年法律顾问业务\n\t\t\t\t\t\t\t\t管理、⑤免费咨询业务管理、⑥个人事务管理、⑦数据分析中心管理。")])]),_vm._v(" "),_c('div',{staticClass:"t-c-right"},[_c('img',{attrs:{"src":__webpack_require__("kuap")}}),_vm._v(" "),_c('p',[_vm._v("律师事务所业务综合管理系统图示")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"casetab"},[_c('div',{staticClass:"tab-tit"},[_c('h2',[_vm._v("惠州市商贸旅游高级职业技术学校新校区安防监控与数据平台")]),_vm._v(" "),_c('b',[_vm._v("建设单位：惠州市商贸旅游高级职业技术学校 ")]),_vm._v(" "),_c('b',[_vm._v("项目类型：弱电智能化、系统集成 ")]),_vm._v(" "),_c('b',[_vm._v("所属行业：教育")]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"tab-contents"},[_c('div',{staticClass:"t-c-left"},[_c('b',[_vm._v("项目概况：")]),_c('p',[_vm._v("惠州市商贸旅游高级职业技术学校新校区位于惠州市福长岭，占地约300000平方米，整个学校分为东西两区，其中东区包\n\t\t\t\t\t\t\t\t括：图书行政楼、四栋教学大楼、综合实训楼、五栋学生宿舍、1号饭堂、教工宿舍与培训楼、风雨操场、足球场。西区包括：足球场、实训\n\t\t\t\t\t\t\t\t工厂、数控1号楼、数控2号楼，服装教学楼、汽车教学楼、2号饭堂、信息技术楼及四栋学生宿舍。\n\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('b',[_vm._v("建设内容：")]),_c('p',[_vm._v("1、视频监控系统；2、安防报警系统；3、网络与数据平台。")])]),_vm._v(" "),_c('div',{staticClass:"t-c-right"},[_c('img',{attrs:{"src":__webpack_require__("vzo0")}}),_vm._v(" "),_c('p',[_vm._v("惠州市商贸旅游高级职业技术学校新校区安防监控与数据平台图示")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"casetab"},[_c('div',{staticClass:"tab-tit"},[_c('h2',[_vm._v("湘西自治州人民医院安防监控项目")]),_vm._v(" "),_c('b',[_vm._v("建设单位：湘西自治州人民医院 ")]),_vm._v(" "),_c('b',[_vm._v("项目类型：弱电智能化、系统集成 ")]),_vm._v(" "),_c('b',[_vm._v("所属行业：医疗")]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"tab-contents"},[_c('div',{staticClass:"t-c-left"},[_c('b',[_vm._v("项目概况：")]),_c('p',[_vm._v("湘西州人民医院总规划用地面积334136㎡，其中A区用地面积136980㎡，B区用地面积197156㎡，机房位置在住院部大楼的第一层\n\t\t\t\t\t\t\t\t\t\t，面积约80㎡，本项目建设全院的视频监控与安全防范系统、数据中心机房。\n\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('b',[_vm._v("建设内容：")]),_c('p',[_vm._v("1、数据机房；2、视频监控与安防系统；3、一卡通与电子巡更系统。")])]),_vm._v(" "),_c('div',{staticClass:"t-c-right"},[_c('img',{attrs:{"src":__webpack_require__("s8jS")}}),_vm._v(" "),_c('p',[_vm._v("湘西自治州人民医院安防监控图示")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2BQd":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/p7-1.423880e.jpg";

/***/ }),

/***/ "2IqB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_solve_vue__ = __webpack_require__("FsQa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_352b38d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_solve_vue__ = __webpack_require__("8sFS");
function injectStyle (ssrContext) {
  __webpack_require__("tjEH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_solve_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_352b38d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_solve_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2W7X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"techonlogy"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"tech-detail"},[_c('div',{staticClass:"tech-top-top"},[_c('h4',[_vm._v(_vm._s(_vm.tech[_vm.chalid].title))]),_vm._v(" "),_c('div',{staticClass:"tech-line"})]),_vm._v(" "),(_vm.chalid == 0 )?_c('div',{staticClass:"techinfo"},[_c('p',{staticClass:"com-content"},[_vm._v(" 公司服务领域分为三大块：")]),_vm._v(" "),_c('div',{staticClass:"tech-singleimg"},[_c('img',{attrs:{"src":_vm.techimg[0].imgsrc}})]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.techimg[0].smalltit))]),_vm._v(" "),_c('p',[_vm._v("系统集成（SI，System Integration），我们在系统工程科学方法的指导下，经过专业技术的不断进步和多年施 工经验的积累，能为您提供智能弱电系统\n\t\t\t\t\t\t集成、网络安全系统集成、数据中心与云平台等三大项目和20个子系统的专业服务。\n\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"tech-singleimg"},[_c('img',{attrs:{"src":_vm.techimg[1].imgsrc}})]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.techimg[1].smalltit))]),_vm._v(" "),_c('p',[_vm._v("软件与数据服务（Software and data services），思程科技是以自主知识产权产品开发为核心的双软企业，我公司采用了CMMI管理模式体系以及国际上先进、成熟的开发工具和语言，开发了许多满足客户实际需求的应用软件。\n\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"tech-singleimg"},[_c('img',{attrs:{"src":_vm.techimg[2].imgsrc}})]),_vm._v(" "),_c('p',[_vm._v("软件（SAAS）即服务是行业的发展趋势，提供应用类的软件服务是公司的发展方向，公司以软件开发为基础，向用户提供全方向的信息化业务方案\n\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"tech-singleimg"},[_c('img',{attrs:{"src":_vm.techimg[3].imgsrc}})]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.techimg[2].smalltit))]),_vm._v(" "),_c('p',[_vm._v("IT运维服务 (IT operation and maintenance services) ，思程科技以专业的技术力量和运维团队为客户提 供IT领域全面的咨询、实施、运维、迁移、培训五大类服务。\n\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"tech-singleimg"},[_c('img',{attrs:{"src":_vm.techimg[4].imgsrc}})])]):_vm._e(),_vm._v(" "),(_vm.chalid == 1 )?_c('div',{staticClass:"techinfo"},[_c('p',{staticClass:"com-content"},[_vm._v(" 公司以信息化技术为基础，深入行业需求，服务于各行业，以提供相关行业的信息化解决方案为整体方向，以项目建设、产品开发、项目运营等形式拓展业务。")]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.yewu[0].smalltit))]),_vm._v(" "),_c('p',[_vm._v("由专业的信息化项目经理落实项目建设，全程项目监管勘查、设计、施工、维护")]),_vm._v(" "),_c('div',{staticClass:"tech-singleimg"},[_c('img',{staticStyle:{"width":"35%"},attrs:{"src":_vm.yewu[0].imgsrc}})]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.yewu[1].smalltit))]),_vm._v(" "),_c('p',[_vm._v("以市场需求为导向，结合相关的行业经验，公司不断推进产品开发工作，以优质产品赢取市场。\n\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"tech-singleimg"},[_c('img',{attrs:{"src":_vm.yewu[1].imgsrc}})]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.yewu[2].smalltit))]),_vm._v(" "),_c('p',[_vm._v("根据用户的业务需求，发挥公司的技术优势与资本能力，承担相关的信息化建设并负责具体运营，达到共赢的目的。\n\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"tech-singleimg"},[_c('img',{staticStyle:{"width":"36%"},attrs:{"src":_vm.yewu[2].imgsrc}})])]):_vm._e(),_vm._v(" "),(_vm.chalid == 2 )?_c('div',{staticClass:"techinfo"},[_c('p',{staticClass:"com-content"},[_vm._v(" 公司主要涉及的技术领域有（1）弱电+网络通讯（2）数据与安全（3）云技术（4）物联网（5）应用软件")]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.jishu[0].smalltit))]),_vm._v(" "),_c('div',{staticClass:"tech-singleimg"},[_c('img',{staticStyle:{"width":"45%"},attrs:{"src":_vm.jishu[0].imgsrc}})]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.jishu[1].smalltit))]),_vm._v(" "),_c('div',{staticClass:"tech-singleimg"},[_c('img',{staticStyle:{"width":"60%"},attrs:{"src":_vm.jishu[1].imgsrc}})]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.jishu[2].smalltit))]),_vm._v(" "),_c('div',{staticClass:"tech-singleimg"},[_c('img',{staticStyle:{"width":"60%"},attrs:{"src":_vm.jishu[2].imgsrc}})]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.jishu[3].smalltit))]),_vm._v(" "),_c('p',{staticClass:"com-content"},[_vm._v(" 顾名思义，物联网就是物物相连的互联网。这有两层意思：其一，物联网的核心和基础仍然是互联网，是在互\n\t\t\t\t\t联网基础上的延伸和扩展的网络；其二，其用户端延伸和扩展到了任何物品与物品之间，进行信息交换和通信，也就\n\t\t\t\t\t是物物相息。物联网通过智能感知、识别技术与普适计算等通信感知技术，广泛应用于网络的融合中，也因此被称\n\t\t\t\t\t为继计算机、互联网之后世界信息产业发展的第三次浪潮。物联网是互联网的应用拓展，与其说物联网是网络，不\n\t\t\t\t\t如说物联网是业务和应用。因此，应用创新是物联网发展的核心，以用户体验为核心的创新2.0是物联网发展的灵魂。\n\t\t\t\t\t")]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.jishu[4].smalltit))]),_vm._v(" "),_c('p',{staticClass:"com-content"},[_vm._v(" 应用软件开发，思程科技是以自主知识产权产品开发为核心的双软企业，我司采用了CMMI管理模式体系\n\t\t\t\t\t以上国际上先进、成熟的开发工具和语言，开发了许多满足客户实际需求的应用软件，应用于政府、民政、医疗、金融等各行业，用户反应良好。\n\t\t\t\t\t")]),_vm._v(" "),_c('p',{staticClass:"com-content"},[_vm._v(" 思程科技的软件研发团队是由一批技术能力强、项目经验丰富的软件人才组成，具有多元化的技术路线，涵盖各主流开发\n\t\t\t\t\t\t语言，在.net和JAVA方面都有着丰富的项目和产品开发经验\n\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"tech-singleimg"},[_c('img',{attrs:{"src":_vm.jishu[4].imgsrc}})])]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"techonlogy-top"},[_c('img',{attrs:{"src":"/static/img/fuwu.jpg"}}),_vm._v(" "),_c('div',{staticClass:"bannerMask"},[_c('div')]),_vm._v(" "),_c('div',{staticClass:"com-tit"},[_c('span',[_c('img',{attrs:{"src":"/static/img/fuwuicon.png"}}),_c('b',[_vm._v("业务中心")])]),_vm._v(" "),_c('p',[_vm._v("致力于为政府、学校、医疗、公共事业、生产企业等各行业提"),_c('br'),_vm._v("\n供专业的信息化服务")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2gso":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/banner_03.3c5a67b.jpg";

/***/ }),

/***/ "4hjF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wenhua.7ac6232.png";

/***/ }),

/***/ "4kaR":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fuwu-tudi.ace2f88.jpg";

/***/ }),

/***/ "4oXx":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/p1-1.640fd8a.jpg";

/***/ }),

/***/ "4tCc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aboutcom"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"com-detail"},[_c('div',{staticClass:"com-top-top"},[_c('h4',[_vm._v(_vm._s(_vm.center[_vm.chalid].title))]),_vm._v(" "),_c('div',{staticClass:"com-line"})]),_vm._v(" "),_c('transition',{attrs:{"name":"zhaopin-fade"}},[(_vm.chalid == 0 )?_c('div',{staticClass:"cominfo"},[_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.center[_vm.chalid].smalltit))]),_vm._v(" "),_c('p',{staticClass:"com-content"},[_c('b',[_vm._v("广东思程科技有限公司")]),_vm._v("是一家专业的IT解决方案服务商。主要从事于计算机系统集成、软件与数据服务、IT运维服务等业务，服务于政府、学校、医疗、生产企业等行业。")]),_vm._v(" "),_c('p',[_vm._v("公司历经市场的考验，始终坚持紧跟时代步伐，积极引进、培养人才，经过十多年的耕耘，公司已拥有了一支成熟的专业技术队伍，能为用户提供全面\n\t\t\t\t\t的IT技术解决方案，能满足大型的信息化系统集成项目的管理与服务要求。此外，公司积极投入自主创新 研发，针对不同行业，推出了具有自己特色的解决\n\t\t\t\t\t方案。 \n\t\t\t\t\t")]),_vm._v(" "),_c('p',[_vm._v("未来我们将一如既往的关注客户的需求，专注于技术创新，以为客户提供专业的技术服务为目标，使客户得到最大的效益，我们真诚期待与广大客户精\n\t\t\t\t\t诚合作，共创辉煌！\n\t\t\t\t\t")]),_vm._v(" "),_vm._l((_vm.comimg),function(im){return _c('div',{staticClass:"imgcomab"},[_c('img',{attrs:{"src":im.imgsrc}})])})],2):_vm._e(),_vm._v(" "),(_vm.chalid == 1 )?_c('div',{staticClass:"cominfo"},[_c('p',{staticClass:"com-content"},[_vm._v(" 一直以来，广东思程科技都注重人才的管理和培养，努力建立一流的团队和学习型组织，充分挖掘每一个成员的潜力，让员工在工作中实现自我价值，我们最宝贵的财富是我们的员工。")]),_vm._v(" "),_c('div',{staticClass:"singleimg"},[_c('img',{attrs:{"src":"/static/img/frame.jpg"}})])]):_vm._e(),_vm._v(" "),(_vm.chalid == 2 )?_c('div',{staticClass:"cominfo"},[_c('div',{staticClass:"singlewimg"},[_c('img',{attrs:{"src":"/static/img/wenhua.png"}})]),_vm._v(" "),_c('div',{staticClass:"comwenhua"},_vm._l((_vm.wenhua),function(wcom){return _c('div',{staticClass:"wencom"},[_c('h3',[_vm._v(_vm._s(wcom.wentit))]),_vm._v(" "),_c('p',[_c('span',{staticClass:"glyphicon glyphicon-triangle-right"}),_vm._v("   "+_vm._s(wcom.wencontent))])])}),0)]):_vm._e(),_vm._v(" "),(_vm.chalid == 3 )?_c('div',{staticClass:"cominfo"},[_c('p',{staticClass:"com-content"},[_vm._v("惠州市德通科技有限公司成立于2004年，2012年公司变更冠名为广东思程科技有限公司，逐步发展成为了专业的信息化服务企业。")]),_vm._v(" "),_vm._l((_vm.honor),function(item){return _c('div',{staticClass:"certificate"},[_c('div',{staticClass:"pic",style:({'background-image': 'url('+  item.hoimg +')'})}),_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(item.honame)+"\n\t\t\t\t\t")])])})],2):_vm._e()])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comtop"},[_c('img',{attrs:{"src":"/static/img/aboutcom.jpg"}}),_vm._v(" "),_c('div',{staticClass:"bannerMask"},[_c('div')]),_vm._v(" "),_c('div',{staticClass:"com-titr"},[_c('span',[_c('img',{attrs:{"src":"/static/img/abouticon.png"}}),_c('b',[_vm._v("关于我们")])]),_vm._v(" "),_c('p',[_vm._v("专业的IT解决方案服务商。主要从事于计算机系统集成、软件开发、IT运"),_c('br'),_vm._v("维服务等业务，服务于 政府、学校、医疗、生产企业等行业。")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4zYS":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/banner_01.1a5b068.jpg";

/***/ }),

/***/ "5dzJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6G03":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zhly01.38b2423.png";

/***/ }),

/***/ "6ce3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/banner_02.5a9fb70.jpg";

/***/ }),

/***/ "73Ta":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/p3-3.b72777f.jpg";

/***/ }),

/***/ "7Ju0":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3FpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo4ZDQwMDdiOS01Y2E2LTE3NDctOWFkZS1mNWU4N2I4MmFjMmUiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MTNGMjM5QTY5OTJDMTFFNzk4MEFFNTY2REM5QTdERDciIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MTNGMjM5QTU5OTJDMTFFNzk4MEFFNTY2REM5QTdERDciIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjhkNDAwN2I5LTVjYTYtMTc0Ny05YWRlLWY1ZTg3YjgyYWMyZSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo4ZDQwMDdiOS01Y2E2LTE3NDctOWFkZS1mNWU4N2I4MmFjMmUiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz62+rcVAAACcklEQVR42pyV225SQRSGf/YGSgvUIgEq0KpIaNULtdoLT+9QYzXxMfSijS9g1F7ohb6DST1UvfEBPNx4oCaKJT0IglQLLbhhFygF14yzGzZOQ3SRLxnWzPysWbNmYXnw4g0kZicmBKeJIFEnMsQH4gnxVPhMZpWIXSBuE1HJj4wKrhCLxDTxuH2R0jZWiVtiQRTdja15JPaosghvEFP4dzP2TLdHOPmfYu2ik0aELDd3ZKs8/U4cPhiEd8BF3ywoahUklr8jX9Rky+8Sz1iEl4iwTOzs8RhsNivmk2nEF1JotYAz5PN53DLBEHFZEaVhMlVVeGR6tYZX8STSuQK+rRbwmsbrJQ1HDoVhtaoy0QkmON7pdTp6eIRLmZ9oNLZ3/E0KcSWbx4CrD+4+h0zwFBMc7PS22Ic2Kxblrx2KYuHCbF5i+xRZtVf0GtY2NESH/HDYbTt+Gx0zEvbTscvQKlXpdbNbzhGmLLMIPi1lcO7ECM6PjfAcMt/woBd2uqSXiSS2m02ZXo4JfiRinTOOHjvYoVyUq+hwgN+w3aaittXgUWuVTZngWyY4ZxSlYeHAXowfjWA1X0T8Swqlss79bmcvIiEfRR7jZbSSXesUnGOCs8RNoxb7Xb0YGz2AVC6P94mvptUFKmiGXq3jWGw/flGUhWLZmM4yLeNSrhneSMiPan0L8wvpXd/Z5+UMfzXRIVOBXCVqRl2wKGfYIOjzIPNjfbek/ykryicr9IB3j+GaERqm9nWduFferKJQKnftBhuazqMkuy/2crNIOvZFkdNuPXFRCD3s1rFZ03wumgbr3ifFwzcS/078BczKHsVvAQYAvLrZA1RjVE8AAAAASUVORK5CYII="

/***/ }),

/***/ "7mG0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'techonlogy',
	data: function data() {
		return {
			tech: [{ id: 0, imgsrc: '/static/img/fuwu.jpg', title: '服务领域' }, { id: 1, imgsrc: '/static/img/fuwu.jpg', title: '业务模式' }, { id: 2, imgsrc: '/static/img/fuwu.jpg', title: '技术领域' }],
			techimg: [{ id: 0, imgsrc: '/static/img/serve1 (1).png', smalltit: '系统集成' }, { id: 1, imgsrc: '/static/img/11serve1 (1).png', smalltit: '软件与数据服务' }, { id: 2, imgsrc: '/static/img/sc-soft-img2.png', smalltit: 'IT运维服务' }, { id: 3, imgsrc: '/static/img/serve1 (2).png', smalltit: '' }, { id: 4, imgsrc: '/static/img/serve1 (3).png', smalltit: '' }],
			yewu: [{ id: 0, imgsrc: '/static/img/yewumodx.png', smalltit: '项目建设' }, { id: 1, imgsrc: '/static/img/yewumodp.png', smalltit: '产品开发' }, { id: 2, imgsrc: '/static/img/yewumodz.png', smalltit: '项目合作运营' }],
			jishu: [{ id: 0, imgsrc: '/static/img/jsly.png', smalltit: '弱电+网络通讯' }, { id: 1, imgsrc: '/static/img/jsly2.png', smalltit: '数据与安全' }, { id: 2, imgsrc: '/static/img/jsly3.png', smalltit: '云技术' }, { id: 3, imgsrc: '/static/img/yewumodz.png', smalltit: '物联网' }, { id: 4, imgsrc: '/static/img/jsly4.png', smalltit: '应用软件' }],
			chalid: 0

		};
	},
	mounted: function mounted() {
		this.getID();
	},

	methods: {
		getID: function getID() {
			this.chalid = this.$route.params.ID;
		}
	}
});

/***/ }),

/***/ "8P+n":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/hjjc01.993ac59.png";

/***/ }),

/***/ "8sFS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"solve"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"case-nav"}),_vm._v(" "),_c('div',{staticClass:"sol-detail"},[_c('div',{staticClass:"sol-top-top"},[_c('ul',_vm._l((_vm.navli),function(navli){return _c('li',{staticClass:"casenav",class:{caseacli : _vm.chalid == navli.id},on:{"click":function($event){return _vm.seltab(navli.id)}}},[_vm._v(_vm._s(navli.litit))])}),0)]),_vm._v(" "),(_vm.chalid == 0 )?_c('div',{staticClass:"solinfo"},[_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.sol[_vm.chalid].smalltit))]),_vm._v(" "),_c('p',{staticClass:"com-content"},[_vm._v("   新零售，即企业以互联网为依托，通过运用大数据、人工智能等先进技术手段，对商品的生产、流通与销售过程进行升级改造，进而重塑业态结构与生态圈，并对线上服务、线下体验以及现代物流进行深度融合的零售新模式。")]),_vm._v(" "),_c('p',{staticClass:"com-content"},[_vm._v("   新零售系统采用线上线下互通理念，线上平台为消费者提供消费指南、优惠信息、便利服务（预订、在线支付、地图等）和分享平台，而线下门店则专注于提供商品展示/体验、下单、提货等服务。线上线下一体化可以充分实现品牌传播、流量的存与增、信息互通、资源互动，可以更大程度的提升竞争力，更好的服务用户。根据新零售系统销在消费者下单购买后，可以快速送达消费者手中。不但发货速度快、产品质量有保障，还提供线下门店体验及退换货售后服务，彻底解决了海淘带来的弊病。\t")]),_vm._v(" "),_c('p',{staticClass:"com-content"},[_vm._v("   新零售系统将新零售总结为“线上+线下+物流，其核心是以消费者为中心的会员、支付、库存、服务等方面数据的全面打通。 ")]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.xls[0].smalltit))]),_vm._v(" "),_c('center',[_c('img',{attrs:{"src":"/static/img/xls2.png"}})]),_vm._v(" "),_c('p',{staticStyle:{"color":"#C9302C"}},[_vm._v("1、精细化解决零售运营难题")]),_vm._v(" "),_c('p',[_vm._v("打破空间局限，提高门店坪效: 以门店为服务圆点，融合线上，构建立体服务网络线上线下互补营运，打造最佳消费者体验。")]),_vm._v(" "),_c('p',[_vm._v("告别混乱管理，打通进销存: 打通线上线下多渠道销售实时洞悉准确库存缺货自动提醒，采购补货一键完成，销售端库存自动更新。")]),_vm._v(" "),_c('p',[_vm._v("用数据驱动门店管理: 实时掌握门店业绩走势监控业绩达成、客单价、退货率等经营指标")]),_vm._v(" "),_c('p',{staticStyle:{"color":"#C9302C"}},[_vm._v("2、沉淀数据，高效管理会员")]),_vm._v(" "),_c('p',[_vm._v("全方位采集消费者数据: 充分利用线下门店流量，将到店顾客转化为线上会员。")]),_vm._v(" "),_c('p',[_vm._v("线上线下一套会员数据: 无障碍识别会员身份，打通会员、积分、资产、全渠道会员管理。")]),_vm._v(" "),_c('p',[_vm._v("精细化管理会员: 社交化会员管理系统、会员卡、积分体系，会员标签、购买力筛选，数据指导二次营销")]),_vm._v(" "),_c('p',{staticStyle:{"color":"#C9302C"}},[_vm._v("3、快速搭建全渠道零售体系")]),_vm._v(" "),_c('p',[_vm._v("为客户输出整体方案: 用一套方案搭建全渠道零售体系拒绝多个业务系统相互割裂而造成的“信息孤岛”。")]),_vm._v(" "),_c('p',[_vm._v("省去多套系统购买、对接成本: 大幅降低使用多套系统的购买成本、对接成本以及与供应商的沟通成本。")]),_vm._v(" "),_c('p',[_vm._v("兼容加盟、直营两套体系: 区域价格管理，自动结算平台统一管控营销策略，灵活设定营销政策。")]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.xls[1].smalltit))]),_vm._v(" "),_c('p',[_vm._v("面向线下实体门店，满足零售店铺线上线下协同运营的诉求")]),_vm._v(" "),_c('center',[_c('img',{staticStyle:{"margin-top":"30px"},attrs:{"src":"/static/img/xls.png"}})])],1):_vm._e(),_vm._v(" "),(_vm.chalid == 1 )?_c('div',{staticClass:"solinfo"},[_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.sol[_vm.chalid].smalltit))]),_vm._v(" "),_c('p',{staticClass:"com-content"},[_vm._v(" 就是利用云计算，物联网等新技术，通过互联网/移动互联网，借助便携的终端上网设备，主动感知旅游资源、旅游经济、旅游活动、旅游者等方面的信息，及时发布，让人们 能够更及时了解这些信息，及时安排和调整工作与旅游计划，从而达到对各类旅游信息的智能感知、方便利用的效果。\n      “智慧旅游”的推广，将提升游客在食、住、行、游、购、娱每个旅游消费环节中的附加值；旅游者在旅游前、旅游中、旅游后，都能够轻松地获取资讯、规划出行、预订票务、安排食宿、消费支出等 ，极大改善旅游体验。")]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.solimg[0].smalltit))]),_vm._v(" "),_c('div',{staticClass:"sol-singleimg"},[_c('img',{staticStyle:{"margin-bottom":"20px"},attrs:{"src":_vm.solimg[0].imgsrc}})]),_vm._v(" "),_c('p',[_vm._v("根据行业的分析，我们从“旅游服务”、“旅游管理”和“旅游营销”这三大方面，通过对顾客、主办单位及景区管理各不同角色的需求分析，形成智慧旅游整体解决方案的构思。\n\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"sol-singleimg"},[_c('img',{staticStyle:{"margin-bottom":"20px"},attrs:{"src":_vm.solimg[1].imgsrc}})]),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.solimg[1].smalltit))]),_vm._v(" "),_c('div',{staticClass:"sol-singleimg"},[_c('img',{staticStyle:{"width":"60%","margin-top":"30px"},attrs:{"src":_vm.solimg[2].imgsrc}})])]):_vm._e(),_vm._v(" "),(_vm.chalid == 2 )?_c('div',{staticClass:"solinfo"},[_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.sol[_vm.chalid].smalltit))]),_vm._v(" "),_c('p',{staticClass:"com-content"},[_vm._v("   “智慧法院”是人民法院信息化建设转型升级的产物，以信息化推进人民法院审判体系和审判能力现代化 ，服务国家治理体系和治理能力现代化。积极适应信息科技发展和“互联网+”时代要求，创新机制，充分运用大数据，推进“智慧法院”建设，方便人民群众诉讼，服务经济社会发展，努力让人民群众在 每一个司法案件中感受到公平正义。")]),_vm._v(" "),_c('div',{staticClass:"sol-singleimg"},[_c('img',{staticStyle:{"width":"50%","margin-top":"10px","margin-bottom":"20px"},attrs:{"src":_vm.fayuan[0].imgsrc}})]),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('div',{staticClass:"sol-singleimg"},[_c('img',{staticStyle:{"width":"50%","margin-top":"20px"},attrs:{"src":_vm.fayuan[1].imgsrc}})])]):_vm._e(),_vm._v(" "),(_vm.chalid == 3 )?_c('div',{staticClass:"solinfo"},[_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.sol[_vm.chalid].smalltit))]),_vm._v(" "),_c('p',{staticClass:"com-content"},[_vm._v("  为更大限度地激活市场要素，整合资源，加强市场监管、降低交易成本，最大限度地在公共资源交易中体现公开、公平、公正，从源头上预防和治理腐败。建立统一公共 资源交易平台，创新管理手段，负责行使招标投标及竞拍工作的具体实施、行政监督和管理职能。")]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.ggzy[0].smalltit))]),_vm._v(" "),_c('div',{staticClass:"sol-singleimg"},[_c('img',{attrs:{"src":_vm.ggzy[0].imgsrc}})]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.ggzy[1].smalltit))]),_vm._v(" "),_c('div',{staticClass:"sol-singleimg"},[_c('img',{attrs:{"src":_vm.ggzy[1].imgsrc}})]),_vm._v(" "),_c('p',[_vm._v("该平台有公共服务、项目交易、综合管理三大基础系统组成;通过“云计算”、“云技术”的应用，服务于如政府采购、工程建设等多类型行业业务；形成的相关业务数据，通过数据中心的建设，实现数据的采集 、分析等功能；最终达到对外提高公共资源交易服务的效率，对内满足公共资源服务单位规范化、系统化管理的双重目的。\n\t\t\t\t\t")]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.ggzy[2].smalltit))]),_vm._v(" "),_vm._l((_vm.ggzyp),function(item){return _c('p',{staticClass:"ggzyp"},[_vm._v(_vm._s(item.tit))])})],2):_vm._e(),_vm._v(" "),(_vm.chalid == 4 )?_c('div',{staticClass:"solinfo"},[_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.sol[_vm.chalid].smalltit))]),_vm._v(" "),_c('p',{staticClass:"com-content"},[_vm._v("作为我司自主研发的产品，旨在满足律师行业的业务需求，提供更畅快的办公体验、更有效的管理模式、以及更智能的业务员流程。")]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.zhls[0].smalltit))]),_vm._v(" "),_c('div',{staticClass:"sol-singleimg"},[_c('img',{staticStyle:{"width":"50%"},attrs:{"src":_vm.zhls[0].imgsrc}})]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.zhls[1].smalltit))]),_vm._v(" "),_c('div',{staticClass:"sol-singleimg"},[_c('img',{staticStyle:{"width":"50%"},attrs:{"src":_vm.zhls[1].imgsrc}})]),_vm._v(" "),_c('div',{staticClass:"sol-singleimg"},[_c('img',{staticStyle:{"width":"50%"},attrs:{"src":_vm.zhls[2].imgsrc}})]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.zhls[2].smalltit))]),_vm._v(" "),_c('p',[_vm._v(" 通过电脑PC端和手机微信端相结合的应用，从功能上实现行业办公、管理及业务办理的快捷、有效和智能化需求特点。\n\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"sol-singleimg"},[_c('img',{staticStyle:{"width":"50%"},attrs:{"src":_vm.zhls[3].imgsrc}})])]):_vm._e(),_vm._v(" "),(_vm.chalid == 5 )?_c('div',{staticClass:"solinfo"},[_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.sol[_vm.chalid].smalltit))]),_vm._v(" "),_c('p',{staticClass:"com-content"},[_vm._v("  “智慧校园”系统，对于优质资源学校推进建设智慧校园系统以及在班级建设智慧班级，多媒体教室系统，形成面向学校管理者、教师、学生、家长的绿色、开放、共享和可持续的个性化服务，并进一步促进学校管理水平的提升，促进师生健康发展和家校良好沟通，为信息技术与教育教学融合创造新环境和新机制。\n智慧校园将配套实验性建立智能教学辅助支持系统，通过收集教学过程中根据作业、测验、考试等各项学习数据进行AI数据分析，针对不同学生出具不同评估报告，用于教师辅助决策，综合素质评定等等；同时教师可以利用知识导图体系，运用精准推送等系统工具为学生群体和个人提供个性化辅助教学，从而有效提高学生成绩。\n\t\t\t\t\t")]),_vm._v(" "),_c('p',[_vm._v("通过前瞻性、系统性、兼具可实施性的设计理念，充分发挥教育信息化对教育现代化的支撑和引领作用，借助云计算、大数据、移动互联网、人工智能等先进技术，规划全区高水平的智慧教育信息化基础设施；打造“智慧校园”、区域共享平台等信息化设施体系；搭建具有本地特色，实现教学资源优势互补，线上线下多样化教学方式，高效、适用易用的区域信息化支撑体系。\n\t\t\t\t\t")]),_vm._v(" "),_c('center',[_c('img',{staticStyle:{"width":"50%"},attrs:{"src":"/static/img/zhxy01.png"}})]),_vm._v(" "),_c('p',[_vm._v("智慧校园”系统，对于优质资源学校推进建设智慧校园系统以及在班级建设智慧班级，多媒体教室系统，形成面向学校管理者、教师、学生、家长的绿色、开放、共享和可持续的个性化服务，并进一步促进学校管理水平的提升，促进师生健康发展和家校良好沟通，为信息技术与教育教学融合创造新环境和新机制。\n智慧校园将配套实验性建立智能教学辅助支持系统，通过收集教学过程中根据作业、测验、考试等各项学习数据进行AI数据分析，针对不同学生出具不同评估报告，用于教师辅助决策，综合素质评定等等；同时教师可以利用知识导图体系，运用精准推送等系统工具为学生群体和个人提供个性化辅助教学，从而有效提高学生成绩。\n\t\t\t\t\t")])],1):_vm._e(),_vm._v(" "),(_vm.chalid == 6 )?_c('div',{staticClass:"solinfo"},[_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.sol[_vm.chalid].smalltit))]),_vm._v(" "),_c('p',{staticClass:"com-content"},[_vm._v("\n\t\t\t\t\t\t厂区作为现代化办公、生产、研发，将主要用作业务、科研、行政办公以及生产基地等。在信息知识经济的时代，业主欲将厂区建设成为具有智能型特征，高科技科研生产基地。我们从智能建筑的四大要素（即结构、系统、服务和管理）来理解、分析厂区智能化的需求。\n\t\t\t\t\t")]),_vm._v(" "),_c('center',[_c('img',{staticStyle:{"width":"50%"},attrs:{"src":"/static/img/zhgc01.png"}})]),_vm._v(" "),_c('p',[_vm._v("\n\t\t\t\t\t\t拟建设成为具有国内外先进水平的，符合高科技生产基地的智能化办公、生产区。智能化系统包含以下特点：\n\t\t\t\t\t")]),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9)],1):_vm._e(),_vm._v(" "),(_vm.chalid == 7 )?_c('div',{staticClass:"solinfo"},[_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.sol[_vm.chalid].smalltit))]),_vm._v(" "),_c('p',{staticClass:"com-content"},[_vm._v("\n\t\t\t\t\t立体化社会防范体系平台通过互联网、网络平台、云平台等先进信息技术的支持，为广大群众提供了一种快速、高效的报警方式。警务人员通过综合服务平台实时监控报警情况，做到实时收取信息，及时做出响应。\n\t\t\t\t")]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v("系统架构")]),_vm._v(" "),_c('center',[_c('img',{staticStyle:{"width":"50%"},attrs:{"src":"/static/img/lth01.png"}})]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v("业务流程展示图")]),_vm._v(" "),_c('center',[_c('img',{staticStyle:{"width":"50%"},attrs:{"src":"/static/img/lth02.png"}})]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v("建设特点")]),_vm._v(" "),_c('p',{staticStyle:{"color":"rgb(201, 48, 44)"}},[_vm._v("1、警情与110实时互通")]),_vm._v(" "),_c('p',{staticStyle:{"color":"rgb(201, 48, 44)"}},[_vm._v("2、社会视频接入公安视频平台")]),_vm._v(" "),_c('p',[_vm._v("云平台技术的应用，使得整体平台适用于当前治安工作分散、紧急性、实时性的特点")])],1):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"solonlogy-top"},[_c('img',{attrs:{"src":"/static/img/solve.jpg"}}),_vm._v(" "),_c('div',{staticClass:"bannerMask"},[_c('div')]),_vm._v(" "),_c('div',{staticClass:"com-tit"},[_c('span',[_c('img',{attrs:{"src":"/static/img/solveicon.png"}}),_c('b',[_vm._v("解决方案")])]),_vm._v(" "),_c('p',[_vm._v("以信息化技术为基础，深入行业需求，服务于各行业，提供相"),_c('br'),_vm._v("\n关行业的专业解决方案")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("基础层")]),_vm._v(" 用于支持各信息系统的安全运行及数据交换的各种必要信息化基础设施，包括网络通讯设施、网络信息安全系统和各种基础软件平台。 ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("应用层")]),_vm._v("分为应用支撑层和用户应用层 应用支撑层主要是一些基础信息系统，通过系统的建设提供功能和数据上的支持；用户应用层则主要面向用户提供特定的功能和用户界面的层现形式。")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("指挥层 ")]),_vm._v("实现景区管监控指挥中心工作的协同联动，指挥调度中心集中设置视频、GPS监控指挥、接处境等系统、利用电视墙、大屏幕设备，接入显示各监控点的视频，并可利用多个大屏幕同时放大显示 重要位置的视频和GPS监控电子地图等，一旦发生紧急事件，工作人员可更充分了解现场状况、迅速找出最佳措施，并及时向相关职能部门发出指令，快速处理 ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("数据层 ")]),_vm._v("数据中心建设专用数据中心机房，采用具备千兆网络接口的应用服务器和数据库服务器，并设立专门的计算机系统维护机构和人员，主要承载门户网站、电子商务和业务审批三大应用，实现网上业务流程及各种业务应用，并集中管理和整合核心业务数据。 ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("智慧法院行业解决方案，将涉及各个角色（如诉讼人、律师、法官及法院内部管理者）的关系，整合成一个角色划分 鲜明的整体，以人为本，科技为手段，体现智能化，对外提高办案效率，对内形成系统化的管理。其中包含三大模块："),_c('b',[_vm._v("专业业务系统、数据中心、基础运营平台")]),_vm._v("。\n\t\t\t\t\t")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticStyle:{"color":"rgb(201, 48, 44)"}},[_vm._v("1、高效：")]),_vm._v("\n\t\t\t\t\t\t将建筑的结构、系统、服务、管理四个基本要素进行优化组合，提供一个投资合理，具有安全、舒适、快捷的服务、科研、办公环境，从而提高工作效率；\n\t\t\t\t\t")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticStyle:{"color":"rgb(201, 48, 44)"}},[_vm._v("2、节能：")]),_vm._v("\t\n\t\t\t\t\t\t通过现代化科技监视、控制手段，采用计算机网络对楼宇机电设备及其系统进行最佳控制，大幅度降低楼宇设备系统的运行、维护、管理成本，达到有效延长以及合理利用能源的目的；\n\t\t\t\t\t")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticStyle:{"color":"rgb(201, 48, 44)"}},[_vm._v("3、科学管理：")]),_vm._v("\n\t\t\t\t\t\t建设厂区通讯自动化和办公自动化系统，为服务、科研、办公的管理手段创造一个优越的环境，并为正常的生产提供优质环境；\n\t\t\t\t\t")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticStyle:{"color":"rgb(201, 48, 44)"}},[_vm._v("4、降低管理成本：")]),_vm._v("\n\t\t\t\t\t\t建立起集中监控、人机界面、信息共享基础上的综合管理模式，从而实现减少维护管理人员，各系统信息显示集中、直观、降低运行成本，建设一个支持厂区内设备监控自动化、安全防范自动化、网络通信自动化的先进的、开放的平台。\n\t\t\t\t\t")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8wZ0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fuwu-haiyang.76398f9.jpg";

/***/ }),

/***/ "BAVs":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/p8-3.b8ee938.jpg";

/***/ }),

/***/ "BTG/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BUkb":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ggzy01.5777daf.png";

/***/ }),

/***/ "CVZP":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fuwu-dayawan.ee6dba4.jpg";

/***/ }),

/***/ "Cw7/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_zhaopin_vue__ = __webpack_require__("LJlt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_605b7882_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_zhaopin_vue__ = __webpack_require__("fIAo");
function injectStyle (ssrContext) {
  __webpack_require__("eC/z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_zhaopin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_605b7882_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_zhaopin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Cz8s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__ = __webpack_require__("wqBJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3802b1fe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__ = __webpack_require__("qlFt");
function injectStyle (ssrContext) {
  __webpack_require__("E13W")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3802b1fe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DBJ4":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/solveicon.653b51d.png";

/***/ }),

/***/ "E13W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EE0m":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ding2.04fe945.png";

/***/ }),

/***/ "Espe":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wepro.a0823a4.jpg";

/***/ }),

/***/ "FGQs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  data: function data() {
    return {
      img: [{ id: 1, imgsrc: 'static/img/data_03.jpg', imglink: '#' }, { id: 2, imgsrc: 'static/img/data_02.jpg', imglink: '#' }, { id: 3, imgsrc: 'static/img/data_01.jpg', imglink: '#' }],
      imgicon: [{ id: 1, imgsrc: 'static/img/sy3_03.png', imglink: '#', detailtit: '系统集成', detailen: 'System Integration' }, { id: 2, imgsrc: 'static/img/sy3_02-06.png', imglink: '#', detailtit: '软件与数据服务', detailen: 'Software and data services' }, { id: 3, imgsrc: 'static/img/sy3_01-09.png', imglink: '#', detailtit: 'IT运维服务', detailen: 'IT operation and maintenance service' }],
      vuelink: [{ id: 1, vuelink: '/TechnologyService/' }, { id: 2, vuelink: '/Solve/' }, { id: 3, vuelink: '/TechnologyService/' }, { id: 4, vuelink: '/TechnologyBusiness/' }],
      falink: [{ id: 0, falink: '/Solve/' + 1 }, { id: 1, falink: '/Solve/' + 2 }, { id: 3, falink: '/TechnologyField/' }, { id: 3, falink: '/TechnologyService/' }, { id: 4, falink: '/TechnologyService/' }],
      detail: [{ id: 1, imgsrc: 'static/img/industry03.jpg', prolink: '/Product/' + 2 }, { id: 2, imgsrc: 'static/img/industry02.jpg', prolink: '/Product/' + 4 }, { id: 3, imgsrc: 'static/img/industry01.jpg', prolink: '/Product/' + 3 }, { id: 4, imgsrc: 'static/img/industry04.jpg', prolink: '/Product/' + 7 }],
      iconb: [{ id: 1, imgsrc: 'static/img/xiangmu.png', tit: '公共资源业务系统', content: '公共资源业务系统是专门针对公共资源交易中心的业务进行开发的综合管理系统， 系统由统一的管理平台与工程交易、土地与矿业权交易、政府采购、产权交易等主要业务子系统组成。' }, { id: 2, imgsrc: 'static/img/zichan.png', tit: '新零售业务系统', content: '系统以中小企业为服务对象，从实现中小企业内部信息管理出发，对接“淘宝”类的大平台，做到充分利用平台资源的同时发挥中小企业的自身灵活性， 切实帮助中小企业面对“新零售”的诸多挑战。' }, { id: 3, imgsrc: 'static/img/zhiyuan.png', tit: '智慧旅游综合业务系统', content: '智慧旅游综合业务系统提供针对旅游行业的综合业务管理；包括门户、OA、资产管理、园林专项业务、旅游专项管理等模块。' }, { id: 4, imgsrc: 'static/img/110.png', tit: '智能综合指挥平台', content: '系统采用了网络、多媒体、物联网等多种技术，具有智能化、可视化、精确化的统一综合指挥功能，由（1）GIS地图监视（2）视频监控与安全警报（3） 车辆通行监控与交通疏导指挥（4）人流量监控与预警管理（5）统一信息发布（6）智能防火警报（7）环境监测系统（8）GPS北斗定位系统（9）视频会议（10） 数字广播系统等专业模块与（11）统一指令系统组成。通过对各子系统功能的有机结合实现统一指挥与调度工作，满足景区、小区、商业综合体、工业园区、学校、 村镇等区域公共安全的综合指挥工作。' }],
      windows: [{ id: 1, imgsrc: 'static/img/quick-nav-about.jpg', winname: '公司简介', imglink: '/AboutcomInfo/' }, { id: 2, imgsrc: 'static/img/quick-nav-wenhua.jpg', winname: '企业文化', imglink: '/AboutcomCulture/' }, { id: 3, imgsrc: 'static/img/quick-nav-zhaopin.jpg', winname: '诚聘英才', imglink: '/Zhaopin' }, { id: 4, imgsrc: 'static/img/quick-nav-contact.jpg', winname: '联系我们', imglink: '/Contactu' }],
      news: [{ ID: 1, title: '广东思程科技有限公司是一家专业的IT解决方案服务商。', imglink: '#', createDate: '2017-10-10' }, { ID: 2, title: '广东思程科技有限公司是一家专业的IT解决方案服务商。', imglink: '#', createDate: '2017-10-10' }, { ID: 3, title: '广东思程科技有限公司是一家专业的IT解决方案服务商。', imglink: '#', createDate: '2017-10-10' }, { ID: 4, title: '广东思程科技有限公司是一家专业的IT解决方案服务商。', imglink: '#', createDate: '2017-10-10' }, { ID: 5, title: '广东思程科技有限公司是一家专业的IT解决方案服务商。', imglink: '#', createDate: '2017-10-10' }, { ID: 6, title: '广东思程科技有限公司是一家专业的IT解决方案服务商。', imglink: '#', createDate: '2017-10-10' }, { ID: 7, title: '广东思程科技有限公司是一家专业的IT解决方案服务商。', imglink: '#', createDate: '2017-10-10' }],
      solvelist: [{ id: 0, imgsrc: 'static/img/zhlysml.png', tit: '智慧旅游', content: '通过互联网/移动互联网，借助便携的终端上网设备，主动感知旅游资源、旅游经济、旅游活动、旅游者等方面的信息及时发布，让人们能够更及时了解这些信息。', fottit: '游客体验', fotstit: '方便游客通过平台对景区进行了解，提高游客在游玩过程中的体验', fotttit: '景区管理', fotftit: '运用科技智能手段进行全面管理，提高景区服务，加强景区安全，打造优质景区' }, { id: 1, imgsrc: 'static/img/zhfysml.png', tit: '智慧法院', content: '以信息化推进人民法院审判体系和审判能力现代化 ，服务国家治理体系和治理能力现代化', fottit: '诉讼人', fotstit: '转变角色，以服务人身份向诉讼人提供专业的服务，如诉讼进程与结果信息查询', fotttit: '律师', fotftit: '遵循三公开原则，对相关案件资料提供公开信息对接服务，对律师提供网上业务办理支持。' }, { id: 2, imgsrc: 'static/img/ggzysml.png', tit: '公共资源交易一体化', content: '建立统一公共资源交易平台,更大限度地激活市场要素，整合资源，加强市场监管、降低交易成本。', fottit: '全程无纸', fotstit: '标书全电子化，大大加快信息的流动速度，同时节约大量纸张', fotttit: '全程共享', fotftit: '实现场地、网络、服务机构等资源共享；评标专家信息、单位诚信记录共享' }, { id: 3, imgsrc: 'static/img/lssml.png', tit: '律师行业业务', content: '作为我司自主研发的产品，旨在满足律师行业的业务需求，提供更畅快的办公体验、更有效的管理模式、以及更智能的业务员流程。', fottit: '畅快的办公体验', fotstit: '随时随地办公，操作简单、易用上手，支持在线文档阅读', fotttit: '智能的业务流程', fotftit: '智能代办定时提醒业务，进程直接展示，可定制化流程管理对防伪系统对接。' }, { id: 4, imgsrc: 'static/img/syxls.png', tit: '新零售', content: '即企业以互联网为依托，通过运用大数据、人工智能等先进技术手段，对商品的生产、流通与销售过程进行升级改造，进而重塑业态结构与生态圈，并对线上服务、线下体验以及现代物流进行深度融合的零售新模式。', fottit: '沉淀数据，高效管理会员', fotstit: '全方位采集消费者数据: 充分利用线下门店流量，将到店顾客转化为线上会员。', fotttit: '快速搭建全渠道零售体系', fotftit: '用一套方案搭建全渠道零售体系拒绝多个业务系统相互割裂而造成的“信息孤岛”。' }],
      show: false,
      height: 'auto',
      bacshow: 0,
      top: '0px',
      width: '300px',
      swipeindex: 0,
      onOff: true
    };
  },

  metaInfo: {
    title: '广东思程科技有限公司',
    meta: [{
      name: 'keyWords',
      content: '广东思程，思程科技，思程，交易系统，见证系统，系统集成，软件与数据服务'
    }, {
      name: "description",
      content: "广东思程科技有限公司是一家专业的IT解决方案服务商。主要从事于计算机系统集成、软件与数据服务、IT运维服务等业务，服务于政府、学校、医疗、生产企业等行业。"
    }]
  },
  mounted: function mounted() {
    this.scor();
    this.getnews();
  },

  watch: {
    show: function show() {
      this.gotheight();
    }
  },
  methods: {
    scor: function scor() {
      var that = this;
      $(document).scroll(function () {
        var htop = $(document).scrollTop();
        if (htop >= 200 & htop < 750) {
          that.show = true;
        } else if (htop < 200 || htop >= 750) {
          that.show = false;
        }
      });
    },
    gotheight: function gotheight() {
      var htop = $(document).scrollTop();
      var top = $('.detail-pro')[0].clientHeight - 100 + 'px';
      this.top = top;
      var width = $('.detail-pro')[0].clientWidth * 0.8 + 'px';
      this.width = width;
      var he = $('.detail-pro')[0].clientHeight + 'px';
      this.height = he;
    },
    getheight: function getheight(index) {
      if (this.onOff) {
        console.log(1);
        this.onOff = false;
        var that = this;
        that.bacshow = index;
      }
    },
    outbac: function outbac() {

      if (!this.onOff) {
        this.onOff = true;
        //  this.bacshow = 0
      }
    },
    getin: function getin(val) {
      this.swipeindex = val;
    },
    gotop: function gotop() {
      window.scrollTo(0, 0);
    },
    getnews: function getnews() {
      var _this = this;

      this.$http.post('http://www.gd-sc.net:9090', { table: 'news' }, { emulateJSON: true }).then(function (response) {
        for (var i = 0; i < response.body.length; i++) {
          var data = response.body[i].createDate;
          response.body[i].createDate = data.substr(0, 10);
        }
        _this.news = response.body;
      });
    },
    todetail: function todetail(id) {
      this.gotop();
      this.$router.push('/Newsdetail/' + id);
    },
    routerto: function routerto(linkt) {
      this.gotop();
      this.$router.push(linkt);
    },
    topro: function topro(linkt) {
      this.gotop();
      this.$router.push(linkt);
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "FsQa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'solve',
	data: function data() {
		return {
			sol: [{ id: 0, imgsrc: '/static/img/solve.jpg', title: '新零售', smalltit: '新零售' }, { id: 1, imgsrc: '/static/img/solve.jpg', title: '智慧旅游', smalltit: '智慧旅游' }, { id: 2, imgsrc: '/static/img/solve.jpg', title: '智慧法院', smalltit: '智慧法院' }, { id: 3, imgsrc: '/static/img/solve.jpg', title: '公共资源交易一体化', smalltit: '公共资源交易一体化' }, { id: 4, imgsrc: '/static/img/solve.jpg', title: '律师行业业务综合管理系统', smalltit: '律师行业业务综合管理系统' }, { id: 5, imgsrc: '/static/img/solve.jpg', title: '智慧校园', smalltit: '智慧校园' }, { id: 6, imgsrc: '/static/img/solve.jpg', title: '智慧工厂', smalltit: '智慧工厂' }, { id: 7, imgsrc: '/static/img/solve.jpg', title: '立体化社会防范体系平台', smalltit: '立体化社会防范体系平台' }],
			solimg: [{ id: 0, imgsrc: '/static/img/sc-lvyou-1.png', smalltit: '需求分析' }, { id: 1, imgsrc: '/static/img/zhihuilvyou.png', smalltit: '建设目标特点' }, { id: 2, imgsrc: '/static/img/zhihuitedian.png', smalltit: '' }],
			xls: [{ id: 0, smalltit: '系统特点' }, { id: 1, smalltit: '系统应用场景' }],
			yewu: [{ id: 0, imgsrc: '/static/img/yewumodx.png', smalltit: '项目建设' }, { id: 1, imgsrc: '/static/img/yewumodp.png', smalltit: '产品开发' }, { id: 2, imgsrc: '/static/img/yewumodz.png', smalltit: '项目合作运营' }],
			chalid: 0,
			fayuan: [{ id: 0, imgsrc: '/static/img/zhfy.jpg' }, { id: 1, imgsrc: '/static/img/zhfy2.jpg' }],
			ggzy: [{ id: 0, imgsrc: '/static/img/ggzy1.png', smalltit: '建设目标关键点' }, { id: 1, imgsrc: '/static/img/ggzy2.png', smalltit: '平台架构图' }, { id: 2, imgsrc: '/static/img/ggzy2.png', smalltit: '公共资源网上交易系统建设' }],
			ggzyp: [{ id: 0, tit: '1.公共资源网上交易大厅（门户网站）' }, { id: 1, tit: '6.政府采购交易招投标系统' }, { id: 2, tit: '2.手机APP客户端' }, { id: 3, tit: '7.公共资源和综合管理系统' }, { id: 4, tit: '3.土地与矿业网上交易系统' }, { id: 5, tit: '8.专家申报与管理系统' }, { id: 6, tit: '4.产权网上交易竞价系统' }, { id: 7, tit: '9.办公OA系统' }, { id: 8, tit: '5.建设工程交易招投标系统' }, { id: 9, tit: '10.交易监察系统' }],
			zhls: [{ id: 0, imgsrc: '/static/img/lvshihangye.jpg', smalltit: '专业解决方案' }, { id: 1, imgsrc: '/static/img/zhls2.png', smalltit: '系统架构' }, { id: 2, imgsrc: '/static/img/zhls3.png', smalltit: '功能特点' }, { id: 3, imgsrc: '/static/img/zhls4.png', smalltit: '功能特点' }],
			navli: [{ id: 0, litit: '新零售' }, { id: 1, litit: '智慧旅游' }, { id: 2, litit: '智慧法院' }, { id: 5, litit: '智慧校园' }, { id: 6, litit: '智慧工厂' }, { id: 3, litit: '公共资源交易' }, { id: 4, litit: '律师行业业务' }, { id: 7, litit: '立体化社会防范' }]
		};
	},
	mounted: function mounted() {
		this.getID();
		//console.log(this.chalid)
	},

	metaInfo: {
		title: '解决方案',
		meta: [{
			name: 'keyWords',
			content: '新零售，智慧旅游，智慧法院，智慧校园，智慧工厂，公共资源交易，律师行业业务，立体化社会防范，交易系统，网上挂牌交易系统，交易竞价系统，土矿交易系统，土地与矿业网上挂牌交易系统，产权交易网上竞价系统，产权交易系统'
		}, {
			name: "description",
			content: "新零售，智慧旅游，智慧法院，智慧校园，智慧工厂，公共资源交易，律师行业业务，立体化社会防范，交易系统，网上挂牌交易系统，交易竞价系统，土矿交易系统，土地与矿业网上挂牌交易系统，产权交易网上竞价系统，产权交易系统"
		}]
	},
	methods: {
		getID: function getID() {
			if (this.$route.params.ID !== null && this.$route.params.ID !== undefined && this.$route.params.ID !== '') {
				this.chalid = this.$route.params.ID;
			} else {
				this.chalid = 0;
			}
		},
		seltab: function seltab(index) {
			this.chalid = index;
		}
	}
});

/***/ }),

/***/ "HriX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/abouticon.92f7106.png";

/***/ }),

/***/ "HtlJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"case-nav"}),_vm._v(" "),_c('div',{staticClass:"pro-detail"},[_c('ul',_vm._l((_vm.pro),function(navli){return _c('li',{staticClass:"casenav",class:{caseacli : _vm.chalid == navli.id},on:{"click":function($event){$event.preventDefault();return _vm.seltab(navli.id)}}},[_vm._v(_vm._s(navli.title))])}),0),_vm._v(" "),(_vm.chalid == 0 )?_c('div',{staticClass:"proinfo"},[_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.pro[_vm.chalid].smalltit))]),_vm._v(" "),_c('p',{staticClass:"com-content"},[_vm._v("\n\t\t\t\t\t应用场景：1.\t城镇环境监测、旅游景区环境监测、江河湖泊湿地环境监测、森林山地环境监测与预警系统；\n\t\t\t\t\t2.\t大型社区、农场、物流园的环境监测；\n\t\t\t\t\t3.\t仓库环境：如粮食、烟草、医药、化工、食品等，主要为温湿度、气体含量、水质、酸碱度等；\n\t\t\t\t\t4.\t机房环境监测：电流、电压、开关状态、发电机、蓄电池、电源、烟感、漏水、配电、温湿度、烟感、门禁、UPS、空调、电源等；\n\t\t\t\t\t5.\t城镇洪涝、干旱灾害的监测预警。\n\t\t\t\t")]),_vm._v(" "),_c('p',{staticClass:"com-content"},[_vm._v("\n\t\t\t\t\t简介：环境监测智能综合管理系统是一个综合利用计算机网络技术、数据库技术、通信技术、自动控制技术、新型传感技术等构成的计算机网络，\n\t\t\t\t\t提供的一种以计算机技术为基础、基于集中管理监控模式的自动化、智能化和高效率的技术手段，统一进行生态监测、污染物监测、环境监测、\n\t\t\t\t\t自然灾害监测并实现分析与预警的一套智能化的系统。\n\t\t\t\t")]),_vm._v(" "),_c('p',{staticClass:"com-content"},[_vm._v("\n\t\t\t\t\t系统功能：通过配置不同的环境传感器，可实现针对性很强的解决方案，如空气质量监测、水质监测、土壤监测、污染物监测、\n\t\t\t\t\t动力监测、声音监测、火灾监测、光照监测等。\n\t\t\t\t")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('p',{staticClass:"com-content"},[_vm._v("\n\t\t\t\t\t软件著作权证书：\n\t\t\t\t")]),_vm._v(" "),_vm._m(2)]):_vm._e(),_vm._v(" "),(_vm.chalid == 1 )?_c('div',{staticClass:"proinfo"},[_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.pro[_vm.chalid].smalltit))]),_vm._v(" "),_c('p',{staticClass:"com-content"},[_vm._v("\n\t\t\t\t\t行业：企事业单位\n\t\t\t\t")]),_vm._v(" "),_c('p',{staticClass:"com-content"},[_vm._v("\n\t\t\t\t\t简介：能够有效降低招投标成本，使采购过程更具规范性和透明性，达到采购管理“公开、公正、公平”的目的，为各行业持续提供“专业、全面、可靠、合规”的招标解决方案。\n\t\t\t\t")]),_vm._v(" "),_c('p',{staticClass:"com-content"},[_vm._v("\n\t\t\t\t\t系统功能：覆盖招投标业务全过程，包括：网上发布招标信息、网上报名、网上报价、网上上传投标文件、网上保证金管理、网上结果公示公告、投标人信息管理、专家基础信息管理、\n\t\t\t\t\t开评标签到考勤管理、三方监管平台、短信平台接口、加解密码公共平台、数据共享与交换接口、电子监管接口。\n\t\t\t\t")]),_vm._v(" "),_vm._m(3)]):_vm._e(),_vm._v(" "),(_vm.chalid == 2 )?_c('div',{staticClass:"proinfo"},[_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.pro[_vm.chalid].smalltit))]),_vm._v(" "),_c('p',{staticClass:"com-content"},[_vm._v("\n\t\t\t\t\t行业：事业单位、大型企业\n\t\t\t\t")]),_vm._v(" "),_c('p',{staticClass:"com-content"},[_vm._v("\t\n\t\t\t\t\t简介：公共资源业务系统是专门针对公共资源交易中心的业务进行开发的综合管理系统，\n\t\t\t\t\t系统由统一的管理平台与工程交易、土地与矿业权交易、政府采购、产权交易等主要业务子系统组成。\n\t\t\t\t")]),_vm._v(" "),_c('p',{staticClass:"com-content"},[_vm._v("\n\t\t\t\t\t系统功能：可实现工程交易、土地与矿业权交易、政府采购、产权交易等各专项的全流程业务，可实现全程网上招投标、\n\t\t\t\t\t全程网上交易、全程的在线监测、统一的信息管理，具有高效、安全、稳定的特点，全面达到公共资源业务的公开、公平、\n\t\t\t\t\t公正的要求。\n\t\t\t\t")]),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('p',{staticClass:"com-content"},[_vm._v("\n\t\t\t\t\t软件著作权证书：\n\t\t\t\t")]),_vm._v(" "),_vm._m(5)]):_vm._e(),_vm._v(" "),(_vm.chalid == 3 )?_c('div',{staticClass:"proinfo"},[_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.pro[_vm.chalid].smalltit))]),_vm._v(" "),_c('p',{staticClass:"com-content"},[_vm._v("\n\t\t\t\t\t行业：景区、园林、旅游事业单位\n\t\t\t\t")]),_vm._v(" "),_c('p',{staticClass:"com-content"},[_vm._v("\t\n\t\t\t\t\t简介：智慧旅游综合业务系统提供针对旅游行业的综合业务管理；包括门户、OA、资产管理、园林专项业务、旅游专项管理等模块。\n\t\t\t\t")]),_vm._v(" "),_c('p',{staticClass:"com-content"},[_vm._v("\n\t\t\t\t\t系统功能：实现了统一信息管理、OA办公自动化，具有针对旅游行业的全程数字功能，包括网上售票、在线（VR）景区、数字景区，\n\t\t\t\t\t通过大数据的应用实现了人流管控、环境监测等智能化管理。\n\t\t\t\t")]),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('p',{staticClass:"com-content"},[_vm._v("\n\t\t\t\t\t软件著作权证书：\n\t\t\t\t")]),_vm._v(" "),_vm._m(7)]):_vm._e(),_vm._v(" "),(_vm.chalid == 4 )?_c('div',{staticClass:"proinfo"},[_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.pro[_vm.chalid].smalltit))]),_vm._v(" "),_c('p',{staticClass:"com-content"},[_vm._v("\n\t\t\t\t\t行业：零售、批发、商贸类行业\n\t\t\t\t")]),_vm._v(" "),_c('p',{staticClass:"com-content"},[_vm._v("\t\n\t\t\t\t\t简介：系统以中小企业为服务对象，从实现中小企业内部信息管理出发，对接“淘宝”类的大平台，做到充分利用平台资源的同时发挥中小企业的自身灵活性，\n\t\t\t\t\t切实帮助中小企业面对“新零售”的诸多挑战\n\t\t\t\t")]),_vm._v(" "),_c('p',{staticClass:"com-content"},[_vm._v("\n\t\t\t\t\t系统功能：分行业的进销存管理；提供微信、网店营销；实现桌面、移动端的全覆盖；实现店内销售、网上配送多种服务方式。\n\t\t\t\t")]),_vm._v(" "),_vm._m(8),_vm._v(" "),_c('p',{staticClass:"com-content"},[_vm._v("\n\t\t\t\t\t软件著作权证书：\n\t\t\t\t")]),_vm._v(" "),_vm._m(9)]):_vm._e(),_vm._v(" "),(_vm.chalid == 5 )?_c('div',{staticClass:"proinfo"},[_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.pro[_vm.chalid].smalltit))]),_vm._v(" "),_c('p',{staticClass:"com-content"},[_vm._v("\n\t\t\t\t\t行业：律师行业\n\t\t\t\t")]),_vm._v(" "),_c('p',{staticClass:"com-content"},[_vm._v("\t\n\t\t\t\t\t简介：系统针对律师行业开发，解决了律师行业的信息化管理需求，包括资料管理、案件跟踪、事物审批、对接法院公开平台，实现了协同工作，有效的提升了律师团队的效率\n\t\t\t\t")]),_vm._v(" "),_c('p',{staticClass:"com-content"},[_vm._v("\n\t\t\t\t\t系统功能：协同办公，资料汇总，事物审批，案件管理\n\t\t\t\t")]),_vm._v(" "),_vm._m(10),_vm._v(" "),_c('p',{staticClass:"com-content"},[_vm._v("\n\t\t\t\t\t软件著作权证书：\n\t\t\t\t")]),_vm._v(" "),_vm._m(11)]):_vm._e(),_vm._v(" "),(_vm.chalid == 6 )?_c('div',{staticClass:"proinfo"},[_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.pro[_vm.chalid].smalltit))]),_vm._v(" "),_c('p',{staticClass:"com-content"},[_vm._v("\n\t\t\t\t\t行业：贸易制造、地产建筑、医疗教育、物流服务等企事业、政府部位。\n\t\t\t\t")]),_vm._v(" "),_c('p',{staticClass:"com-content"},[_vm._v("\t\n\t\t\t\t\t简介：OA管理系统由人力资源管理模块、信息中心、流程审批、公文管理、文档管理、任务管理、会议管理等子系统组成。适合企事业内部的办公审批流程管理。\n\t\t\t\t")]),_vm._v(" "),_c('p',{staticClass:"com-content"},[_vm._v("\n\t\t\t\t\t系统功能：通过电子公文流转改变了企业传统纸质公文办公模式，采用电子起草、传阅、审批、会签、签发、归档等电子化流转方式，真正实现无纸化办公。\n\t\t\t\t")]),_vm._v(" "),_vm._m(12),_vm._v(" "),_c('p',{staticClass:"com-content"},[_vm._v("\n\t\t\t\t\t软件著作权证书：\n\t\t\t\t")]),_vm._v(" "),_vm._m(13)]):_vm._e(),_vm._v(" "),(_vm.chalid == 7 )?_c('div',{staticClass:"proinfo"},[_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.pro[_vm.chalid].smalltit))]),_vm._v(" "),_c('p',{staticClass:"com-content"},[_vm._v("\n\t\t\t\t\t行业：安防、消防、环保等\n\t\t\t\t")]),_vm._v(" "),_c('p',{staticClass:"com-content"},[_vm._v("\t\n\t\t\t\t\t简介：系统采用了网络、多媒体、物联网等多种技术，具有智能化、可视化、精确化的统一综合指挥功能，由（1）GIS地图监视（2）视频监控与安全警报（3）\n\t\t\t\t\t车辆通行监控与交通疏导指挥（4）人流量监控与预警管理（5）统一信息发布（6）智能防火警报（7）环境监测系统（8）GPS北斗定位系统（9）视频会议（10）\n\t\t\t\t\t数字广播系统等专业模块与（11）统一指令系统组成。通过对各子系统功能的有机结合实现统一指挥与调度工作，满足景区、小区、商业综合体、工业园区、学校、\n\t\t\t\t\t村镇等区域公共安全的综合指挥工作。\n\t\t\t\t")]),_vm._v(" "),_c('p',{staticClass:"com-content"},[_vm._v("\n\t\t\t\t\t系统功能：实现了视频监控、多媒体发布、安防警报、环境监测、移动定位等专项功能，可实现各种业务系统的数据对接，\n\t\t\t\t\t具有数据分析功能，具有安全、稳定、网络化的特点\n\t\t\t\t")]),_vm._v(" "),_vm._m(14),_vm._v(" "),_c('p',{staticClass:"com-content"},[_vm._v("\n\t\t\t\t\t软件著作权证书：\n\t\t\t\t")]),_vm._v(" "),_vm._m(15)]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"proonlogy-top"},[_c('img',{attrs:{"src":__webpack_require__("Espe")}}),_vm._v(" "),_c('div',{staticClass:"bannerMask"},[_c('div')]),_vm._v(" "),_c('div',{staticClass:"com-tit"},[_c('span',[_c('img',{attrs:{"src":__webpack_require__("DBJ4")}}),_c('b',[_vm._v("我们的产品")])]),_vm._v(" "),_c('p',[_vm._v("多年产品研发经验，采用CMMI管理模式体系以上国际先进、成"),_c('br'),_vm._v("\n熟的开发工具和语言")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pro-singleimg"},[_c('img',{staticStyle:{"width":"80%","max-width":"100%"},attrs:{"src":__webpack_require__("8P+n")}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pro-singleimg"},[_c('img',{staticStyle:{"width":"18%","height":"auto","display":"inline-block","margin":"1%"},attrs:{"src":__webpack_require__("4oXx")}}),_vm._v(" "),_c('img',{staticStyle:{"width":"18%","height":"auto","display":"inline-block","margin":"1%"},attrs:{"src":__webpack_require__("JS1F")}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pro-singleimg"},[_c('img',{staticStyle:{"width":"80%","max-width":"100%"},attrs:{"src":__webpack_require__("tw47")}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pro-singleimg"},[_c('img',{staticStyle:{"width":"60%","max-width":"100%"},attrs:{"src":__webpack_require__("BUkb")}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pro-singleimg"},[_c('img',{staticStyle:{"width":"18%","height":"auto","display":"inline-block","margin":"1%"},attrs:{"src":__webpack_require__("+nda")}}),_vm._v(" "),_c('img',{staticStyle:{"width":"18%","height":"auto","display":"inline-block","margin":"1%"},attrs:{"src":__webpack_require__("YB8v")}}),_vm._v(" "),_c('img',{staticStyle:{"width":"18%","height":"auto","display":"inline-block","margin":"1%"},attrs:{"src":__webpack_require__("73Ta")}}),_vm._v(" "),_c('img',{staticStyle:{"width":"18%","height":"auto","display":"inline-block","margin":"1%"},attrs:{"src":__webpack_require__("03Ll")}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pro-singleimg"},[_c('img',{staticStyle:{"width":"60%","max-width":"100%"},attrs:{"src":__webpack_require__("6G03")}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pro-singleimg"},[_c('img',{staticStyle:{"width":"18%","height":"auto","display":"inline-block","margin":"1%"},attrs:{"src":__webpack_require__("tBRS")}}),_vm._v(" "),_c('img',{staticStyle:{"width":"18%","height":"auto","display":"inline-block","margin":"1%"},attrs:{"src":__webpack_require__("P/ir")}}),_vm._v(" "),_c('img',{staticStyle:{"width":"18%","height":"auto","display":"inline-block","margin":"1%"},attrs:{"src":__webpack_require__("SEiT")}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pro-singleimg"},[_c('img',{staticStyle:{"width":"60%","max-width":"100%"},attrs:{"src":__webpack_require__("z2Ij")}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pro-singleimg"},[_c('img',{staticStyle:{"width":"18%","height":"auto","display":"inline-block","margin":"1%"},attrs:{"src":__webpack_require__("iVxy")}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pro-singleimg"},[_c('img',{staticStyle:{"width":"60%","max-width":"100%"},attrs:{"src":__webpack_require__("O76j")}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pro-singleimg"},[_c('img',{staticStyle:{"width":"18%","height":"auto","display":"inline-block","margin":"1%"},attrs:{"src":__webpack_require__("fr82")}}),_vm._v(" "),_c('img',{staticStyle:{"width":"18%","height":"auto","display":"inline-block","margin":"1%"},attrs:{"src":__webpack_require__("OPlf")}}),_vm._v(" "),_c('img',{staticStyle:{"width":"18%","height":"auto","display":"inline-block","margin":"1%"},attrs:{"src":__webpack_require__("PaFw")}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pro-singleimg"},[_c('img',{staticStyle:{"width":"60%","max-width":"100%"},attrs:{"src":__webpack_require__("QvBD")}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pro-singleimg"},[_c('img',{staticStyle:{"width":"18%","height":"auto","display":"inline-block","margin":"1%"},attrs:{"src":__webpack_require__("2BQd")}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pro-singleimg"},[_c('img',{staticStyle:{"width":"60%","max-width":"100%"},attrs:{"src":__webpack_require__("WdB6")}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pro-singleimg"},[_c('img',{staticStyle:{"width":"18%","height":"auto","display":"inline-block","margin":"1%"},attrs:{"src":__webpack_require__("aH5q")}}),_vm._v(" "),_c('img',{staticStyle:{"width":"18%","height":"auto","display":"inline-block","margin":"1%"},attrs:{"src":__webpack_require__("dWvu")}}),_vm._v(" "),_c('img',{staticStyle:{"width":"18%","height":"auto","display":"inline-block","margin":"1%"},attrs:{"src":__webpack_require__("BAVs")}}),_vm._v(" "),_c('img',{staticStyle:{"width":"18%","height":"auto","display":"inline-block","margin":"1%"},attrs:{"src":__webpack_require__("tkHa")}}),_vm._v(" "),_c('img',{staticStyle:{"width":"18%","height":"auto","display":"inline-block","margin":"1%"},attrs:{"src":__webpack_require__("ynmX")}}),_vm._v(" "),_c('img',{staticStyle:{"width":"18%","height":"auto","display":"inline-block","margin":"1%"},attrs:{"src":__webpack_require__("iTIH")}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "I29P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "I3KQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"techonlogy"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"tech-detail"},[_c('div',{staticClass:"tech-top-top"},[_c('h4',[_vm._v(_vm._s(_vm.tech[_vm.chalid].title))]),_vm._v(" "),_c('div',{staticClass:"tech-line"})]),_vm._v(" "),(_vm.chalid == 0 )?_c('div',{staticClass:"techinfo"},[_c('p',{staticClass:"com-content"},[_vm._v(" 公司服务领域分为三大块：")]),_vm._v(" "),_c('div',{staticClass:"tech-singleimg"},[_c('img',{attrs:{"src":_vm.techimg[0].imgsrc}})]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.techimg[0].smalltit))]),_vm._v(" "),_c('p',[_vm._v("系统集成（SI，System Integration），我们在系统工程科学方法的指导下，经过专业技术的不断进步和多年施 工经验的积累，能为您提供智能弱电系统\n\t\t\t\t\t\t集成、网络安全系统集成、数据中心与云平台等三大项目和20个子系统的专业服务。\n\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"tech-singleimg"},[_c('img',{attrs:{"src":_vm.techimg[1].imgsrc}})]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.techimg[1].smalltit))]),_vm._v(" "),_c('p',[_vm._v("软件与数据服务（Software and data services），思程科技是以自主知识产权产品开发为核心的双软企业，我公司采用了CMMI管理模式体系以及国际上先进、成熟的开发工具和语言，开发了许多满足客户实际需求的应用软件。\n\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"tech-singleimg"},[_c('img',{attrs:{"src":_vm.techimg[2].imgsrc}})]),_vm._v(" "),_c('p',[_vm._v("软件（SAAS）即服务是行业的发展趋势，提供应用类的软件服务是公司的发展方向，公司以软件开发为基础，向用户提供全方向的信息化业务方案\n\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"tech-singleimg"},[_c('img',{attrs:{"src":_vm.techimg[3].imgsrc}})]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.techimg[2].smalltit))]),_vm._v(" "),_c('p',[_vm._v("IT运维服务 (IT operation and maintenance services) ，思程科技以专业的技术力量和运维团队为客户提 供IT领域全面的咨询、实施、运维、迁移、培训五大类服务。\n\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"tech-singleimg"},[_c('img',{attrs:{"src":_vm.techimg[4].imgsrc}})])]):_vm._e(),_vm._v(" "),(_vm.chalid == 1 )?_c('div',{staticClass:"techinfo"},[_c('p',{staticClass:"com-content"},[_vm._v(" 公司以信息化技术为基础，深入行业需求，服务于各行业，以提供相关行业的信息化解决方案为整体方向，以项目建设、产品开发、项目运营等形式拓展业务。")]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.yewu[0].smalltit))]),_vm._v(" "),_c('p',[_vm._v("由专业的信息化项目经理落实项目建设，全程项目监管勘查、设计、施工、维护")]),_vm._v(" "),_c('div',{staticClass:"tech-singleimg"},[_c('img',{staticStyle:{"width":"35%"},attrs:{"src":_vm.yewu[0].imgsrc}})]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.yewu[1].smalltit))]),_vm._v(" "),_c('p',[_vm._v("以市场需求为导向，结合相关的行业经验，公司不断推进产品开发工作，以优质产品赢取市场。\n\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"tech-singleimg"},[_c('img',{attrs:{"src":_vm.yewu[1].imgsrc}})]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.yewu[2].smalltit))]),_vm._v(" "),_c('p',[_vm._v("根据用户的业务需求，发挥公司的技术优势与资本能力，承担相关的信息化建设并负责具体运营，达到共赢的目的。\n\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"tech-singleimg"},[_c('img',{staticStyle:{"width":"36%"},attrs:{"src":_vm.yewu[2].imgsrc}})])]):_vm._e(),_vm._v(" "),(_vm.chalid == 2 )?_c('div',{staticClass:"techinfo"},[_c('p',{staticClass:"com-content"},[_vm._v(" 公司主要涉及的技术领域有（1）弱电+网络通讯（2）数据与安全（3）云技术（4）物联网（5）应用软件")]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.jishu[0].smalltit))]),_vm._v(" "),_c('div',{staticClass:"tech-singleimg"},[_c('img',{staticStyle:{"width":"45%"},attrs:{"src":_vm.jishu[0].imgsrc}})]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.jishu[1].smalltit))]),_vm._v(" "),_c('div',{staticClass:"tech-singleimg"},[_c('img',{staticStyle:{"width":"60%"},attrs:{"src":_vm.jishu[1].imgsrc}})]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.jishu[2].smalltit))]),_vm._v(" "),_c('div',{staticClass:"tech-singleimg"},[_c('img',{staticStyle:{"width":"60%"},attrs:{"src":_vm.jishu[2].imgsrc}})]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.jishu[3].smalltit))]),_vm._v(" "),_c('p',{staticClass:"com-content"},[_vm._v(" 顾名思义，物联网就是物物相连的互联网。这有两层意思：其一，物联网的核心和基础仍然是互联网，是在互\n\t\t\t\t\t联网基础上的延伸和扩展的网络；其二，其用户端延伸和扩展到了任何物品与物品之间，进行信息交换和通信，也就\n\t\t\t\t\t是物物相息。物联网通过智能感知、识别技术与普适计算等通信感知技术，广泛应用于网络的融合中，也因此被称\n\t\t\t\t\t为继计算机、互联网之后世界信息产业发展的第三次浪潮。物联网是互联网的应用拓展，与其说物联网是网络，不\n\t\t\t\t\t如说物联网是业务和应用。因此，应用创新是物联网发展的核心，以用户体验为核心的创新2.0是物联网发展的灵魂。\n\t\t\t\t\t")]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.jishu[4].smalltit))]),_vm._v(" "),_c('p',{staticClass:"com-content"},[_vm._v(" 应用软件开发，思程科技是以自主知识产权产品开发为核心的双软企业，我司采用了CMMI管理模式体系\n\t\t\t\t\t以上国际上先进、成熟的开发工具和语言，开发了许多满足客户实际需求的应用软件，应用于政府、民政、医疗、金融等各行业，用户反应良好。\n\t\t\t\t\t")]),_vm._v(" "),_c('p',{staticClass:"com-content"},[_vm._v(" 思程科技的软件研发团队是由一批技术能力强、项目经验丰富的软件人才组成，具有多元化的技术路线，涵盖各主流开发\n\t\t\t\t\t\t语言，在.net和JAVA方面都有着丰富的项目和产品开发经验\n\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"tech-singleimg"},[_c('img',{attrs:{"src":_vm.jishu[4].imgsrc}})])]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"techonlogy-top"},[_c('img',{attrs:{"src":"/static/img/fuwu.jpg"}}),_vm._v(" "),_c('div',{staticClass:"bannerMask"},[_c('div')]),_vm._v(" "),_c('div',{staticClass:"com-tit"},[_c('span',[_c('img',{attrs:{"src":"/static/img/fuwuicon.png"}}),_c('b',[_vm._v("业务中心")])]),_vm._v(" "),_c('p',[_vm._v("致力于为政府、学校、医疗、公共事业、生产企业等各行业提"),_c('br'),_vm._v("\n供专业的信息化服务")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IL2k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_technology_service_vue__ = __webpack_require__("QbBv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3699cac2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_technology_service_vue__ = __webpack_require__("I3KQ");
function injectStyle (ssrContext) {
  __webpack_require__("TQH0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_technology_service_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3699cac2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_technology_service_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JS1F":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/p1-2.12d389b.jpg";

/***/ }),

/***/ "K5aM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'aboutcom-info',
	data: function data() {
		return {
			top: [{ id: 0, imgsrc: '/static/img/aboutcom.jpg', title: '关于我们' }],
			center: [{ id: 0, imgsrc: '/static/img/aboutcom.jpg', title: '公司简介', smalltit: '专业的信息化服务商' }, { id: 1, imgsrc: '/static/img/aboutcom.jpg', title: '组织框架', smalltit: '专业的信息化服务商' }, { id: 2, imgsrc: '/static/img/aboutcom.jpg', title: '企业文化', smalltit: '专业的信息化服务商' }, { id: 3, imgsrc: '/static/img/aboutcom.jpg', title: '资质荣誉', smalltit: '专业的信息化服务商' }, { id: 4, imgsrc: '/static/img/aboutcom.jpg', title: '新闻资讯', smalltit: '专业的信息化服务商' }],
			chalid: 0,
			comimg: [{ id: 0, imgsrc: '/static/img/comabout1.jpg' }, { id: 1, imgsrc: '/static/img/comabout2.jpg' }],
			news: [],
			wenhua: [{ id: 0, wentit: '责任感', wencontent: '我们的企业要有社会责任感，我们的员工对公司、客户、家庭要勇于负责任' }, { id: 1, wentit: '团队精神', wencontent: '我们的企业是一个团队，每个员工都必须充分认可团队、依靠团队、配合 团队、才能形成一个有战斗力的队伍' }, { id: 2, wentit: '专业服务、技术创新', wencontent: '拥有专业的技术、良好的服务能力，展现IT行业的“工匠”精神' }, { id: 3, wentit: '管理的规范化与制度化', wencontent: '我们相信：企业的长远发展需要管理的规范化与运营的制度化' }, { id: 4, wentit: '勤劳、诚实、自信、超越自我的精神', wencontent: '我们希望我们的员工是一个勤奋、诚实可靠、有自信、勇于超越自我的人' }],
			honor: [{ id: 0, hoimg: '/static/img/zz1.jpg', honame: '■ 计算机信息系统集成企业资质证书叁级' }, { id: 1, hoimg: '/static/img/zz13.jpg', honame: '■ 广东省安全技术防范系统设计、施工、维修资格证（壹级）证书' }, { id: 2, hoimg: '/static/img/zz5.jpg', honame: '■ 广东省涉密计算机、通信和办公自动化设备定点维护维修证书' }, { id: 3, hoimg: '/static/img/zz6.jpg', honame: '■ 软件企业认定证书' }, { id: 4, hoimg: '/static/img/zz12.jpg', honame: '■ 质量管理体系认证证书' }, { id: 5, hoimg: '/static/img/zz14.jpg', honame: '■ 高新技术企业证书' }, { id: 6, hoimg: '/static/img/zz9.jpg', honame: '■ 音视频工程业企业资质贰级' }, { id: 7, hoimg: '/static/img/zz11.jpg', honame: '■ 守合同重信用企业（连续十二年）' }, { id: 8, hoimg: '/static/img/zz15.jpg', honame: '■ 信息技术服务管理体系认证证书' }, { id: 9, hoimg: '/static/img/zz16.jpg', honame: '■ 环境管理体系认证证书' }, { id: 10, hoimg: '/static/img/zz17.jpg', honame: '■ 职业健康安全管理体系认证证书' }, { id: 11, hoimg: '/static/img/zz18.jpg', honame: '■ 电子与智能化工程专业承包贰级' }, { id: 12, hoimg: '/static/img/zz19.jpg', honame: '■ 安全生产许可证' }],
			honorname: [{ id: 0, honame: '■ 计算机信息系统集成企业资质证书叁级' }, { id: 1, honame: '■ 广东省安全技术防范系统设计、施工、维修资格证（壹级）证书' }, { id: 2, honame: '■ 广东省涉密计算机、通信和办公自动化设备定点维护维修证书' }, { id: 3, honame: '■ 软件企业认定证书' }, { id: 4, honame: '■ ISO9001 2020质量管理体系认证证书' }, { id: 5, honame: '■ 高新技术企业证书' }, { id: 6, honame: '■ 音视频工程业企业资质贰级' }, { id: 7, honame: '■ 守合同重信用企业（连续十二年）' }, { id: 8, honame: '■ ISO/IEC 20000信息技术服务管理体系认证证书' }, { id: 9, honame: '■ ISO14001环境管理体系认证证书' }, { id: 10, honame: '■ ISO45001职业健康安全管理体系认证证书' }, { id: 11, honame: '■ 电子与智能化工程专业承包贰级' }, { id: 12, honame: '■ 安全生产许可证' }],
			scrollWatch: true
		};
	},
	mounted: function mounted() {
		this.getID();
		this.getnews();
	},

	metaInfo: {
		title: '专业的信息化服务企业'
	},
	methods: {
		getID: function getID() {
			this.chalid = 0;
		},
		getnews: function getnews() {
			// 	this.$http.post('http://www.gd-sc.net:9090',{table : 'news'},{emulateJSON: true}).then((response) => {
			//     for(var i=0 ; i<response.body.length ; i++){
			//     	var data =  response.body[i].createDate;
			//     	response.body[i].createDate = data.substr(0,10)
			//     }
			//     this.news = response.body;
			//   })
		},
		todetail: function todetail(id) {
			this.$router.push('/Newsdetail/' + id);
		}
	}
});

/***/ }),

/***/ "KZDr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aboutcom_culture_vue__ = __webpack_require__("n5dN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ebc29a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aboutcom_culture_vue__ = __webpack_require__("4tCc");
function injectStyle (ssrContext) {
  __webpack_require__("BTG/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aboutcom_culture_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ebc29a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aboutcom_culture_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LJlt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'zhaopin',
	data: function data() {
		return {
			img: [//配置图片，循环使用
			{ id: 0, imgsrc: 'static/img/zhaopin-z.png', imgsrcl: 'static/img/zhaopin-zl.png' }, { id: 1, imgsrc: 'static/img/zhaopin-c.png', imgsrcl: 'static/img/zhaopin-cl.png' }, { id: 2, imgsrc: 'static/img/zhaopin-x.png', imgsrcl: 'static/img/zhaopin-xl.png' }, { id: 3, imgsrc: 'static/img/zhaopin-y.png', imgsrcl: 'static/img/zhaopin-yl.png' }],
			choose: [
				// {id : 0 , imgsrc : 'static/img/zhaopin-z.png' , imgsrcl : 'static/img/zhaopin-zl.png' , name : '总经办'},
				// {id : 1 , imgsrc : 'static/img/zhaopin-c.png' , imgsrcl : 'static/img/zhaopin-cl.png' , name : '产品部'},
				// {id : 2 , imgsrc : 'static/img/zhaopin-x.png' , imgsrcl : 'static/img/zhaopin-xl.png' , name : '业务部'},
				// {id : 3 , imgsrc : 'static/img/zhaopin-y.png' , imgsrcl : 'static/img/zhaopin-yl.png' , name : '项目部'},
				// {id : 4 , imgsrc : 'static/img/zhaopin-z.png' , imgsrcl : 'static/img/zhaopin-zl.png' , name : '测试部门1'},
				// {id : 5 , imgsrc : 'static/img/zhaopin-c.png' , imgsrcl : 'static/img/zhaopin-cl.png' , name : '测试部门2'},
				// {id : 6 , imgsrc : 'static/img/zhaopin-x.png' , imgsrcl : 'static/img/zhaopin-xl.png' , name : '测试部门3'},
				// {id : 7 , imgsrc : 'static/img/zhaopin-y.png' , imgsrcl : 'static/img/zhaopin-yl.png' , name : '测试部门4'},
			],
			selid: 0, //选中的部门id
			conid: '', //选中的部门名称
			liid: 0, //当前展开的li序号，0为全部关闭
			zhiwei: [] //获取的招聘数据
		};
	},
	mounted: function mounted() {
		this.getzhaopin();
	},

	watch: {
		selid: function selid() {
			this.liid = 0;
			//this.getzhaopin()
		}
	},
	metaInfo: {
		title: '诚聘英才'
	},
	methods: {
		getzhaopin: function getzhaopin() {
			var _this = this;

			var that = this;
			this.$http.post('http://gd-sc.net:9092/api/GDSC_Job/getjob').then(function (response) {
				//this.$http.post('http://localhost:9090/api/GDSC_Job/getjob').then((response) => {
				//console.log(response.body)
				_this.zhiwei = response.body;
				//获取数据
				var pData = response.body;
				var pLength = pData.length;
				//获取部门并去掉重复
				var department = {};
				var depArr = [];
				for (var i = 0; i < pLength; i++) {
					department[pData[i].department] = pData[i].department;
				}
				for (var key in department) {
					depArr.push(key);
				}
				//生成choose
				var choose = [];
				for (var i = 0; i < depArr.length; i++) {
					var item = {};
					item.id = i;
					item.imgsrc = _this.img[i % _this.img.length].imgsrc;
					item.imgsrcl = _this.img[i % _this.img.length].imgsrcl;
					item.name = depArr[i];
					choose.push(item);
				}
				_this.choose = choose;
				//console.log(choose)

				//初始化截取前10位时间数据
				_this.conid = _this.choose[0].name;
				for (var i = 0; i < response.body.length; i++) {
					var data = response.body[i].createDate;
					response.body[i].createDate = data.substr(0, 10);
				}
			});
		},
		selclick: function selclick(id) {
			//点击选项后
			this.selid = id;
			this.conid = this.choose[id].name;
		},
		liclick: function liclick(id) {
			//console.log(id)
			if (id != this.liid) {
				this.liid = id;
			} else {
				this.liid = 0;
			}
		}
	}
});

/***/ }),

/***/ "LTJG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aboutcom_vue__ = __webpack_require__("j05s");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_446d8dea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aboutcom_vue__ = __webpack_require__("qIoi");
function injectStyle (ssrContext) {
  __webpack_require__("V7hX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aboutcom_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_446d8dea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aboutcom_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LmOv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bc84a3c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("yfWl");
function injectStyle (ssrContext) {
  __webpack_require__("nsKm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bc84a3c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_min_css__ = __webpack_require__("qb6w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_js_bootstrap_min__ = __webpack_require__("Bb4J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_js_bootstrap_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_js_bootstrap_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_index_css__ = __webpack_require__("tvR6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_resource__ = __webpack_require__("8+8L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_meta_info__ = __webpack_require__("5K15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_meta_info___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_meta_info__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.











__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_meta_info___default.a);
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]);
  },
  mounted: function mounted() {
    document.dispatchEvent(new Event('render-event'));
  }
  // template: '<App/>',
  // components: { App }

});

/***/ }),

/***/ "NTPD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/xihu.51120c1.jpg";

/***/ }),

/***/ "O5+O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "O76j":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lshy01.74bfdab.png";

/***/ }),

/***/ "ODHj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'aboutcom',
	data: function data() {
		return {
			top: [{ id: 0, imgsrc: 'static/img/aboutcom.jpg', title: '关于我们' }],
			center: [{ id: 0, imgsrc: 'static/img/aboutcom.jpg', title: '公司简介', smalltit: '专业的信息化服务商' }, { id: 1, imgsrc: 'static/img/aboutcom.jpg', title: '组织框架', smalltit: '专业的信息化服务商' }, { id: 2, imgsrc: 'static/img/aboutcom.jpg', title: '企业文化', smalltit: '专业的信息化服务商' }, { id: 3, imgsrc: 'static/img/aboutcom.jpg', title: '资质荣誉', smalltit: '专业的信息化服务商' }, { id: 4, imgsrc: 'static/img/aboutcom.jpg', title: '新闻资讯', smalltit: '专业的信息化服务商' }],
			chalid: 0,
			comimg: [{ id: 0, imgsrc: 'static/img/comabout1.jpg' }, { id: 1, imgsrc: 'static/img/comabout2.jpg' }],
			wenhua: [{ id: 0, wentit: '责任感', wencontent: '我们的企业要有社会责任感，我们的员工对公司、客户、家庭要勇于负责任' }, { id: 1, wentit: '团队精神', wencontent: '我们的企业是一个团队，每个员工都必须充分认可团队、依靠团队、配合 团队、才能形成一个有战斗力的队伍' }, { id: 2, wentit: '专业服务、技术创新', wencontent: '拥有专业的技术、良好的服务能力，展现IT行业的“工匠”精神' }, { id: 3, wentit: '管理的规范化与制度化', wencontent: '我们相信：企业的长远发展需要管理的规范化与运营的制度化' }, { id: 4, wentit: '勤劳、诚实、自信、超越自我的精神', wencontent: '我们希望我们的员工是一个勤奋、诚实可靠、有自信、勇于超越自我的人' }],
			honor: [{ id: 0, hoimg: 'static/img/zz1.jpg' }, { id: 1, hoimg: 'static/img/zz4.jpg' }, { id: 2, hoimg: 'static/img/zz5.jpg' }, { id: 3, hoimg: 'static/img/zz6.jpg' }, { id: 4, hoimg: 'static/img/zz7.jpg' }, { id: 5, hoimg: 'static/img/zz8.jpg' }, { id: 6, hoimg: 'static/img/zz9.jpg' }, { id: 7, hoimg: 'static/img/zz10.jpg' }],
			honorname: [{ id: 0, honame: '■ 计算机信息系统集成企业资质证书叁级' }, { id: 1, honame: '■ 广东省公共安全技术防范系统设计、施工、维修资格证（壹级）证书' }, { id: 2, honame: '■ 广东省涉密计算机、通信和办公自动化设备定点维护维修证书' }, { id: 3, honame: '■ 软件企业认定证书' }, { id: 4, honame: '■ ISO9001 2015质量管理体系认证证书' }, { id: 5, honame: '■ 高新技术企业证书' }, { id: 6, honame: '■ 音视频工程业企业资质贰级' }, { id: 7, honame: '■ 守合同重信用企业（连续九年）' }],
			scrollWatch: true
		};
	},
	mounted: function mounted() {
		this.getID();
	},

	metaInfo: {
		title: '联系我们'
	},
	methods: {
		getID: function getID() {
			this.chalid = this.$route.params.ID;
		}
	}
});

/***/ }),

/***/ "OIKr":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/salfout.43dc0cd.png";

/***/ }),

/***/ "OPlf":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/p6-2.5b85f86.jpg";

/***/ }),

/***/ "P/ir":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/p4-2.5f044b2.jpg";

/***/ }),

/***/ "P5Dz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('div',{staticClass:"footer"},[_c('div',{staticClass:"footer-left"},[_vm._l((_vm.foottit),function(tit){return _c('div',{staticClass:"left-li"},[_c('router-link',{attrs:{"to":tit.vuelink}},[_c('h4',[_vm._v(_vm._s(tit.name))])]),_vm._v(" "),_c('ul',_vm._l((_vm.footcontent[tit.id].content),function(con){return _c('li',{on:{"click":function($event){return _vm.gotop()}}},[_c('router-link',{attrs:{"to":con.vuelink}},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(con.name)+"\n\t\t\t\t\t\t")])],1)}),0)],1)}),_vm._v(" "),_c('div',{staticClass:"footer-line"})],2),_vm._v(" "),_c('div',{staticClass:"footer-right"},[_vm._l((_vm.secondimg),function(img){return _c('div',{staticClass:"right-img",class:img.id},[_c('img',{attrs:{"src":img.imgsrc}}),_vm._v(" "),_c('div',{staticClass:"right-tit"},[_c('p',[_vm._v("扫一扫")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(img.name))])])])}),_vm._v(" "),_vm._m(0)],2)]),_vm._v(" "),_c('div',{staticStyle:{"clear":"both"}}),_vm._v(" "),_c('div',{staticClass:"footer-lines"}),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"right-address"},[_c('p',[_vm._v("地址：惠州市江北云山西路2号帝景国际商务中心C座综合楼718-722室")]),_vm._v(" "),_c('p',[_vm._v("电话：0752-2123600")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-bottom"},[_c('div',{staticClass:"bottom-left"},[_c('p',[_vm._v("友情链接：广东思程科技有限公司 丨 广东思程科技 丨 广东思诚科技有限公司")])]),_vm._v(" "),_c('div',{staticClass:"bottom-right"},[_c('p',[_vm._v("Copyright © 广东思程科技有限公司. "),_c('a',{attrs:{"href":"https://beian.miit.gov.cn"}},[_vm._v("粤ICP备12073207号 ")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PaFw":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/p6-3.640fd8a.jpg";

/***/ }),

/***/ "PtSF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_technology_field_vue__ = __webpack_require__("hvxX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61fc6db4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_technology_field_vue__ = __webpack_require__("WZpi");
function injectStyle (ssrContext) {
  __webpack_require__("dnzX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_technology_field_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61fc6db4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_technology_field_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PwIh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_saltout_vue__ = __webpack_require__("acwo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6c9889e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_saltout_vue__ = __webpack_require__("T5Hf");
function injectStyle (ssrContext) {
  __webpack_require__("I29P")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_saltout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6c9889e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_saltout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QAtm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'aboutcom',
	data: function data() {
		return {
			top: [{ id: 0, imgsrc: 'static/img/aboutcom.jpg', title: '关于我们' }],
			chalid: 0,
			comimg: [{ id: 0, imgsrc: 'static/img/comabout1.jpg' }, { id: 1, imgsrc: 'static/img/comabout2.jpg' }],
			scrollWatch: true,
			newsdetail: []
		};
	},
	mounted: function mounted() {
		this.getID();
		this.getnews();
	},

	methods: {
		getID: function getID() {
			this.chalid = this.$route.params.ID;
		},
		getnews: function getnews() {
			var _this = this;

			var that = this;
			this.$http.post('http://www.gd-sc.net:9090', { table: 'news' }, { emulateJSON: true }).then(function (response) {
				for (var i = 0; i < response.body.length; i++) {
					var data = response.body[i].createDate;
					response.body[i].createDate = data.substr(0, 10);
				}
				_this.newsdetail = response.body;
			});
		},
		todetail: function todetail(id) {
			this.$router.push('/Newsdetail/' + id);
		}
	}
});

/***/ }),

/***/ "QbBv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'techonlogy-service',
	data: function data() {
		return {
			tech: [{ id: 0, imgsrc: '/static/img/fuwu.jpg', title: '服务领域' }, { id: 1, imgsrc: '/static/img/fuwu.jpg', title: '业务模式' }, { id: 2, imgsrc: '/static/img/fuwu.jpg', title: '技术领域' }],
			techimg: [{ id: 0, imgsrc: '/static/img/serve1 (1).png', smalltit: '系统集成' }, { id: 1, imgsrc: '/static/img/11serve1 (1).png', smalltit: '软件与数据服务' }, { id: 2, imgsrc: '/static/img/sc-soft-img2.png', smalltit: 'IT运维服务' }, { id: 3, imgsrc: '/static/img/serve1 (2).png', smalltit: '' }, { id: 4, imgsrc: '/static/img/serve1 (3).png', smalltit: '' }],
			yewu: [{ id: 0, imgsrc: '/static/img/yewumodx.png', smalltit: '项目建设' }, { id: 1, imgsrc: '/static/img/yewumodp.png', smalltit: '产品开发' }, { id: 2, imgsrc: '/static/img/yewumodz.png', smalltit: '项目合作运营' }],
			jishu: [{ id: 0, imgsrc: '/static/img/jsly.png', smalltit: '弱电+网络通讯' }, { id: 1, imgsrc: '/static/img/jsly2.png', smalltit: '数据与安全' }, { id: 2, imgsrc: '/static/img/jsly3.png', smalltit: '云技术' }, { id: 3, imgsrc: '/static/img/yewumodz.png', smalltit: '物联网' }, { id: 4, imgsrc: '/static/img/jsly4.png', smalltit: '应用软件' }],
			chalid: 0

		};
	},
	mounted: function mounted() {
		this.getID();
	},

	metaInfo: {
		title: '服务领域'
	},
	methods: {
		getID: function getID() {
			this.chalid = 0;
		}
	}
});

/***/ }),

/***/ "QfkK":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/shffbt2.c1a8965.png";

/***/ }),

/***/ "QvBD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/oa01.74bfdab.png";

/***/ }),

/***/ "QwJf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newsdetail_vue__ = __webpack_require__("QAtm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_789582a0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_newsdetail_vue__ = __webpack_require__("SZiH");
function injectStyle (ssrContext) {
  __webpack_require__("LmOv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newsdetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_789582a0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_newsdetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "S1Xg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'techonlogy-business',
	data: function data() {
		return {
			tech: [{ id: 0, imgsrc: '/static/img/fuwu.jpg', title: '服务领域' }, { id: 1, imgsrc: '/static/img/fuwu.jpg', title: '业务模式' }, { id: 2, imgsrc: '/static/img/fuwu.jpg', title: '技术领域' }],
			techimg: [{ id: 0, imgsrc: '/static/img/serve1 (1).png', smalltit: '系统集成' }, { id: 1, imgsrc: '/static/img/11serve1 (1).png', smalltit: '软件与数据服务' }, { id: 2, imgsrc: '/static/img/sc-soft-img2.png', smalltit: 'IT运维服务' }, { id: 3, imgsrc: '/static/img/serve1 (2).png', smalltit: '' }, { id: 4, imgsrc: '/static/img/serve1 (3).png', smalltit: '' }],
			yewu: [{ id: 0, imgsrc: '/static/img/yewumodx.png', smalltit: '项目建设' }, { id: 1, imgsrc: '/static/img/yewumodp.png', smalltit: '产品开发' }, { id: 2, imgsrc: '/static/img/yewumodz.png', smalltit: '项目合作运营' }],
			jishu: [{ id: 0, imgsrc: '/static/img/jsly.png', smalltit: '弱电+网络通讯' }, { id: 1, imgsrc: '/static/img/jsly2.png', smalltit: '数据与安全' }, { id: 2, imgsrc: '/static/img/jsly3.png', smalltit: '云技术' }, { id: 3, imgsrc: '/static/img/yewumodz.png', smalltit: '物联网' }, { id: 4, imgsrc: '/static/img/jsly4.png', smalltit: '应用软件' }],
			chalid: 0

		};
	},
	mounted: function mounted() {
		this.getID();
	},

	metaInfo: {
		title: '业务模式'
	},
	methods: {
		getID: function getID() {
			this.chalid = 1;
		}
	}
});

/***/ }),

/***/ "SEiT":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/p4-3.53da9e8.jpg";

/***/ }),

/***/ "SRNm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"dddd"},[_c('div',{staticClass:"carousel slide",attrs:{"id":"myCarousel","data-interval":"4000"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"carousel-inner"},[_c('div',{staticClass:"item active"},[_c('router-link',{attrs:{"to":_vm.vuelink[0].vuelink}},[_c('img',{attrs:{"src":__webpack_require__("4zYS"),"alt":"First slide"}})])],1),_vm._v(" "),_c('div',{staticClass:"item"},[_c('router-link',{attrs:{"to":_vm.vuelink[1].vuelink}},[_c('img',{attrs:{"src":__webpack_require__("6ce3"),"alt":"Second slide"}})])],1),_vm._v(" "),_c('div',{staticClass:"item"},[_c('router-link',{attrs:{"to":_vm.vuelink[2].vuelink}},[_c('img',{attrs:{"src":__webpack_require__("2gso"),"alt":"Third slide"}})])],1),_vm._v(" "),_c('div',{staticClass:"item"},[_c('router-link',{attrs:{"to":_vm.vuelink[3].vuelink}},[_c('img',{attrs:{"src":__webpack_require__("h5FS"),"alt":"Third slide"}})])],1),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('a',{staticClass:"carousel-control left",attrs:{"href":"#myCarousel","data-slide":"prev"}},[_vm._v("‹\n    ")]),_vm._v(" "),_c('a',{staticClass:"carousel-control right",attrs:{"href":"#myCarousel","data-slide":"next"}},[_vm._v("›\n    ")])])]),_vm._v(" "),_c('div',{staticClass:"hserver"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"server-content"},_vm._l((_vm.img),function(item,index){return _c('div',{staticClass:"content-detail"},[_c('div',{staticClass:"limitimg"},[_c('img',{staticClass:"backimg",attrs:{"src":item.imgsrc}}),_vm._v(" "),_c('transition',{attrs:{"name":"slide-fadey"}},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"iconimg",attrs:{"src":_vm.imgicon[index].imgsrc}})]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-fadey"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"imgdetail"},[_c('h3',[_vm._v(_vm._s(_vm.imgicon[index].detailtit))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.imgicon[index].detailen))])])])],1)])}),0)]),_vm._v(" "),_c('div',{staticClass:"solvecase"},[_vm._m(3),_vm._v(" "),_c('el-carousel',{attrs:{"interval":4000,"type":"card","height":"600px"},on:{"change":function($event){return _vm.getin($event)}}},_vm._l((_vm.solvelist),function(solve,index){return _c('el-carousel-item',{key:index,class:{solvesmaitem : solve.id != _vm.swipeindex}},[_c('div',{staticClass:"solve-topop",class:{solvesmatop : solve.id != _vm.swipeindex}},[(solve.id != _vm.swipeindex)?_c('img',{class:{noneimg : solve.id != _vm.swipeindex},attrs:{"src":solve.imgsrc}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"solsma-tit",class:{noneac : solve.id != _vm.swipeindex}},[_c('h3',{class:{noneach3 : solve.id != _vm.swipeindex}},[_vm._v(_vm._s(solve.tit))])]),_vm._v(" "),_c('div',{staticClass:"solsma-icon",class:{noneacic : solve.id != _vm.swipeindex}},[(solve.id == _vm.swipeindex)?_c('img',{attrs:{"src":solve.imgsrc}}):_vm._e(),_vm._v(" "),_c('p',{class:{noneacp : solve.id != _vm.swipeindex}},[_vm._v(_vm._s(solve.content))])])]),_vm._v(" "),_c('div',{staticClass:"solsma-bottom"},[_c('p',[_c('b',[_vm._v(_vm._s(solve.fottit))])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(solve.fotstit))]),_vm._v(" "),_c('p',[_c('b',[_vm._v(_vm._s(solve.fotttit))])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(solve.fotftit))])]),_vm._v(" "),_c('div',{staticClass:"solsma-footer"},[_c('router-link',{attrs:{"to":_vm.falink[0].falink}},[_c('el-button',{on:{"click":function($event){return _vm.gotop()}}},[_vm._v("MORE")])],1)],1)])}),1)],1),_vm._v(" "),_c('div',{staticClass:"product"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"pro-detail"},_vm._l((_vm.detail),function(item,index){return _c('div',{staticClass:"detail-pro",on:{"mouseover":function($event){$event.stopPropagation();return _vm.getheight(item.id)},"mouseout":function($event){$event.stopPropagation();return _vm.outbac()},"click":function($event){return _vm.topro(item.prolink)}}},[_c('img',{attrs:{"src":item.imgsrc}}),_vm._v(" "),_c('transition',{attrs:{"name":"slide-fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.bacshow == item.id),expression:"bacshow == item.id"}],staticClass:"change-pro"},[_c('img',{staticClass:"pro-image",attrs:{"src":_vm.iconb[index].imgsrc}}),_vm._v(" "),_c('div',{staticClass:"pro-p",style:({width : _vm.width})},[_c('router-link',{attrs:{"to":""}},[_c('p',[_vm._v(_vm._s(_vm.iconb[index].content))])])],1),_vm._v(" "),_c('div',{staticClass:"back-pro",style:({height : _vm.height})})])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-fadex"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.bacshow == 0 || _vm.bacshow != item.id),expression:"bacshow == 0 || bacshow != item.id"}],staticClass:"change-pro"},[_c('img',{staticClass:"pro-image",attrs:{"src":_vm.iconb[index].imgsrc}}),_vm._v(" "),_c('div',{staticClass:"pro-line"},[_c('h3',[_vm._v(_vm._s(_vm.iconb[index].tit))])]),_vm._v(" "),_c('div',{staticClass:"back-pro black",style:({height : _vm.height})})])])],1)}),0)]),_vm._v(" "),_c('div',{staticClass:"news"},[_c('div',{staticClass:"sanjiao"}),_vm._v(" "),_c('div',{staticClass:"newscon"},[_c('div',{staticClass:"comlist"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"comswindows"},_vm._l((_vm.windows),function(win){return _c('div',{staticClass:"windowslist",on:{"click":function($event){return _vm.routerto(win.imglink)}}},[_c('img',{staticClass:"winlist",attrs:{"src":win.imgsrc}}),_vm._v(" "),_c('div',{staticClass:"comsbottom"},[_c('div',{staticClass:"com-p"},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(win.winname)+"\t\t\t\t\n\t   \t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"com-bac"})])])}),0)]),_vm._v(" "),_c('div',{staticClass:"newslist"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"newsli"},[_c('ul',_vm._l((_vm.news),function(newsli){return _c('li',{on:{"click":function($event){return _vm.todetail(newsli.ID)}}},[_vm._v(_vm._s(newsli.title)+"\n\t   \t\t\t\t"),_c('div',{staticClass:"lidata"},[_vm._v("\n\t   \t\t\t\t\t"+_vm._s(newsli.createDate)+"\n\t   \t\t\t\t")])])}),0)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"carousel-indicators"},[_c('li',{staticClass:"active",attrs:{"data-target":"#myCarousel","data-slide-to":"0"}}),_vm._v(" "),_c('li',{attrs:{"data-target":"#myCarousel","data-slide-to":"1"}}),_vm._v(" "),_c('li',{attrs:{"data-target":"#myCarousel","data-slide-to":"2"}}),_vm._v(" "),_c('li',{attrs:{"data-target":"#myCarousel","data-slide-to":"3"}}),_vm._v(" "),_c('li',{attrs:{"data-target":"#myCarousel","data-slide-to":"4"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item"},[_c('img',{attrs:{"src":__webpack_require__("1Q6r"),"alt":"Third slide"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"server-tit"},[_c('h4',[_vm._v("服务领域")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"server-tit"},[_c('h4',[_vm._v("专业解决方案")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"server-tit"},[_c('h4',[_vm._v("我们的产品")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comstit"},[_c('span',[_vm._v("快速导航           INTRODUCTION")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comstit"},[_c('span',[_vm._v("新闻中心           NEWS CENTER")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SVvk":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/shff.24741d1.png";

/***/ }),

/***/ "SZiH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aboutcom"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"com-detail"},[_vm._m(1),_vm._v(" "),_vm._l((_vm.newsdetail),function(news){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(news.ID == _vm.chalid ),expression:"news.ID == chalid "}]},[_c('div',{staticClass:"newsdetailtit"},[_c('h4',[_vm._v(_vm._s(news.title))])]),_vm._v(" "),_c('div',{staticClass:"newsdetailcontent",domProps:{"innerHTML":_vm._s(news.content)}},[_vm._v("\n            \t\t"+_vm._s(news.content)+"\n            \t")])])})],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comtop"},[_c('img',{attrs:{"src":__webpack_require__("sdn1")}}),_vm._v(" "),_c('div',{staticClass:"com-titr"},[_c('span',[_c('img',{attrs:{"src":__webpack_require__("HriX")}}),_c('b',[_vm._v("新闻中心")])]),_vm._v(" "),_c('p',[_vm._v("专业的IT解决方案服务商。主要从事于计算机系统集成、软件开发、IT运"),_c('br'),_vm._v("\n维服务等业务，服务于 政府、学校、医疗、生产企业等行业。")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"com-top-top"},[_c('h4',[_vm._v("公司动态")]),_vm._v(" "),_c('div',{staticClass:"com-line"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SgA3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'case',
	data: function data() {
		return {
			top: [{ id: 0, imgsrc: 'static/img/casetoop.jpg', title: '关于我们' }],
			center: [{ id: 0, imgsrc: 'static/img/casetoop.jpg', title: '公司简介', smalltit: '专业的信息化服务商' }, { id: 1, imgsrc: 'static/img/casetoop.jpg', title: '组织框架', smalltit: '专业的信息化服务商' }, { id: 2, imgsrc: 'static/img/casetoop.jpg', title: '企业文化', smalltit: '专业的信息化服务商' }, { id: 3, imgsrc: 'static/img/casetoop.jpg', title: '资质荣誉', smalltit: '专业的信息化服务商' }, { id: 4, imgsrc: 'static/img/casetoop.jpg', title: '新闻资讯', smalltit: '专业的信息化服务商' }],
			chalid: 0,
			navli: [{ id: 0, litit: '服务事业单位 ' }, { id: 1, litit: '房地产 ' }, { id: 2, litit: '政府 ' }, { id: 3, litit: '旅游 ' }, { id: 4, litit: '传媒 ' }, { id: 5, litit: '律师 ' }, { id: 6, litit: '教育 ' }, { id: 7, litit: '医疗 ' }],
			scrollWatch: true,
			lijudge: 0,
			selid: 0
		};
	},
	mounted: function mounted() {
		this.getID();
	},

	metaInfo: {
		title: '案例展示',
		meta: [{
			name: 'keyWords',
			content: '服务事业单位，房地产，政府，旅游，传媒，律师，教育，医疗'
		}, {
			name: "description",
			content: "服务事业单位，房地产，政府，旅游，传媒，律师，教育，医疗"
		}]
	},
	methods: {
		getID: function getID() {
			this.chalid = this.$route.params.ID;
		},
		seltab: function seltab(index) {
			this.lijudge = index;
		}
	}
});

/***/ }),

/***/ "T5Hf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aboutcom"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"com-detail"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"cominfo"},[_c('h4',{staticClass:"small-tit"},[_vm._v("售后服务")]),_vm._v(" "),_c('p',{staticClass:"com-content"},[_vm._v(" 广东思程科技有限公司作为一家专业从事软件开发、系统集成和技术服务的专业IT服务公司。思程拥有专业 的售后服务团队，秉承“优质、高效，用心服务”的服务理念，不断提高客户的满意度。")]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v("服务方式")]),_vm._v(" "),_c('center',[_c('img',{staticStyle:{"margin-top":"60px"},attrs:{"src":__webpack_require__("cnrs")}}),_c('br'),_vm._v(" "),_c('img',{staticStyle:{"margin-top":"10px","margin-bottom":"20px"},attrs:{"src":__webpack_require__("x2i3")}}),_c('br'),_vm._v(" "),_c('img',{staticStyle:{"margin-bottom":"20px"},attrs:{"src":__webpack_require__("QfkK")}}),_c('br'),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("SVvk")}})])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comtop"},[_c('img',{attrs:{"src":__webpack_require__("OIKr")}}),_vm._v(" "),_c('div',{staticClass:"bannerMask"},[_c('div')]),_vm._v(" "),_c('div',{staticClass:"com-titr"},[_c('span',[_c('img',{attrs:{"src":__webpack_require__("uPfT")}}),_c('b',[_vm._v("售后服务")])]),_vm._v(" "),_c('p',[_vm._v("拥有专业的售后服务团队，秉承“优质、高效，用心服务”的"),_c('br'),_vm._v("\n服务理念，不断提高客户的满意度")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"com-top-top"},[_c('h4',[_vm._v("售后服务")]),_vm._v(" "),_c('div',{staticClass:"com-line"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TNcm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TPnO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_case_vue__ = __webpack_require__("SgA3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6339f8db_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_case_vue__ = __webpack_require__("1go9");
function injectStyle (ssrContext) {
  __webpack_require__("5dzJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_case_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6339f8db_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_case_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TQH0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TkMI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V7hX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VrY+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zhaopinicon.ecfe333.png";

/***/ }),

/***/ "W/u7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WZpi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"techonlogy"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"tech-detail"},[_c('div',{staticClass:"tech-top-top"},[_c('h4',[_vm._v(_vm._s(_vm.tech[_vm.chalid].title))]),_vm._v(" "),_c('div',{staticClass:"tech-line"})]),_vm._v(" "),(_vm.chalid == 0 )?_c('div',{staticClass:"techinfo"},[_c('p',{staticClass:"com-content"},[_vm._v(" 公司服务领域分为三大块：")]),_vm._v(" "),_c('div',{staticClass:"tech-singleimg"},[_c('img',{attrs:{"src":_vm.techimg[0].imgsrc}})]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.techimg[0].smalltit))]),_vm._v(" "),_c('p',[_vm._v("系统集成（SI，System Integration），我们在系统工程科学方法的指导下，经过专业技术的不断进步和多年施 工经验的积累，能为您提供智能弱电系统\n\t\t\t\t\t\t集成、网络安全系统集成、数据中心与云平台等三大项目和20个子系统的专业服务。\n\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"tech-singleimg"},[_c('img',{attrs:{"src":_vm.techimg[1].imgsrc}})]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.techimg[1].smalltit))]),_vm._v(" "),_c('p',[_vm._v("软件与数据服务（Software and data services），思程科技是以自主知识产权产品开发为核心的双软企业，我公司采用了CMMI管理模式体系以及国际上先进、成熟的开发工具和语言，开发了许多满足客户实际需求的应用软件。\n\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"tech-singleimg"},[_c('img',{attrs:{"src":_vm.techimg[2].imgsrc}})]),_vm._v(" "),_c('p',[_vm._v("软件（SAAS）即服务是行业的发展趋势，提供应用类的软件服务是公司的发展方向，公司以软件开发为基础，向用户提供全方向的信息化业务方案\n\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"tech-singleimg"},[_c('img',{attrs:{"src":_vm.techimg[3].imgsrc}})]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.techimg[2].smalltit))]),_vm._v(" "),_c('p',[_vm._v("IT运维服务 (IT operation and maintenance services) ，思程科技以专业的技术力量和运维团队为客户提 供IT领域全面的咨询、实施、运维、迁移、培训五大类服务。\n\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"tech-singleimg"},[_c('img',{attrs:{"src":_vm.techimg[4].imgsrc}})])]):_vm._e(),_vm._v(" "),(_vm.chalid == 1 )?_c('div',{staticClass:"techinfo"},[_c('p',{staticClass:"com-content"},[_vm._v(" 公司以信息化技术为基础，深入行业需求，服务于各行业，以提供相关行业的信息化解决方案为整体方向，以项目建设、产品开发、项目运营等形式拓展业务。")]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.yewu[0].smalltit))]),_vm._v(" "),_c('p',[_vm._v("由专业的信息化项目经理落实项目建设，全程项目监管勘查、设计、施工、维护")]),_vm._v(" "),_c('div',{staticClass:"tech-singleimg"},[_c('img',{staticStyle:{"width":"35%"},attrs:{"src":_vm.yewu[0].imgsrc}})]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.yewu[1].smalltit))]),_vm._v(" "),_c('p',[_vm._v("以市场需求为导向，结合相关的行业经验，公司不断推进产品开发工作，以优质产品赢取市场。\n\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"tech-singleimg"},[_c('img',{attrs:{"src":_vm.yewu[1].imgsrc}})]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.yewu[2].smalltit))]),_vm._v(" "),_c('p',[_vm._v("根据用户的业务需求，发挥公司的技术优势与资本能力，承担相关的信息化建设并负责具体运营，达到共赢的目的。\n\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"tech-singleimg"},[_c('img',{staticStyle:{"width":"36%"},attrs:{"src":_vm.yewu[2].imgsrc}})])]):_vm._e(),_vm._v(" "),(_vm.chalid == 2 )?_c('div',{staticClass:"techinfo"},[_c('p',{staticClass:"com-content"},[_vm._v(" 公司主要涉及的技术领域有（1）弱电+网络通讯（2）数据与安全（3）云技术（4）物联网（5）应用软件")]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.jishu[0].smalltit))]),_vm._v(" "),_c('div',{staticClass:"tech-singleimg"},[_c('img',{staticStyle:{"width":"45%"},attrs:{"src":_vm.jishu[0].imgsrc}})]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.jishu[1].smalltit))]),_vm._v(" "),_c('div',{staticClass:"tech-singleimg"},[_c('img',{staticStyle:{"width":"60%"},attrs:{"src":_vm.jishu[1].imgsrc}})]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.jishu[2].smalltit))]),_vm._v(" "),_c('div',{staticClass:"tech-singleimg"},[_c('img',{staticStyle:{"width":"60%"},attrs:{"src":_vm.jishu[2].imgsrc}})]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.jishu[3].smalltit))]),_vm._v(" "),_c('p',{staticClass:"com-content"},[_vm._v(" 顾名思义，物联网就是物物相连的互联网。这有两层意思：其一，物联网的核心和基础仍然是互联网，是在互\n\t\t\t\t\t联网基础上的延伸和扩展的网络；其二，其用户端延伸和扩展到了任何物品与物品之间，进行信息交换和通信，也就\n\t\t\t\t\t是物物相息。物联网通过智能感知、识别技术与普适计算等通信感知技术，广泛应用于网络的融合中，也因此被称\n\t\t\t\t\t为继计算机、互联网之后世界信息产业发展的第三次浪潮。物联网是互联网的应用拓展，与其说物联网是网络，不\n\t\t\t\t\t如说物联网是业务和应用。因此，应用创新是物联网发展的核心，以用户体验为核心的创新2.0是物联网发展的灵魂。\n\t\t\t\t\t")]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.jishu[4].smalltit))]),_vm._v(" "),_c('p',{staticClass:"com-content"},[_vm._v(" 应用软件开发，思程科技是以自主知识产权产品开发为核心的双软企业，我司采用了CMMI管理模式体系\n\t\t\t\t\t以上国际上先进、成熟的开发工具和语言，开发了许多满足客户实际需求的应用软件，应用于政府、民政、医疗、金融等各行业，用户反应良好。\n\t\t\t\t\t")]),_vm._v(" "),_c('p',{staticClass:"com-content"},[_vm._v(" 思程科技的软件研发团队是由一批技术能力强、项目经验丰富的软件人才组成，具有多元化的技术路线，涵盖各主流开发\n\t\t\t\t\t\t语言，在.net和JAVA方面都有着丰富的项目和产品开发经验\n\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"tech-singleimg"},[_c('img',{attrs:{"src":_vm.jishu[4].imgsrc}})])]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"techonlogy-top"},[_c('img',{attrs:{"src":"/static/img/fuwu.jpg"}}),_vm._v(" "),_c('div',{staticClass:"bannerMask"},[_c('div')]),_vm._v(" "),_c('div',{staticClass:"com-tit"},[_c('span',[_c('img',{attrs:{"src":"/static/img/fuwuicon.png"}}),_c('b',[_vm._v("业务中心")])]),_vm._v(" "),_c('p',[_vm._v("致力于为政府、学校、医疗、公共事业、生产企业等各行业提"),_c('br'),_vm._v("\n供专业的信息化服务")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WdB6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/znzh01.774616f.png";

/***/ }),

/***/ "XWwE":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/chuanmei.e188ae9.jpg";

/***/ }),

/***/ "XxfM":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ding3.52414f8.png";

/***/ }),

/***/ "YB8v":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/p3-2.eab7272.jpg";

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home__ = __webpack_require__("wUZA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_zhaopin__ = __webpack_require__("Cw7/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_aboutcom__ = __webpack_require__("LTJG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_technology__ = __webpack_require__("bvwA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_solve__ = __webpack_require__("2IqB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_product__ = __webpack_require__("u+Fy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_saltout__ = __webpack_require__("PwIh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_contactu__ = __webpack_require__("dZe8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_case__ = __webpack_require__("TPnO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_newsdetail__ = __webpack_require__("QwJf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_aboutcom_aboutcom_culture_vue__ = __webpack_require__("KZDr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_aboutcom_aboutcom_honor_vue__ = __webpack_require__("y7Yn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_aboutcom_aboutcom_info_vue__ = __webpack_require__("iT0j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_aboutcom_aboutcom_news_vue__ = __webpack_require__("oTfL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_aboutcom_aboutcom_org_vue__ = __webpack_require__("rwbt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_technology_technology_business_vue__ = __webpack_require__("tLzu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_technology_technology_field_vue__ = __webpack_require__("PtSF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_technology_technology_service_vue__ = __webpack_require__("IL2k");























__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_home__["a" /* default */]
  }, {
    path: '/Zhaopin',
    name: 'Zhaopin',
    component: __WEBPACK_IMPORTED_MODULE_3__components_zhaopin__["a" /* default */]
  }, {
    path: '/Aboutcom/:ID',
    name: 'Aboutcom',
    component: __WEBPACK_IMPORTED_MODULE_4__components_aboutcom__["a" /* default */]
  }, {
    path: '/AboutcomCulture',
    name: 'AboutcomCulture',
    component: __WEBPACK_IMPORTED_MODULE_12__components_aboutcom_aboutcom_culture_vue__["a" /* default */]
  }, {
    path: '/AboutcomHonor',
    name: 'AboutcomHonor',
    component: __WEBPACK_IMPORTED_MODULE_13__components_aboutcom_aboutcom_honor_vue__["a" /* default */]
  }, {
    path: '/AboutcomInfo',
    name: 'AboutcomInfo',
    component: __WEBPACK_IMPORTED_MODULE_14__components_aboutcom_aboutcom_info_vue__["a" /* default */]
  }, {
    path: '/AboutcomNews',
    name: 'AboutcomNews',
    component: __WEBPACK_IMPORTED_MODULE_15__components_aboutcom_aboutcom_news_vue__["a" /* default */]
  }, {
    path: '/AboutcomOrg',
    name: 'AboutcomOrg',
    component: __WEBPACK_IMPORTED_MODULE_16__components_aboutcom_aboutcom_org_vue__["a" /* default */]
  }, {
    path: '/Technology/:ID',
    name: 'Technology',
    component: __WEBPACK_IMPORTED_MODULE_5__components_technology__["a" /* default */]
  }, {
    path: '/TechnologyBusiness',
    name: 'TechnologyBusiness',
    component: __WEBPACK_IMPORTED_MODULE_17__components_technology_technology_business_vue__["a" /* default */]
  }, {
    path: '/TechnologyField',
    name: 'TechnologyField',
    component: __WEBPACK_IMPORTED_MODULE_18__components_technology_technology_field_vue__["a" /* default */]
  }, {
    path: '/TechnologyService',
    name: 'TechnologyService',
    component: __WEBPACK_IMPORTED_MODULE_19__components_technology_technology_service_vue__["a" /* default */]
  }, {
    path: '/Solve/:ID',
    name: 'Solve',
    component: __WEBPACK_IMPORTED_MODULE_6__components_solve__["a" /* default */]
  }, {
    path: '/Solve',
    name: 'Solve',
    component: __WEBPACK_IMPORTED_MODULE_6__components_solve__["a" /* default */]
  }, {
    path: '/Product/:ID',
    name: 'Product',
    component: __WEBPACK_IMPORTED_MODULE_7__components_product__["a" /* default */]
  }, {
    path: '/Product/',
    name: 'Product',
    component: __WEBPACK_IMPORTED_MODULE_7__components_product__["a" /* default */]
  }, {
    path: '/Saltout',
    name: 'Saltout',
    component: __WEBPACK_IMPORTED_MODULE_8__components_saltout__["a" /* default */]
  }, {
    path: '/Contactu',
    name: 'Contactu',
    component: __WEBPACK_IMPORTED_MODULE_9__components_contactu__["a" /* default */]
  }, {
    path: '/Case',
    name: 'Case',
    component: __WEBPACK_IMPORTED_MODULE_10__components_case__["a" /* default */]
  }, {
    path: '/Newsdetail/:ID',
    name: 'Newsdetail',
    component: __WEBPACK_IMPORTED_MODULE_11__components_newsdetail__["a" /* default */]
  }]
}));

/***/ }),

/***/ "YpdP":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo2.e635d0b.png";

/***/ }),

/***/ "aH5q":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/p8-1.ca7f000.jpg";

/***/ }),

/***/ "acwo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'aboutcom',
	data: function data() {
		return {
			top: [{ id: 0, imgsrc: 'static/img/aboutcom.jpg', title: '关于我们' }],
			center: [{ id: 0, imgsrc: 'static/img/aboutcom.jpg', title: '公司简介', smalltit: '专业的信息化服务商' }, { id: 1, imgsrc: 'static/img/aboutcom.jpg', title: '组织框架', smalltit: '专业的信息化服务商' }, { id: 2, imgsrc: 'static/img/aboutcom.jpg', title: '企业文化', smalltit: '专业的信息化服务商' }, { id: 3, imgsrc: 'static/img/aboutcom.jpg', title: '资质荣誉', smalltit: '专业的信息化服务商' }, { id: 4, imgsrc: 'static/img/aboutcom.jpg', title: '新闻资讯', smalltit: '专业的信息化服务商' }],
			chalid: 0,
			comimg: [{ id: 0, imgsrc: 'static/img/comabout1.jpg' }, { id: 1, imgsrc: 'static/img/comabout2.jpg' }],
			wenhua: [{ id: 0, wentit: '责任感', wencontent: '我们的企业要有社会责任感，我们的员工对公司、客户、家庭要勇于负责任' }, { id: 1, wentit: '团队精神', wencontent: '我们的企业是一个团队，每个员工都必须充分认可团队、依靠团队、配合 团队、才能形成一个有战斗力的队伍' }, { id: 2, wentit: '专业服务、技术创新', wencontent: '拥有专业的技术、良好的服务能力，展现IT行业的“工匠”精神' }, { id: 3, wentit: '管理的规范化与制度化', wencontent: '我们相信：企业的长远发展需要管理的规范化与运营的制度化' }, { id: 4, wentit: '勤劳、诚实、自信、超越自我的精神', wencontent: '我们希望我们的员工是一个勤奋、诚实可靠、有自信、勇于超越自我的人' }],
			honor: [{ id: 0, hoimg: 'static/img/zz1.jpg' }, { id: 1, hoimg: 'static/img/zz4.jpg' }, { id: 2, hoimg: 'static/img/zz5.jpg' }, { id: 3, hoimg: 'static/img/zz6.jpg' }, { id: 4, hoimg: 'static/img/zz7.jpg' }, { id: 5, hoimg: 'static/img/zz8.jpg' }, { id: 6, hoimg: 'static/img/zz9.jpg' }, { id: 7, hoimg: 'static/img/zz10.jpg' }],
			honorname: [{ id: 0, honame: '■ 计算机信息系统集成企业资质证书叁级' }, { id: 1, honame: '■ 广东省公共安全技术防范系统设计、施工、维修资格证（壹级）证书' }, { id: 2, honame: '■ 广东省涉密计算机、通信和办公自动化设备定点维护维修证书' }, { id: 3, honame: '■ 软件企业认定证书' }, { id: 4, honame: '■ ISO9001 2015质量管理体系认证证书' }, { id: 5, honame: '■ 高新技术企业证书' }, { id: 6, honame: '■ 音视频工程业企业资质贰级' }, { id: 7, honame: '■ 守合同重信用企业（连续九年）' }],
			scrollWatch: true
		};
	},
	mounted: function mounted() {
		this.getID();
	},

	metaInfo: {
		title: '售后服务'
	},
	methods: {
		getID: function getID() {
			this.chalid = this.$route.params.ID;
		}
	}
});

/***/ }),

/***/ "bjI8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bvwA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_technology_vue__ = __webpack_require__("7mG0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_016f1c14_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_technology_vue__ = __webpack_require__("yc8Y");
function injectStyle (ssrContext) {
  __webpack_require__("1DlP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_technology_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_016f1c14_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_technology_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ce18":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'vfooter',
	data: function data() {
		return {
			foottit: [{ id: 0, name: '关于思程', vuelink: '/AboutcomInfo/' }, { id: 1, name: '业务中心', vuelink: '/TechnologyService/' }, { id: 2, name: '解决方案', vuelink: '/Solve/' + 0 }, { id: 3, name: '案例展示', vuelink: '/Case/' }, { id: 4, name: '我们的产品', vuelink: '/Product/' + 0 }],
			footcontent: [{ content: [{ name: '公司简介', vuelink: '/AboutcomInfo' }, { name: '组织框架', vuelink: '/AboutcomOrg' }, { name: '企业文化', vuelink: '/AboutcomCulture' }, { name: '资质荣誉', vuelink: '/AboutcomHonor' }, { name: '新闻资讯', vuelink: '/AboutcomNews' }] }, { content: [{ name: '服务领域', vuelink: '/TechnologyService' }, { name: '业务模式', vuelink: '/TechnologyBusiness' }, { name: '技术领域', vuelink: '/TechnologyField' }] }, { content: [{ name: '解决方案', vuelink: '/Solve/' }] }, { content: [{ name: '案例展示', vuelink: '/Case/' }] }, { content: [{ name: '我们的产品', vuelink: '/Product/' }] }],
			secondimg: [{ id: 0, imgsrc: '/static/img/2wm_wx.png', name: '思程微信公众号' }, { id: 1, imgsrc: '/static/img/2wm_gs.png', name: '思程手机官网' }]
		};
	},

	methods: {
		gotop: function gotop() {
			window.scrollTo(0, 0);
		}
	}
});

/***/ }),

/***/ "cnrs":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/shffbt.69b0e75.png";

/***/ }),

/***/ "d8wd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'aboutcom-news',
	data: function data() {
		return {
			top: [{ id: 0, imgsrc: '/static/img/aboutcom.jpg', title: '关于我们' }],
			center: [{ id: 0, imgsrc: '/static/img/aboutcom.jpg', title: '公司简介', smalltit: '专业的信息化服务商' }, { id: 1, imgsrc: '/static/img/aboutcom.jpg', title: '组织框架', smalltit: '专业的信息化服务商' }, { id: 2, imgsrc: '/static/img/aboutcom.jpg', title: '企业文化', smalltit: '专业的信息化服务商' }, { id: 3, imgsrc: '/static/img/aboutcom.jpg', title: '资质荣誉', smalltit: '专业的信息化服务商' }, { id: 4, imgsrc: '/static/img/aboutcom.jpg', title: '新闻资讯', smalltit: '专业的信息化服务商' }],
			chalid: 0,
			comimg: [{ id: 0, imgsrc: '/static/img/comabout1.jpg' }, { id: 1, imgsrc: '/static/img/comabout2.jpg' }],
			news: [],
			wenhua: [{ id: 0, wentit: '责任感', wencontent: '我们的企业要有社会责任感，我们的员工对公司、客户、家庭要勇于负责任' }, { id: 1, wentit: '团队精神', wencontent: '我们的企业是一个团队，每个员工都必须充分认可团队、依靠团队、配合 团队、才能形成一个有战斗力的队伍' }, { id: 2, wentit: '专业服务、技术创新', wencontent: '拥有专业的技术、良好的服务能力，展现IT行业的“工匠”精神' }, { id: 3, wentit: '管理的规范化与制度化', wencontent: '我们相信：企业的长远发展需要管理的规范化与运营的制度化' }, { id: 4, wentit: '勤劳、诚实、自信、超越自我的精神', wencontent: '我们希望我们的员工是一个勤奋、诚实可靠、有自信、勇于超越自我的人' }],
			honor: [{ id: 0, hoimg: '/static/img/zz1.jpg', honame: '■ 计算机信息系统集成企业资质证书叁级' }, { id: 1, hoimg: '/static/img/zz13.jpg', honame: '■ 广东省安全技术防范系统设计、施工、维修资格证（壹级）证书' }, { id: 2, hoimg: '/static/img/zz5.jpg', honame: '■ 广东省涉密计算机、通信和办公自动化设备定点维护维修证书' }, { id: 3, hoimg: '/static/img/zz6.jpg', honame: '■ 软件企业认定证书' }, { id: 4, hoimg: '/static/img/zz12.jpg', honame: '■ 质量管理体系认证证书' }, { id: 5, hoimg: '/static/img/zz14.jpg', honame: '■ 高新技术企业证书' }, { id: 6, hoimg: '/static/img/zz9.jpg', honame: '■ 音视频工程业企业资质贰级' }, { id: 7, hoimg: '/static/img/zz11.jpg', honame: '■ 守合同重信用企业（连续十二年）' }, { id: 8, hoimg: '/static/img/zz15.jpg', honame: '■ 信息技术服务管理体系认证证书' }, { id: 9, hoimg: '/static/img/zz16.jpg', honame: '■ 环境管理体系认证证书' }, { id: 10, hoimg: '/static/img/zz17.jpg', honame: '■ 职业健康安全管理体系认证证书' }, { id: 11, hoimg: '/static/img/zz18.jpg', honame: '■ 电子与智能化工程专业承包贰级' }, { id: 12, hoimg: '/static/img/zz19.jpg', honame: '■ 安全生产许可证' }],
			honorname: [{ id: 0, honame: '■ 计算机信息系统集成企业资质证书叁级' }, { id: 1, honame: '■ 广东省安全技术防范系统设计、施工、维修资格证（壹级）证书' }, { id: 2, honame: '■ 广东省涉密计算机、通信和办公自动化设备定点维护维修证书' }, { id: 3, honame: '■ 软件企业认定证书' }, { id: 4, honame: '■ ISO9001 2020质量管理体系认证证书' }, { id: 5, honame: '■ 高新技术企业证书' }, { id: 6, honame: '■ 音视频工程业企业资质贰级' }, { id: 7, honame: '■ 守合同重信用企业（连续十二年）' }, { id: 8, honame: '■ ISO/IEC 20000信息技术服务管理体系认证证书' }, { id: 9, honame: '■ ISO14001环境管理体系认证证书' }, { id: 10, honame: '■ ISO45001职业健康安全管理体系认证证书' }, { id: 11, honame: '■ 电子与智能化工程专业承包贰级' }, { id: 12, honame: '■ 安全生产许可证' }],
			scrollWatch: true
		};
	},
	mounted: function mounted() {
		this.getID();
		this.getnews();
	},

	metaInfo: {
		title: '新闻资讯'
	},
	methods: {
		getID: function getID() {
			this.chalid = 4;
		},
		getnews: function getnews() {
			// 	this.$http.post('http://www.gd-sc.net:9090',{table : 'news'},{emulateJSON: true}).then((response) => {
			//     for(var i=0 ; i<response.body.length ; i++){
			//     	var data =  response.body[i].createDate;
			//     	response.body[i].createDate = data.substr(0,10)
			//     }
			//     this.news = response.body;
			//   })
		},
		todetail: function todetail(id) {
			this.$router.push('/Newsdetail/' + id);
		}
	}
});

/***/ }),

/***/ "dWvu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/p8-2.cf51a82.jpg";

/***/ }),

/***/ "dZe8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contactu_vue__ = __webpack_require__("ODHj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a2b5020_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contactu_vue__ = __webpack_require__("xhmT");
function injectStyle (ssrContext) {
  __webpack_require__("O5+O")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contactu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a2b5020_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contactu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dnzX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eC/z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fIAo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zhaopin"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"zhaopin-choose"},[_c('div',{staticClass:"choose-top"},_vm._l((_vm.choose),function(sel){return _c('div',{staticClass:"top-sel",on:{"click":function($event){return _vm.selclick(sel.id)}}},[(_vm.selid != sel.id)?_c('img',{attrs:{"src":sel.imgsrc}}):_vm._e(),_vm._v(" "),(_vm.selid == sel.id)?_c('img',{attrs:{"src":sel.imgsrcl}}):_vm._e(),_vm._v(" "),_c('p',{class:{activep : _vm.selid == sel.id}},[_vm._v(_vm._s(sel.name))])])}),0),_vm._v(" "),_c('div',{staticClass:"choose-center"},[_c('transition',{attrs:{"name":"zhaopin-fade"}},[_c('div',{staticClass:"center-detail"},_vm._l((_vm.zhiwei),function(cen){return _c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.conid == cen.department),expression:"conid == cen.department"}]},[_c('li',{class:{liactivecon : cen.id == _vm.liid},on:{"click":function($event){return _vm.liclick(cen.id)}}},[_c('div',{staticClass:"center-line"}),_vm._v(" "),_c('b',[_vm._v(_vm._s(cen.type))]),_vm._v(" "),_c('span',{staticClass:"det-sta"},[_vm._v("\n\t\t\t\t\t\t\t\t\t职位 ： "+_vm._s(cen.position)+"       薪资 ： "+_vm._s(cen.money)+"       招聘状态 ： "+_vm._s(cen.status)+"      招聘人数 ： "+_vm._s(cen.persons)+"\n\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('span',{staticClass:"right glyphicon",class:{'glyphicon-triangle-bottom' : cen.id == _vm.liid}}),_vm._v(" "),_c('span',{staticClass:"right glyphicon",class:{'glyphicon-triangle-right' : cen.id != _vm.liid}})]),_vm._v(" "),_c('transition',{attrs:{"name":"zhaopin-fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(cen.id == _vm.liid),expression:"cen.id == liid"}],staticClass:"det-content"},[_c('div',{domProps:{"innerHTML":_vm._s(cen.demand)}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(cen.demand)+"\n\t\t\t\t\t\t\t\t\t")])])])],1)}),0)])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zhaopin-top"},[_c('img',{attrs:{"src":__webpack_require__("i/D2")}}),_vm._v(" "),_c('div',{staticClass:"com-tit"},[_c('span',[_c('img',{attrs:{"src":__webpack_require__("VrY+")}}),_c('b',[_vm._v("诚聘英才")])]),_vm._v(" "),_c('p',[_vm._v("别藏了，就是你！寻找与众不同的你，思程等你来点新花样！"),_c('br'),_vm._v("\n高薪诚聘，我们等待您的加入！")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fJPC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/gjf-rmfy.c76c461.jpg";

/***/ }),

/***/ "fWu1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aboutcom"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"com-detail"},[_c('div',{staticClass:"com-top-top"},[_c('h4',[_vm._v(_vm._s(_vm.center[_vm.chalid].title))]),_vm._v(" "),_c('div',{staticClass:"com-line"})]),_vm._v(" "),_c('transition',{attrs:{"name":"zhaopin-fade"}},[(_vm.chalid == 0 )?_c('div',{staticClass:"cominfo"},[_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.center[_vm.chalid].smalltit))]),_vm._v(" "),_c('p',{staticClass:"com-content"},[_c('b',[_vm._v("广东思程科技有限公司")]),_vm._v("是一家专业的IT解决方案服务商。主要从事于计算机系统集成、软件与数据服务、IT运维服务等业务，服务于政府、学校、医疗、生产企业等行业。")]),_vm._v(" "),_c('p',[_vm._v("公司历经市场的考验，始终坚持紧跟时代步伐，积极引进、培养人才，经过十多年的耕耘，公司已拥有了一支成熟的专业技术队伍，能为用户提供全面\n\t\t\t\t\t的IT技术解决方案，能满足大型的信息化系统集成项目的管理与服务要求。此外，公司积极投入自主创新 研发，针对不同行业，推出了具有自己特色的解决\n\t\t\t\t\t方案。 \n\t\t\t\t\t")]),_vm._v(" "),_c('p',[_vm._v("未来我们将一如既往的关注客户的需求，专注于技术创新，以为客户提供专业的技术服务为目标，使客户得到最大的效益，我们真诚期待与广大客户精\n\t\t\t\t\t诚合作，共创辉煌！\n\t\t\t\t\t")]),_vm._v(" "),_vm._l((_vm.comimg),function(im){return _c('div',{staticClass:"imgcomab"},[_c('img',{attrs:{"src":im.imgsrc}})])})],2):_vm._e(),_vm._v(" "),(_vm.chalid == 1 )?_c('div',{staticClass:"cominfo"},[_c('p',{staticClass:"com-content"},[_vm._v(" 一直以来，广东思程科技都注重人才的管理和培养，努力建立一流的团队和学习型组织，充分挖掘每一个成员的潜力，让员工在工作中实现自我价值，我们最宝贵的财富是我们的员工。")]),_vm._v(" "),_c('div',{staticClass:"singleimg"},[_c('img',{attrs:{"src":"/static/img/frame.jpg"}})])]):_vm._e(),_vm._v(" "),(_vm.chalid == 2 )?_c('div',{staticClass:"cominfo"},[_c('div',{staticClass:"singlewimg"},[_c('img',{attrs:{"src":"/static/img/wenhua.png"}})]),_vm._v(" "),_c('div',{staticClass:"comwenhua"},_vm._l((_vm.wenhua),function(wcom){return _c('div',{staticClass:"wencom"},[_c('h3',[_vm._v(_vm._s(wcom.wentit))]),_vm._v(" "),_c('p',[_c('span',{staticClass:"glyphicon glyphicon-triangle-right"}),_vm._v("   "+_vm._s(wcom.wencontent))])])}),0)]):_vm._e(),_vm._v(" "),(_vm.chalid == 3 )?_c('div',{staticClass:"cominfo"},[_c('p',{staticClass:"com-content"},[_vm._v("惠州市德通科技有限公司成立于2004年，2012年公司变更冠名为广东思程科技有限公司，逐步发展成为了专业的信息化服务企业。")]),_vm._v(" "),_vm._l((_vm.honor),function(item){return _c('div',{staticClass:"certificate"},[_c('div',{staticClass:"pic",style:({'background-image': 'url('+  item.hoimg +')'})}),_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(item.honame)+"\n\t\t\t\t\t")])])})],2):_vm._e(),_vm._v(" "),(_vm.chalid == 4 )?_c('div',{staticClass:"newsinfo"},[_c('div',{staticClass:"aboutnewslist"},[_c('div',{staticClass:"aboutnewsli"},[_c('ul',_vm._l((_vm.news),function(newsli){return _c('li',{on:{"click":function($event){return _vm.todetail(newsli.ID)}}},[_vm._v(_vm._s(newsli.title)+"\n\t\t\t\t\t\t\t"),_c('div',{staticClass:"aboutlidata"},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(newsli.createDate)+"\n\t\t\t\t\t\t\t")])])}),0)])])]):_vm._e()])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comtop"},[_c('img',{attrs:{"src":"/static/img/aboutcom.jpg"}}),_vm._v(" "),_c('div',{staticClass:"bannerMask"},[_c('div')]),_vm._v(" "),_c('div',{staticClass:"com-titr"},[_c('span',[_c('img',{attrs:{"src":"/static/img/abouticon.png"}}),_c('b',[_vm._v("关于我们")])]),_vm._v(" "),_c('p',[_vm._v("专业的IT解决方案服务商。主要从事于计算机系统集成、软件开发、IT运"),_c('br'),_vm._v("维服务等业务，服务于 政府、学校、医疗、生产企业等行业。")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fr82":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/p6-1.9bce7f3.jpg";

/***/ }),

/***/ "g3pt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aboutcom"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"com-detail"},[_c('div',{staticClass:"com-top-top"},[_c('h4',[_vm._v(_vm._s(_vm.center[_vm.chalid].title))]),_vm._v(" "),_c('div',{staticClass:"com-line"})]),_vm._v(" "),_c('transition',{attrs:{"name":"zhaopin-fade"}},[(_vm.chalid == 0 )?_c('div',{staticClass:"cominfo"},[_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.center[_vm.chalid].smalltit))]),_vm._v(" "),_c('p',{staticClass:"com-content"},[_c('b',[_vm._v("广东思程科技有限公司")]),_vm._v("是一家专业的IT解决方案服务商。主要从事于计算机系统集成、软件与数据服务、IT运维服务等业务，服务于政府、学校、医疗、生产企业等行业。")]),_vm._v(" "),_c('p',[_vm._v("公司历经市场的考验，始终坚持紧跟时代步伐，积极引进、培养人才，经过十多年的耕耘，公司已拥有了一支成熟的专业技术队伍，能为用户提供全面\n\t\t\t\t\t的IT技术解决方案，能满足大型的信息化系统集成项目的管理与服务要求。此外，公司积极投入自主创新 研发，针对不同行业，推出了具有自己特色的解决\n\t\t\t\t\t方案。 \n\t\t\t\t\t")]),_vm._v(" "),_c('p',[_vm._v("未来我们将一如既往的关注客户的需求，专注于技术创新，以为客户提供专业的技术服务为目标，使客户得到最大的效益，我们真诚期待与广大客户精\n\t\t\t\t\t诚合作，共创辉煌！\n\t\t\t\t\t")]),_vm._v(" "),_vm._l((_vm.comimg),function(im){return _c('div',{staticClass:"imgcomab"},[_c('img',{attrs:{"src":im.imgsrc}})])})],2):_vm._e(),_vm._v(" "),(_vm.chalid == 1 )?_c('div',{staticClass:"cominfo"},[_c('p',{staticClass:"com-content"},[_vm._v(" 一直以来，广东思程科技都注重人才的管理和培养，努力建立一流的团队和学习型组织，充分挖掘每一个成员的潜力，让员工在工作中实现自我价值，我们最宝贵的财富是我们的员工。")]),_vm._v(" "),_c('div',{staticClass:"singleimg"},[_c('img',{attrs:{"src":"/static/img/frame.jpg"}})])]):_vm._e(),_vm._v(" "),(_vm.chalid == 2 )?_c('div',{staticClass:"cominfo"},[_c('div',{staticClass:"singlewimg"},[_c('img',{attrs:{"src":"/static/img/wenhua.png"}})]),_vm._v(" "),_c('div',{staticClass:"comwenhua"},_vm._l((_vm.wenhua),function(wcom){return _c('div',{staticClass:"wencom"},[_c('h3',[_vm._v(_vm._s(wcom.wentit))]),_vm._v(" "),_c('p',[_c('span',{staticClass:"glyphicon glyphicon-triangle-right"}),_vm._v("   "+_vm._s(wcom.wencontent))])])}),0)]):_vm._e(),_vm._v(" "),(_vm.chalid == 3 )?_c('div',{staticClass:"cominfo"},[_c('p',{staticClass:"com-content"},[_vm._v("惠州市德通科技有限公司成立于2004年，2012年公司变更冠名为广东思程科技有限公司，逐步发展成为了专业的信息化服务企业。")]),_vm._v(" "),_vm._l((_vm.honor),function(item){return _c('div',{staticClass:"certificate"},[_c('div',{staticClass:"pic",style:({'background-image': 'url('+  item.hoimg +')'})}),_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(item.honame)+"\n\t\t\t\t\t")])])})],2):_vm._e(),_vm._v(" "),(_vm.chalid == 4 )?_c('div',{staticClass:"newsinfo"},[_c('div',{staticClass:"aboutnewslist"},[_c('div',{staticClass:"aboutnewsli"},[_c('ul',_vm._l((_vm.news),function(newsli){return _c('li',{on:{"click":function($event){return _vm.todetail(newsli.ID)}}},[_vm._v(_vm._s(newsli.title)+"\n\t\t\t\t\t\t\t"),_c('div',{staticClass:"aboutlidata"},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(newsli.createDate)+"\n\t\t\t\t\t\t\t")])])}),0)])])]):_vm._e()])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comtop"},[_c('img',{attrs:{"src":"/static/img/aboutcom.jpg"}}),_vm._v(" "),_c('div',{staticClass:"bannerMask"},[_c('div')]),_vm._v(" "),_c('div',{staticClass:"com-titr"},[_c('span',[_c('img',{attrs:{"src":"/static/img/abouticon.png"}}),_c('b',[_vm._v("关于我们")])]),_vm._v(" "),_c('p',[_vm._v("专业的IT解决方案服务商。主要从事于计算机系统集成、软件开发、IT运"),_c('br'),_vm._v("维服务等业务，服务于 政府、学校、医疗、生产企业等行业。")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gkch":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fdc-lfs.5448008.jpg";

/***/ }),

/***/ "goFp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'aboutcom-org',
	data: function data() {
		return {
			top: [{ id: 0, imgsrc: '/static/img/aboutcom.jpg', title: '关于我们' }],
			center: [{ id: 0, imgsrc: '/static/img/aboutcom.jpg', title: '公司简介', smalltit: '专业的信息化服务商' }, { id: 1, imgsrc: '/static/img/aboutcom.jpg', title: '组织框架', smalltit: '专业的信息化服务商' }, { id: 2, imgsrc: '/static/img/aboutcom.jpg', title: '企业文化', smalltit: '专业的信息化服务商' }, { id: 3, imgsrc: '/static/img/aboutcom.jpg', title: '资质荣誉', smalltit: '专业的信息化服务商' }, { id: 4, imgsrc: '/static/img/aboutcom.jpg', title: '新闻资讯', smalltit: '专业的信息化服务商' }],
			chalid: 0,
			comimg: [{ id: 0, imgsrc: '/static/img/comabout1.jpg' }, { id: 1, imgsrc: '/static/img/comabout2.jpg' }],
			news: [],
			wenhua: [{ id: 0, wentit: '责任感', wencontent: '我们的企业要有社会责任感，我们的员工对公司、客户、家庭要勇于负责任' }, { id: 1, wentit: '团队精神', wencontent: '我们的企业是一个团队，每个员工都必须充分认可团队、依靠团队、配合 团队、才能形成一个有战斗力的队伍' }, { id: 2, wentit: '专业服务、技术创新', wencontent: '拥有专业的技术、良好的服务能力，展现IT行业的“工匠”精神' }, { id: 3, wentit: '管理的规范化与制度化', wencontent: '我们相信：企业的长远发展需要管理的规范化与运营的制度化' }, { id: 4, wentit: '勤劳、诚实、自信、超越自我的精神', wencontent: '我们希望我们的员工是一个勤奋、诚实可靠、有自信、勇于超越自我的人' }],
			honor: [{ id: 0, hoimg: '/static/img/zz1.jpg', honame: '■ 计算机信息系统集成企业资质证书叁级' }, { id: 1, hoimg: '/static/img/zz13.jpg', honame: '■ 广东省安全技术防范系统设计、施工、维修资格证（壹级）证书' }, { id: 2, hoimg: '/static/img/zz5.jpg', honame: '■ 广东省涉密计算机、通信和办公自动化设备定点维护维修证书' }, { id: 3, hoimg: '/static/img/zz6.jpg', honame: '■ 软件企业认定证书' }, { id: 4, hoimg: '/static/img/zz12.jpg', honame: '■ 质量管理体系认证证书' }, { id: 5, hoimg: '/static/img/zz14.jpg', honame: '■ 高新技术企业证书' }, { id: 6, hoimg: '/static/img/zz9.jpg', honame: '■ 音视频工程业企业资质贰级' }, { id: 7, hoimg: '/static/img/zz11.jpg', honame: '■ 守合同重信用企业（连续十二年）' }, { id: 8, hoimg: '/static/img/zz15.jpg', honame: '■ 信息技术服务管理体系认证证书' }, { id: 9, hoimg: '/static/img/zz16.jpg', honame: '■ 环境管理体系认证证书' }, { id: 10, hoimg: '/static/img/zz17.jpg', honame: '■ 职业健康安全管理体系认证证书' }, { id: 11, hoimg: '/static/img/zz18.jpg', honame: '■ 电子与智能化工程专业承包贰级' }, { id: 12, hoimg: '/static/img/zz19.jpg', honame: '■ 安全生产许可证' }],
			honorname: [{ id: 0, honame: '■ 计算机信息系统集成企业资质证书叁级' }, { id: 1, honame: '■ 广东省安全技术防范系统设计、施工、维修资格证（壹级）证书' }, { id: 2, honame: '■ 广东省涉密计算机、通信和办公自动化设备定点维护维修证书' }, { id: 3, honame: '■ 软件企业认定证书' }, { id: 4, honame: '■ ISO9001 2020质量管理体系认证证书' }, { id: 5, honame: '■ 高新技术企业证书' }, { id: 6, honame: '■ 音视频工程业企业资质贰级' }, { id: 7, honame: '■ 守合同重信用企业（连续十二年）' }, { id: 8, honame: '■ ISO/IEC 20000信息技术服务管理体系认证证书' }, { id: 9, honame: '■ ISO14001环境管理体系认证证书' }, { id: 10, honame: '■ ISO45001职业健康安全管理体系认证证书' }, { id: 11, honame: '■ 电子与智能化工程专业承包贰级' }, { id: 12, honame: '■ 安全生产许可证' }],
			scrollWatch: true
		};
	},
	mounted: function mounted() {
		this.getID();
		this.getnews();
	},

	metaInfo: {
		title: '组织框架'
	},
	methods: {
		getID: function getID() {
			this.chalid = 1;
		},
		getnews: function getnews() {
			// 	this.$http.post('http://www.gd-sc.net:9090',{table : 'news'},{emulateJSON: true}).then((response) => {
			//     for(var i=0 ; i<response.body.length ; i++){
			//     	var data =  response.body[i].createDate;
			//     	response.body[i].createDate = data.substr(0,10)
			//     }
			//     this.news = response.body;
			//   })
		},
		todetail: function todetail(id) {
			this.$router.push('/Newsdetail/' + id);
		}
	}
});

/***/ }),

/***/ "h2uk":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon2.8e2d621.png";

/***/ }),

/***/ "h5FS":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/banner_04.0dcd945.jpg";

/***/ }),

/***/ "hvxX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'techonlogy-field',
	data: function data() {
		return {
			tech: [{ id: 0, imgsrc: '/static/img/fuwu.jpg', title: '服务领域' }, { id: 1, imgsrc: '/static/img/fuwu.jpg', title: '业务模式' }, { id: 2, imgsrc: '/static/img/fuwu.jpg', title: '技术领域' }],
			techimg: [{ id: 0, imgsrc: '/static/img/serve1 (1).png', smalltit: '系统集成' }, { id: 1, imgsrc: '/static/img/11serve1 (1).png', smalltit: '软件与数据服务' }, { id: 2, imgsrc: '/static/img/sc-soft-img2.png', smalltit: 'IT运维服务' }, { id: 3, imgsrc: '/static/img/serve1 (2).png', smalltit: '' }, { id: 4, imgsrc: '/static/img/serve1 (3).png', smalltit: '' }],
			yewu: [{ id: 0, imgsrc: '/static/img/yewumodx.png', smalltit: '项目建设' }, { id: 1, imgsrc: '/static/img/yewumodp.png', smalltit: '产品开发' }, { id: 2, imgsrc: '/static/img/yewumodz.png', smalltit: '项目合作运营' }],
			jishu: [{ id: 0, imgsrc: '/static/img/jsly.png', smalltit: '弱电+网络通讯' }, { id: 1, imgsrc: '/static/img/jsly2.png', smalltit: '数据与安全' }, { id: 2, imgsrc: '/static/img/jsly3.png', smalltit: '云技术' }, { id: 3, imgsrc: '/static/img/yewumodz.png', smalltit: '物联网' }, { id: 4, imgsrc: '/static/img/jsly4.png', smalltit: '应用软件' }],
			chalid: 0

		};
	},
	mounted: function mounted() {
		this.getID();
	},

	metaInfo: {
		title: '技术领域'
	},
	methods: {
		getID: function getID() {
			this.chalid = 2;
		}
	}
});

/***/ }),

/***/ "i/D2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zhaopin.ab320e3.png";

/***/ }),

/***/ "i3ah":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/gjf-gaj.7c0e9bb.jpg";

/***/ }),

/***/ "iT0j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aboutcom_info_vue__ = __webpack_require__("K5aM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61507c63_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aboutcom_info_vue__ = __webpack_require__("mCwo");
function injectStyle (ssrContext) {
  __webpack_require__("bjI8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aboutcom_info_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61507c63_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aboutcom_info_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iTIH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/p8-6.0816f46.jpg";

/***/ }),

/***/ "iVxy":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/p5-1.8d1007c.jpg";

/***/ }),

/***/ "j05s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'aboutcom',
	data: function data() {
		return {
			top: [{ id: 0, imgsrc: 'static/img/aboutcom.jpg', title: '关于我们' }],
			center: [{ id: 0, imgsrc: 'static/img/aboutcom.jpg', title: '公司简介', smalltit: '专业的信息化服务商' }, { id: 1, imgsrc: 'static/img/aboutcom.jpg', title: '组织框架', smalltit: '专业的信息化服务商' }, { id: 2, imgsrc: 'static/img/aboutcom.jpg', title: '企业文化', smalltit: '专业的信息化服务商' }, { id: 3, imgsrc: 'static/img/aboutcom.jpg', title: '资质荣誉', smalltit: '专业的信息化服务商' }, { id: 4, imgsrc: 'static/img/aboutcom.jpg', title: '新闻资讯', smalltit: '专业的信息化服务商' }],
			chalid: 0,
			comimg: [{ id: 0, imgsrc: '/static/img/comabout1.jpg' }, { id: 1, imgsrc: '/static/img/comabout2.jpg' }],
			news: [],
			wenhua: [{ id: 0, wentit: '责任感', wencontent: '我们的企业要有社会责任感，我们的员工对公司、客户、家庭要勇于负责任' }, { id: 1, wentit: '团队精神', wencontent: '我们的企业是一个团队，每个员工都必须充分认可团队、依靠团队、配合 团队、才能形成一个有战斗力的队伍' }, { id: 2, wentit: '专业服务、技术创新', wencontent: '拥有专业的技术、良好的服务能力，展现IT行业的“工匠”精神' }, { id: 3, wentit: '管理的规范化与制度化', wencontent: '我们相信：企业的长远发展需要管理的规范化与运营的制度化' }, { id: 4, wentit: '勤劳、诚实、自信、超越自我的精神', wencontent: '我们希望我们的员工是一个勤奋、诚实可靠、有自信、勇于超越自我的人' }],
			honor: [{ id: 0, hoimg: 'static/img/zz1.jpg', honame: '■ 计算机信息系统集成企业资质证书叁级' }, { id: 1, hoimg: 'static/img/zz13.jpg', honame: '■ 广东省安全技术防范系统设计、施工、维修资格证（壹级）证书' }, { id: 2, hoimg: 'static/img/zz5.jpg', honame: '■ 广东省涉密计算机、通信和办公自动化设备定点维护维修证书' }, { id: 3, hoimg: 'static/img/zz6.jpg', honame: '■ 软件企业认定证书' }, { id: 4, hoimg: 'static/img/zz12.jpg', honame: '■ 质量管理体系认证证书' }, { id: 5, hoimg: 'static/img/zz14.jpg', honame: '■ 高新技术企业证书' }, { id: 6, hoimg: 'static/img/zz9.jpg', honame: '■ 音视频工程业企业资质贰级' }, { id: 7, hoimg: 'static/img/zz11.jpg', honame: '■ 守合同重信用企业（连续十二年）' }, { id: 8, hoimg: 'static/img/zz15.jpg', honame: '■ 信息技术服务管理体系认证证书' }, { id: 9, hoimg: 'static/img/zz16.jpg', honame: '■ 环境管理体系认证证书' }, { id: 10, hoimg: 'static/img/zz17.jpg', honame: '■ 职业健康安全管理体系认证证书' }, { id: 11, hoimg: 'static/img/zz18.jpg', honame: '■ 电子与智能化工程专业承包贰级' }, { id: 12, hoimg: 'static/img/zz19.jpg', honame: '■ 安全生产许可证' }],
			honorname: [{ id: 0, honame: '■ 计算机信息系统集成企业资质证书叁级' }, { id: 1, honame: '■ 广东省安全技术防范系统设计、施工、维修资格证（壹级）证书' }, { id: 2, honame: '■ 广东省涉密计算机、通信和办公自动化设备定点维护维修证书' }, { id: 3, honame: '■ 软件企业认定证书' }, { id: 4, honame: '■ ISO9001 2020质量管理体系认证证书' }, { id: 5, honame: '■ 高新技术企业证书' }, { id: 6, honame: '■ 音视频工程业企业资质贰级' }, { id: 7, honame: '■ 守合同重信用企业（连续十二年）' }, { id: 8, honame: '■ ISO/IEC 20000信息技术服务管理体系认证证书' }, { id: 9, honame: '■ ISO14001环境管理体系认证证书' }, { id: 10, honame: '■ ISO45001职业健康安全管理体系认证证书' }, { id: 11, honame: '■ 电子与智能化工程专业承包贰级' }, { id: 12, honame: '■ 安全生产许可证' }],
			scrollWatch: true
		};
	},

	metaInfo: {
		title: '专业的信息化服务企业'
	},
	mounted: function mounted() {
		this.getID();
		this.getnews();
	},

	methods: {
		getID: function getID() {
			this.chalid = this.$route.params.ID;
		},
		getnews: function getnews() {
			// 	this.$http.post('http://www.gd-sc.net:9090',{table : 'news'},{emulateJSON: true}).then((response) => {
			//     for(var i=0 ; i<response.body.length ; i++){
			//     	var data =  response.body[i].createDate;
			//     	response.body[i].createDate = data.substr(0,10)
			//     }
			//     this.news = response.body;
			//   })
		},
		todetail: function todetail(id) {
			this.$router.push('/Newsdetail/' + id);
		}
	}
});

/***/ }),

/***/ "jId1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jsOG":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon1.ba23cd1.png";

/***/ }),

/***/ "jwzE":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/casetoop.65fa130.jpg";

/***/ }),

/***/ "kuap":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lvshi.4851761.jpg";

/***/ }),

/***/ "kxce":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'product',
	data: function data() {
		return {
			pro: [{ id: 0, imgsrc: 'static/img/wepro.jpg', title: '环境监测管理系统', smalltit: '环境监测智能综合管理系统' }, { id: 1, imgsrc: 'static/img/wepro.jpg', title: '企业招投标系统', smalltit: '企业招投标系统' }, { id: 2, imgsrc: 'static/img/wepro.jpg', title: '公共资源业务系统', smalltit: '公共资源业务系统' }, { id: 3, imgsrc: 'static/img/wepro.jpg', title: '智慧旅游综合业务系统', smalltit: '智慧旅游综合业务系统' }, { id: 4, imgsrc: 'static/img/wepro.jpg', title: '新零售业务系统', smalltit: '新零售业务系统' }, { id: 5, imgsrc: 'static/img/wepro.jpg', title: '律师行业综合业务系统', smalltit: '律师行业综合业务系统' }, { id: 6, imgsrc: 'static/img/wepro.jpg', title: '通用OA业务系统', smalltit: '通用OA业务系统' }, { id: 7, imgsrc: 'static/img/wepro.jpg', title: '智能能综合指挥平台', smalltit: '智能综合指挥平台' }],

			chalid: 0,

			navli: [{ id: 0, litit: '服务事业单位 ' }, { id: 1, litit: '房地产 ' }, { id: 2, litit: '政府 ' }, { id: 3, litit: '旅游 ' }, { id: 4, litit: '传媒 ' }, { id: 5, litit: '律师 ' }, { id: 6, litit: '教育 ' }, { id: 7, litit: '医疗 ' }],
			scrollWatch: true,
			lijudge: 0,
			selid: 0
		};
	},
	mounted: function mounted() {
		this.getID();
	},

	metaInfo: {
		title: '我们的产品',
		meta: [{
			name: 'keyWords',
			content: '环境监测智能综合管理系统，企业招投标系统，公共资源业务系统，智慧旅游综合业务系统，新零售业务系统，律师行业综合业务系统，通用OA业务系统，智能综合指挥平台，交易系统，网上挂牌交易系统，交易竞价系统，土矿交易系统，土地与矿业网上挂牌交易系统，产权交易网上竞价系统，产权交易系统'
		}, {
			name: "description",
			content: "环境监测智能综合管理系统，企业招投标系统，公共资源业务系统，智慧旅游综合业务系统，新零售业务系统，律师行业综合业务系统，通用OA业务系统，智能综合指挥平台，交易系统，网上挂牌交易系统，交易竞价系统，土矿交易系统，土地与矿业网上挂牌交易系统，产权交易网上竞价系统，产权交易系统"
		}]
	},
	methods: {
		getID: function getID() {
			if (this.$route.params.ID !== null && this.$route.params.ID !== undefined && this.$route.params.ID !== '') {
				this.chalid = this.$route.params.ID;
			} else {
				this.chalid = 0;
			}
		},
		seltab: function seltab(index) {
			this.chalid = index;
		}
	}
});

/***/ }),

/***/ "mCwo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aboutcom"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"com-detail"},[_c('div',{staticClass:"com-top-top"},[_c('h4',[_vm._v(_vm._s(_vm.center[_vm.chalid].title))]),_vm._v(" "),_c('div',{staticClass:"com-line"})]),_vm._v(" "),_c('transition',{attrs:{"name":"zhaopin-fade"}},[(_vm.chalid == 0 )?_c('div',{staticClass:"cominfo"},[_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.center[_vm.chalid].smalltit))]),_vm._v(" "),_c('p',{staticClass:"com-content"},[_c('b',[_vm._v("广东思程科技有限公司")]),_vm._v("是一家专业的IT解决方案服务商。主要从事于计算机系统集成、软件与数据服务、IT运维服务等业务，服务于政府、学校、医疗、生产企业等行业。")]),_vm._v(" "),_c('p',[_vm._v("公司历经市场的考验，始终坚持紧跟时代步伐，积极引进、培养人才，经过十多年的耕耘，公司已拥有了一支成熟的专业技术队伍，能为用户提供全面\n\t\t\t\t\t的IT技术解决方案，能满足大型的信息化系统集成项目的管理与服务要求。此外，公司积极投入自主创新 研发，针对不同行业，推出了具有自己特色的解决\n\t\t\t\t\t方案。 \n\t\t\t\t\t")]),_vm._v(" "),_c('p',[_vm._v("未来我们将一如既往的关注客户的需求，专注于技术创新，以为客户提供专业的技术服务为目标，使客户得到最大的效益，我们真诚期待与广大客户精\n\t\t\t\t\t诚合作，共创辉煌！\n\t\t\t\t\t")]),_vm._v(" "),_vm._l((_vm.comimg),function(im){return _c('div',{staticClass:"imgcomab"},[_c('img',{attrs:{"src":im.imgsrc}})])})],2):_vm._e(),_vm._v(" "),(_vm.chalid == 1 )?_c('div',{staticClass:"cominfo"},[_c('p',{staticClass:"com-content"},[_vm._v(" 一直以来，广东思程科技都注重人才的管理和培养，努力建立一流的团队和学习型组织，充分挖掘每一个成员的潜力，让员工在工作中实现自我价值，我们最宝贵的财富是我们的员工。")]),_vm._v(" "),_c('div',{staticClass:"singleimg"},[_c('img',{attrs:{"src":"/static/img/frame.jpg"}})])]):_vm._e(),_vm._v(" "),(_vm.chalid == 2 )?_c('div',{staticClass:"cominfo"},[_c('div',{staticClass:"singlewimg"},[_c('img',{attrs:{"src":"/static/img/wenhua.png"}})]),_vm._v(" "),_c('div',{staticClass:"comwenhua"},_vm._l((_vm.wenhua),function(wcom){return _c('div',{staticClass:"wencom"},[_c('h3',[_vm._v(_vm._s(wcom.wentit))]),_vm._v(" "),_c('p',[_c('span',{staticClass:"glyphicon glyphicon-triangle-right"}),_vm._v("   "+_vm._s(wcom.wencontent))])])}),0)]):_vm._e(),_vm._v(" "),(_vm.chalid == 3 )?_c('div',{staticClass:"cominfo"},[_c('p',{staticClass:"com-content"},[_vm._v("惠州市德通科技有限公司成立于2004年，2012年公司变更冠名为广东思程科技有限公司，逐步发展成为了专业的信息化服务企业。")]),_vm._v(" "),_vm._l((_vm.honor),function(item){return _c('div',{staticClass:"certificate"},[_c('div',{staticClass:"pic",style:({'background-image': 'url('+  item.hoimg +')'})}),_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(item.honame)+"\n\t\t\t\t\t")])])})],2):_vm._e(),_vm._v(" "),(_vm.chalid == 4 )?_c('div',{staticClass:"newsinfo"},[_c('div',{staticClass:"aboutnewslist"},[_c('div',{staticClass:"aboutnewsli"},[_c('ul',_vm._l((_vm.news),function(newsli){return _c('li',{on:{"click":function($event){return _vm.todetail(newsli.ID)}}},[_vm._v(_vm._s(newsli.title)+"\n\t\t\t\t\t\t\t"),_c('div',{staticClass:"aboutlidata"},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(newsli.createDate)+"\n\t\t\t\t\t\t\t")])])}),0)])])]):_vm._e()])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comtop"},[_c('img',{attrs:{"src":"/static/img/aboutcom.jpg"}}),_vm._v(" "),_c('div',{staticClass:"bannerMask"},[_c('div')]),_vm._v(" "),_c('div',{staticClass:"com-titr"},[_c('span',[_c('img',{attrs:{"src":"/static/img/abouticon.png"}}),_c('b',[_vm._v("关于我们")])]),_vm._v(" "),_c('p',[_vm._v("专业的IT解决方案服务商。主要从事于计算机系统集成、软件开发、IT运"),_c('br'),_vm._v("维服务等业务，服务于 政府、学校、医疗、生产企业等行业。")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mzkE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue__ = __webpack_require__("ce18");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51314318_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__ = __webpack_require__("P5Dz");
function injectStyle (ssrContext) {
  __webpack_require__("jId1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51314318_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "n5dN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'aboutcom-culture',
	data: function data() {
		return {
			top: [{ id: 0, imgsrc: '/static/img/aboutcom.jpg', title: '关于我们' }],
			center: [{ id: 0, imgsrc: '/static/img/aboutcom.jpg', title: '公司简介', smalltit: '专业的信息化服务商' }, { id: 1, imgsrc: '/static/img/aboutcom.jpg', title: '组织框架', smalltit: '专业的信息化服务商' }, { id: 2, imgsrc: '/static/img/aboutcom.jpg', title: '企业文化', smalltit: '专业的信息化服务商' }, { id: 3, imgsrc: '/static/img/aboutcom.jpg', title: '资质荣誉', smalltit: '专业的信息化服务商' }, { id: 4, imgsrc: '/static/img/aboutcom.jpg', title: '新闻资讯', smalltit: '专业的信息化服务商' }],
			chalid: 2,
			comimg: [{ id: 0, imgsrc: '/static/img/comabout1.jpg' }, { id: 1, imgsrc: '/static/img/comabout2.jpg' }],
			news: [],
			wenhua: [{ id: 0, wentit: '责任感', wencontent: '我们的企业要有社会责任感，我们的员工对公司、客户、家庭要勇于负责任' }, { id: 1, wentit: '团队精神', wencontent: '我们的企业是一个团队，每个员工都必须充分认可团队、依靠团队、配合 团队、才能形成一个有战斗力的队伍' }, { id: 2, wentit: '专业服务、技术创新', wencontent: '拥有专业的技术、良好的服务能力，展现IT行业的“工匠”精神' }, { id: 3, wentit: '管理的规范化与制度化', wencontent: '我们相信：企业的长远发展需要管理的规范化与运营的制度化' }, { id: 4, wentit: '勤劳、诚实、自信、超越自我的精神', wencontent: '我们希望我们的员工是一个勤奋、诚实可靠、有自信、勇于超越自我的人' }],
			honor: [{ id: 0, hoimg: '/static/img/zz1.jpg', honame: '■ 计算机信息系统集成企业资质证书叁级' }, { id: 1, hoimg: '/static/img/zz13.jpg', honame: '■ 广东省安全技术防范系统设计、施工、维修资格证（壹级）证书' }, { id: 2, hoimg: '/static/img/zz5.jpg', honame: '■ 广东省涉密计算机、通信和办公自动化设备定点维护维修证书' }, { id: 3, hoimg: '/static/img/zz6.jpg', honame: '■ 软件企业认定证书' }, { id: 4, hoimg: '/static/img/zz12.jpg', honame: '■ 质量管理体系认证证书' }, { id: 5, hoimg: '/static/img/zz14.jpg', honame: '■ 高新技术企业证书' }, { id: 6, hoimg: '/static/img/zz9.jpg', honame: '■ 音视频工程业企业资质贰级' }, { id: 7, hoimg: '/static/img/zz11.jpg', honame: '■ 守合同重信用企业（连续十二年）' }, { id: 8, hoimg: '/static/img/zz15.jpg', honame: '■ 信息技术服务管理体系认证证书' }, { id: 9, hoimg: '/static/img/zz16.jpg', honame: '■ 环境管理体系认证证书' }, { id: 10, hoimg: '/static/img/zz17.jpg', honame: '■ 职业健康安全管理体系认证证书' }, { id: 11, hoimg: '/static/img/zz18.jpg', honame: '■ 电子与智能化工程专业承包贰级' }, { id: 12, hoimg: '/static/img/zz19.jpg', honame: '■ 安全生产许可证' }],
			honorname: [{ id: 0, honame: '■ 计算机信息系统集成企业资质证书叁级' }, { id: 1, honame: '■ 广东省安全技术防范系统设计、施工、维修资格证（壹级）证书' }, { id: 2, honame: '■ 广东省涉密计算机、通信和办公自动化设备定点维护维修证书' }, { id: 3, honame: '■ 软件企业认定证书' }, { id: 4, honame: '■ ISO9001 2020质量管理体系认证证书' }, { id: 5, honame: '■ 高新技术企业证书' }, { id: 6, honame: '■ 音视频工程业企业资质贰级' }, { id: 7, honame: '■ 守合同重信用企业（连续十二年）' }, { id: 8, honame: '■ ISO/IEC 20000信息技术服务管理体系认证证书' }, { id: 9, honame: '■ ISO14001环境管理体系认证证书' }, { id: 10, honame: '■ ISO45001职业健康安全管理体系认证证书' }, { id: 11, honame: '■ 电子与智能化工程专业承包贰级' }, { id: 12, honame: '■ 安全生产许可证' }],
			scrollWatch: true
		};
	},
	created: function created() {},
	mounted: function mounted() {
		this.getID();
		this.getnews();
	},

	metaInfo: {
		title: '企业文化'
	},
	methods: {
		getID: function getID() {
			this.chalid = 2;
		},
		getnews: function getnews() {
			// 	this.$http.post('http://www.gd-sc.net:9090',{table : 'news'},{emulateJSON: true}).then((response) => {
			//     for(var i=0 ; i<response.body.length ; i++){
			//     	var data =  response.body[i].createDate;
			//     	response.body[i].createDate = data.substr(0,10)
			//     }
			//     this.news = response.body;
			//   })
		},
		todetail: function todetail(id) {
			this.$router.push('/Newsdetail/' + id);
		}
	}
});

/***/ }),

/***/ "nsKm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oReE":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/gjf-110.fc99152.jpg";

/***/ }),

/***/ "oTfL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aboutcom_news_vue__ = __webpack_require__("d8wd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_399437db_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aboutcom_news_vue__ = __webpack_require__("fWu1");
function injectStyle (ssrContext) {
  __webpack_require__("TNcm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aboutcom_news_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_399437db_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aboutcom_news_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "q5Xz":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/caseicon.fce428c.png";

/***/ }),

/***/ "qIoi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aboutcom"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"com-detail"},[_c('div',{staticClass:"com-top-top"},[_c('h4',[_vm._v(_vm._s(_vm.center[_vm.chalid].title))]),_vm._v(" "),_c('div',{staticClass:"com-line"})]),_vm._v(" "),_c('transition',{attrs:{"name":"zhaopin-fade"}},[(_vm.chalid == 0 )?_c('div',{staticClass:"cominfo"},[_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.center[_vm.chalid].smalltit))]),_vm._v(" "),_c('p',{staticClass:"com-content"},[_c('b',[_vm._v("广东思程科技有限公司")]),_vm._v("是一家专业的IT解决方案服务商。主要从事于计算机系统集成、软件与数据服务、IT运维服务等业务，服务于政府、学校、医疗、生产企业等行业。")]),_vm._v(" "),_c('p',[_vm._v("公司历经市场的考验，始终坚持紧跟时代步伐，积极引进、培养人才，经过十多年的耕耘，公司已拥有了一支成熟的专业技术队伍，能为用户提供全面\n\t\t\t\t\t的IT技术解决方案，能满足大型的信息化系统集成项目的管理与服务要求。此外，公司积极投入自主创新 研发，针对不同行业，推出了具有自己特色的解决\n\t\t\t\t\t方案。 \n\t\t\t\t\t")]),_vm._v(" "),_c('p',[_vm._v("未来我们将一如既往的关注客户的需求，专注于技术创新，以为客户提供专业的技术服务为目标，使客户得到最大的效益，我们真诚期待与广大客户精\n\t\t\t\t\t诚合作，共创辉煌！\n\t\t\t\t\t")]),_vm._v(" "),_vm._l((_vm.comimg),function(im){return _c('div',{staticClass:"imgcomab"},[_c('img',{attrs:{"src":im.imgsrc}})])})],2):_vm._e(),_vm._v(" "),(_vm.chalid == 1 )?_c('div',{staticClass:"cominfo"},[_c('p',{staticClass:"com-content"},[_vm._v(" 一直以来，广东思程科技都注重人才的管理和培养，努力建立一流的团队和学习型组织，充分挖掘每一个成员的潜力，让员工在工作中实现自我价值，我们最宝贵的财富是我们的员工。")]),_vm._v(" "),_c('div',{staticClass:"singleimg"},[_c('img',{attrs:{"src":__webpack_require__("xGfG")}})])]):_vm._e(),_vm._v(" "),(_vm.chalid == 2 )?_c('div',{staticClass:"cominfo"},[_c('div',{staticClass:"singlewimg"},[_c('img',{attrs:{"src":__webpack_require__("4hjF")}})]),_vm._v(" "),_c('div',{staticClass:"comwenhua"},_vm._l((_vm.wenhua),function(wcom){return _c('div',{staticClass:"wencom"},[_c('h3',[_vm._v(_vm._s(wcom.wentit))]),_vm._v(" "),_c('p',[_c('span',{staticClass:"glyphicon glyphicon-triangle-right"}),_vm._v("   "+_vm._s(wcom.wencontent))])])}),0)]):_vm._e(),_vm._v(" "),(_vm.chalid == 3 )?_c('div',{staticClass:"cominfo"},[_c('p',{staticClass:"com-content"},[_vm._v("惠州市德通科技有限公司成立于2004年，2012年公司变更冠名为广东思程科技有限公司，逐步发展成为了专业的信息化服务企业。")]),_vm._v(" "),_vm._l((_vm.honor),function(item){return _c('div',{staticClass:"certificate"},[_c('div',{staticClass:"pic",style:({'background-image': 'url('+  item.hoimg +')'})}),_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(item.honame)+"\n\t\t\t\t\t")])])})],2):_vm._e(),_vm._v(" "),(_vm.chalid == 4 )?_c('div',{staticClass:"newsinfo"},[_c('div',{staticClass:"aboutnewslist"},[_c('div',{staticClass:"aboutnewsli"},[_c('ul',_vm._l((_vm.news),function(newsli){return _c('li',{on:{"click":function($event){return _vm.todetail(newsli.ID)}}},[_vm._v(_vm._s(newsli.title)+"\n\t\t\t\t\t\t\t"),_c('div',{staticClass:"aboutlidata"},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(newsli.createDate)+"\n\t\t\t\t\t\t\t")])])}),0)])])]):_vm._e()])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comtop"},[_c('img',{attrs:{"src":__webpack_require__("sdn1")}}),_vm._v(" "),_c('div',{staticClass:"bannerMask"},[_c('div')]),_vm._v(" "),_c('div',{staticClass:"com-titr"},[_c('span',[_c('img',{attrs:{"src":__webpack_require__("HriX")}}),_c('b',[_vm._v("关于我们")])]),_vm._v(" "),_c('p',[_vm._v("专业的IT解决方案服务商。主要从事于计算机系统集成、软件开发、IT运"),_c('br'),_vm._v("维服务等业务，服务于 政府、学校、医疗、生产企业等行业。")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qb6w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qlFt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"header-o",style:({background : '#0066ef' ,opacity : 1})}),_vm._v(" "),_c('div',{staticClass:"nav-nav"},[_c('ul',_vm._l((_vm.nav),function(na,index){return _c('li',{class:{liactive: _vm.acli == na.id},attrs:{"id":"index"},on:{"mouseenter":function($event){return _vm.slide(index)},"mouseleave":function($event){return _vm.out()}}},[_c('router-link',{class:{liaactive: _vm.acli == na.id},style:({color : '#fff' }),attrs:{"to":na.linkto}},[_c('div',{staticClass:"gogogo",on:{"click":function($event){return _vm.linkto(na.id)}}},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(na.name)+"\n\t\t\t\t\t\t\t")])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-fade"}},[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.judge == na.id),expression:"judge == na.id"}]},_vm._l((_vm.navcontent[index].content),function(con){return _c('li',{on:{"click":function($event){return _vm.linkto(na.id)}}},[_c('router-link',{attrs:{"to":con.vuelink}},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(con.name)+"\n\t\t\t\t\t\t\t\t")])],1)}),0)])],1)}),0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-logo"},[_c('div',{staticClass:"header-logonav"},[_c('div',{staticClass:"top-logo"},[_c('img',{attrs:{"src":__webpack_require__("YpdP")}})]),_vm._v(" "),_c('div',{staticClass:"top-other"},[_c('span',[_c('p',[_vm._v("设为主页     |    收藏本页")])]),_vm._v(" "),_c('span',[_c('a',{attrs:{"rel":"nofollow","title":" 客服热线：0752-2123600","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("jsOG")}})]),_vm._v(" "),_c('a',{attrs:{"rel":"nofollow","href":"http://wpa.qq.com/msgrd?v=3&uin=3250932395&site=qq&menu=yes","title":"QQ：3250932395","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("h2uk")}})]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("7Ju0")}}),_vm._v(" "),_c('a',{attrs:{"href":"http://oa.gd-sc.net:8080/obpm/"}},[_vm._v("进入业务系统")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qrdm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'aboutcom-honor',
	data: function data() {
		return {
			top: [{ id: 0, imgsrc: '/static/img/aboutcom.jpg', title: '关于我们' }],
			center: [{ id: 0, imgsrc: '/static/img/aboutcom.jpg', title: '公司简介', smalltit: '专业的信息化服务商' }, { id: 1, imgsrc: '/static/img/aboutcom.jpg', title: '组织框架', smalltit: '专业的信息化服务商' }, { id: 2, imgsrc: '/static/img/aboutcom.jpg', title: '企业文化', smalltit: '专业的信息化服务商' }, { id: 3, imgsrc: '/static/img/aboutcom.jpg', title: '资质荣誉', smalltit: '专业的信息化服务商' }, { id: 4, imgsrc: '/static/img/aboutcom.jpg', title: '新闻资讯', smalltit: '专业的信息化服务商' }],
			chalid: 0,
			comimg: [{ id: 0, imgsrc: '/static/img/comabout1.jpg' }, { id: 1, imgsrc: '/static/img/comabout2.jpg' }],
			news: [],
			wenhua: [{ id: 0, wentit: '责任感', wencontent: '我们的企业要有社会责任感，我们的员工对公司、客户、家庭要勇于负责任' }, { id: 1, wentit: '团队精神', wencontent: '我们的企业是一个团队，每个员工都必须充分认可团队、依靠团队、配合 团队、才能形成一个有战斗力的队伍' }, { id: 2, wentit: '专业服务、技术创新', wencontent: '拥有专业的技术、良好的服务能力，展现IT行业的“工匠”精神' }, { id: 3, wentit: '管理的规范化与制度化', wencontent: '我们相信：企业的长远发展需要管理的规范化与运营的制度化' }, { id: 4, wentit: '勤劳、诚实、自信、超越自我的精神', wencontent: '我们希望我们的员工是一个勤奋、诚实可靠、有自信、勇于超越自我的人' }],
			honor: [{ id: 0, hoimg: '/static/img/zz1.jpg', honame: '■ 计算机信息系统集成企业资质证书叁级' }, { id: 1, hoimg: '/static/img/zz13.jpg', honame: '■ 广东省安全技术防范系统设计、施工、维修资格证（壹级）证书' }, { id: 2, hoimg: '/static/img/zz5.jpg', honame: '■ 广东省涉密计算机、通信和办公自动化设备定点维护维修证书' }, { id: 3, hoimg: '/static/img/zz6.jpg', honame: '■ 软件企业认定证书' }, { id: 4, hoimg: '/static/img/zz12.jpg', honame: '■ 质量管理体系认证证书' }, { id: 5, hoimg: '/static/img/zz14.jpg', honame: '■ 高新技术企业证书' }, { id: 6, hoimg: '/static/img/zz9.jpg', honame: '■ 音视频工程业企业资质贰级' }, { id: 7, hoimg: '/static/img/zz11.jpg', honame: '■ 守合同重信用企业（连续十二年）' }, { id: 8, hoimg: '/static/img/zz15.jpg', honame: '■ 信息技术服务管理体系认证证书' }, { id: 9, hoimg: '/static/img/zz16.jpg', honame: '■ 环境管理体系认证证书' }, { id: 10, hoimg: '/static/img/zz17.jpg', honame: '■ 职业健康安全管理体系认证证书' }, { id: 11, hoimg: '/static/img/zz18.jpg', honame: '■ 电子与智能化工程专业承包贰级' }, { id: 12, hoimg: '/static/img/zz19.jpg', honame: '■ 安全生产许可证' }],
			honorname: [{ id: 0, honame: '■ 计算机信息系统集成企业资质证书叁级' }, { id: 1, honame: '■ 广东省安全技术防范系统设计、施工、维修资格证（壹级）证书' }, { id: 2, honame: '■ 广东省涉密计算机、通信和办公自动化设备定点维护维修证书' }, { id: 3, honame: '■ 软件企业认定证书' }, { id: 4, honame: '■ ISO9001 2020质量管理体系认证证书' }, { id: 5, honame: '■ 高新技术企业证书' }, { id: 6, honame: '■ 音视频工程业企业资质贰级' }, { id: 7, honame: '■ 守合同重信用企业（连续十二年）' }, { id: 8, honame: '■ ISO/IEC 20000信息技术服务管理体系认证证书' }, { id: 9, honame: '■ ISO14001环境管理体系认证证书' }, { id: 10, honame: '■ ISO45001职业健康安全管理体系认证证书' }, { id: 11, honame: '■ 电子与智能化工程专业承包贰级' }, { id: 12, honame: '■ 安全生产许可证' }],
			scrollWatch: true
		};
	},
	mounted: function mounted() {
		this.getID();
		this.getnews();
	},

	metaInfo: {
		title: '资质荣誉'
	},
	methods: {
		getID: function getID() {
			this.chalid = 3;
		},
		getnews: function getnews() {
			// 	this.$http.post('http://www.gd-sc.net:9090',{table : 'news'},{emulateJSON: true}).then((response) => {
			//     for(var i=0 ; i<response.body.length ; i++){
			//     	var data =  response.body[i].createDate;
			//     	response.body[i].createDate = data.substr(0,10)
			//     }
			//     this.news = response.body;
			//   })
		},
		todetail: function todetail(id) {
			this.$router.push('/Newsdetail/' + id);
		}
	}
});

/***/ }),

/***/ "roiq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rwbt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aboutcom_org_vue__ = __webpack_require__("goFp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e5d8fd9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aboutcom_org_vue__ = __webpack_require__("g3pt");
function injectStyle (ssrContext) {
  __webpack_require__("u9MZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aboutcom_org_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e5d8fd9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aboutcom_org_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "s8jS":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/yiliao.7c6b81c.jpg";

/***/ }),

/***/ "sdn1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/aboutcom.6b82690.jpg";

/***/ }),

/***/ "tBRS":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/p4-1.534913c.jpg";

/***/ }),

/***/ "tLzu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_technology_business_vue__ = __webpack_require__("S1Xg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6daedf34_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_technology_business_vue__ = __webpack_require__("2W7X");
function injectStyle (ssrContext) {
  __webpack_require__("W/u7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_technology_business_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6daedf34_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_technology_business_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tjEH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tkHa":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/p8-4.ad42e5f.jpg";

/***/ }),

/***/ "tkYC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fdc-yj.3daad4a.jpg";

/***/ }),

/***/ "tvR6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tw47":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qyztb.94c61ba.jpg";

/***/ }),

/***/ "u+Fy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_product_vue__ = __webpack_require__("kxce");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c2fbd5a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_product_vue__ = __webpack_require__("HtlJ");
function injectStyle (ssrContext) {
  __webpack_require__("roiq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_product_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c2fbd5a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_product_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "u9MZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uPfT":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/saltouticon.ecfd0e5.png";

/***/ }),

/***/ "vPp3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vzo0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/gif-jiaoyu.fa5b7a7.jpg";

/***/ }),

/***/ "w69A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aboutcom"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"com-detail"},[_c('div',{staticClass:"com-top-top"},[_c('h4',[_vm._v(_vm._s(_vm.center[_vm.chalid].title))]),_vm._v(" "),_c('div',{staticClass:"com-line"})]),_vm._v(" "),_c('transition',{attrs:{"name":"zhaopin-fade"}},[(_vm.chalid == 0 )?_c('div',{staticClass:"cominfo"},[_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.center[_vm.chalid].smalltit))]),_vm._v(" "),_c('p',{staticClass:"com-content"},[_c('b',[_vm._v("广东思程科技有限公司")]),_vm._v("是一家专业的IT解决方案服务商。主要从事于计算机系统集成、软件与数据服务、IT运维服务等业务，服务于政府、学校、医疗、生产企业等行业。")]),_vm._v(" "),_c('p',[_vm._v("公司历经市场的考验，始终坚持紧跟时代步伐，积极引进、培养人才，经过十多年的耕耘，公司已拥有了一支成熟的专业技术队伍，能为用户提供全面\n\t\t\t\t\t的IT技术解决方案，能满足大型的信息化系统集成项目的管理与服务要求。此外，公司积极投入自主创新 研发，针对不同行业，推出了具有自己特色的解决\n\t\t\t\t\t方案。 \n\t\t\t\t\t")]),_vm._v(" "),_c('p',[_vm._v("未来我们将一如既往的关注客户的需求，专注于技术创新，以为客户提供专业的技术服务为目标，使客户得到最大的效益，我们真诚期待与广大客户精\n\t\t\t\t\t诚合作，共创辉煌！\n\t\t\t\t\t")]),_vm._v(" "),_vm._l((_vm.comimg),function(im){return _c('div',{staticClass:"imgcomab"},[_c('img',{attrs:{"src":im.imgsrc}})])})],2):_vm._e(),_vm._v(" "),(_vm.chalid == 1 )?_c('div',{staticClass:"cominfo"},[_c('p',{staticClass:"com-content"},[_vm._v(" 一直以来，广东思程科技都注重人才的管理和培养，努力建立一流的团队和学习型组织，充分挖掘每一个成员的潜力，让员工在工作中实现自我价值，我们最宝贵的财富是我们的员工。")]),_vm._v(" "),_c('div',{staticClass:"singleimg"},[_c('img',{attrs:{"src":"/static/img/frame.jpg"}})])]):_vm._e(),_vm._v(" "),(_vm.chalid == 2 )?_c('div',{staticClass:"cominfo"},[_c('div',{staticClass:"singlewimg"},[_c('img',{attrs:{"src":"/static/img/wenhua.png"}})]),_vm._v(" "),_c('div',{staticClass:"comwenhua"},_vm._l((_vm.wenhua),function(wcom){return _c('div',{staticClass:"wencom"},[_c('h3',[_vm._v(_vm._s(wcom.wentit))]),_vm._v(" "),_c('p',[_c('span',{staticClass:"glyphicon glyphicon-triangle-right"}),_vm._v("   "+_vm._s(wcom.wencontent))])])}),0)]):_vm._e(),_vm._v(" "),(_vm.chalid == 3 )?_c('div',{staticClass:"cominfo"},[_c('p',{staticClass:"com-content"},[_vm._v("惠州市德通科技有限公司成立于2004年，2012年公司变更冠名为广东思程科技有限公司，逐步发展成为了专业的信息化服务企业。")]),_vm._v(" "),_vm._l((_vm.honor),function(item){return _c('div',{staticClass:"certificate"},[_c('div',{staticClass:"pic",style:({'background-image': 'url('+  item.hoimg +')'})}),_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(item.honame)+"\n\t\t\t\t\t")])])})],2):_vm._e(),_vm._v(" "),(_vm.chalid == 4 )?_c('div',{staticClass:"newsinfo"},[_c('div',{staticClass:"aboutnewslist"},[_c('div',{staticClass:"aboutnewsli"},[_c('ul',_vm._l((_vm.news),function(newsli){return _c('li',{on:{"click":function($event){return _vm.todetail(newsli.ID)}}},[_vm._v(_vm._s(newsli.title)+"\n\t\t\t\t\t\t\t"),_c('div',{staticClass:"aboutlidata"},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(newsli.createDate)+"\n\t\t\t\t\t\t\t")])])}),0)])])]):_vm._e()])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comtop"},[_c('img',{attrs:{"src":"/static/img/aboutcom.jpg"}}),_vm._v(" "),_c('div',{staticClass:"bannerMask"},[_c('div')]),_vm._v(" "),_c('div',{staticClass:"com-titr"},[_c('span',[_c('img',{attrs:{"src":"/static/img/abouticon.png"}}),_c('b',[_vm._v("关于我们")])]),_vm._v(" "),_c('p',[_vm._v("专业的IT解决方案服务商。主要从事于计算机系统集成、软件开发、IT运"),_c('br'),_vm._v("维服务等业务，服务于 政府、学校、医疗、生产企业等行业。")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wUZA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__ = __webpack_require__("FGQs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b5bd1fd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__ = __webpack_require__("SRNm");
function injectStyle (ssrContext) {
  __webpack_require__("vPp3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5b5bd1fd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b5bd1fd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wqBJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'vheader',
	data: function data() {
		return {
			nav: [{ id: 0, name: '首页', linkto: '/' }, { id: 1, name: '关于思程', linkto: '/AboutcomInfo/' }, { id: 2, name: '业务中心', linkto: '/TechnologyService/' }, { id: 3, name: '解决方案', linkto: '/Solve/' }, { id: 4, name: '案例展示', linkto: '/Case/' }, { id: 5, name: '我们的产品', linkto: '/Product/' }, { id: 6, name: '服务平台', linkto: '/Saltout/' }],
			navcontent: [{ content: [{ name: '技术领域', vuelink: '/' }, { name: '业务模式', vuelink: '/' }] }, { content: [{ name: '公司简介', vuelink: '/AboutcomInfo' }, { name: '资质荣誉', vuelink: '/AboutcomHonor' }, { name: '组织框架', vuelink: '/AboutcomOrg' }, { name: '企业文化', vuelink: '/AboutcomCulture' }, { name: '新闻资讯', vuelink: '/AboutcomNews' }] }, { content: [{ name: '服务领域', vuelink: '/TechnologyService' }, { name: '业务模式', vuelink: '/TechnologyBusiness' }, { name: '技术领域', vuelink: '/TechnologyField' }] }, { content: [{
					name: '新零售', vuelink: '/Solve/' + 0 }, { name: '智慧旅游', vuelink: '/Solve/' + 1 }, { name: '智慧法院', vuelink: '/Solve/' + 2 }, { name: '智慧校园', vuelink: '/Solve/' + 5 }, { name: '智慧工厂', vuelink: '/Solve/' + 6 }, { name: '公共资源交易', vuelink: '/Solve/' + 3 }, { name: '律师行业业务', vuelink: '/Solve/' + 4 }, { name: '立体化社会防范', vuelink: '/Solve/' + 7 }] }, { content: [{ name: '案例展示', vuelink: '/' }] }, { content: [{ name: '环境监测系统', vuelink: '/Product/' + 0 }, { name: '企业招投标系统', vuelink: '/Product/' + 1 }, { name: '公共资源业务', vuelink: '/Product/' + 2 }, { name: '智慧旅游业务', vuelink: '/Product/' + 3 }, { name: '新零售业务系统', vuelink: '/Product/' + 4 }, { name: '律师行业系统', vuelink: '/Product/' + 5 }, { name: '通用OA业务系统', vuelink: '/Product/' + 6 }, { name: '智能综合指挥', vuelink: '/Product/' + 7 }] }, { content: [{ name: '售后服务', vuelink: '/Saltout' }, { name: '诚聘英才', vuelink: '/Zhaopin' }, { name: '联系我们', vuelink: '/Contactu' }] }],
			judge: -1,
			width: '100%',
			liwidth: '100%',
			logo: 'static/img/logo.png',
			backg: '#fff',
			color: '#fff',
			acli: 0,
			op: .1
		};
	},
	mounted: function mounted() {
		this.getscro();
	},

	methods: {
		slide: function slide(index) {
			if (index == 0 || index == 4 || index == 5 || index == 3) {
				this.judge = -1;
			} else {
				this.judge = index;
				if (index == 1) {
					this.width = '500%';
					this.liwidth = '20%';
				} else if (index == 2) {
					this.width = '200%';
					this.liwidth = '50%';
				} else if (index == 3 || index == 5) {
					this.width = '400%';
					this.liwidth = '25%';
				} else if (index == 6) {
					this.width = '300%';
					this.liwidth = '33.3%';
				}
			}
		},
		out: function out() {
			this.judge = -1;
		},
		linkto: function linkto(index) {
			this.acli = index;
			this.gotop();
		},
		gotop: function gotop() {
			window.scrollTo(0, 0);
		},
		getscro: function getscro() {
			var that = this;
			$(document).scroll(function () {
				var top = $(document).scrollTop();
				if (top > 150) {
					that.logo = 'static/img/logoit.png';
					that.backg = '#0066ef';
					that.color = '#fff';
					that.op = 1;
				} else if (top == 0) {
					that.logo = 'static/img/logo.png';
					that.backg = '#fff';
					that.color = '#fff';
					that.op = .1;
				} else if (top > 15 & top <= 150) {
					that.op = 1;
					that.logo = 'static/img/logo.png';
					that.color = '#000';
					that.backg = '#fff';
				}
			});
		}
	}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "x2i3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ding.d47c5d1.png";

/***/ }),

/***/ "x5b1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/contactusicon.5c133d4.png";

/***/ }),

/***/ "xGfG":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/frame.4f663ff.jpg";

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header__ = __webpack_require__("Cz8s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_footer__ = __webpack_require__("mzkE");
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    Vheader: __WEBPACK_IMPORTED_MODULE_0__components_header__["a" /* default */],
    Vfooter: __WEBPACK_IMPORTED_MODULE_1__components_footer__["a" /* default */]
  },
  computed: {
    key: function key() {
      return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date();
    }
  }
});

/***/ }),

/***/ "xhmT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aboutcom"},[_c('div',{staticClass:"comtop"},[_c('img',{attrs:{"src":__webpack_require__("xmSA")}}),_vm._v(" "),_c('div',{staticClass:"com-tit"},[_c('span',[_c('img',{attrs:{"src":__webpack_require__("x5b1")}}),_c('b',[_vm._v("联系我们")])]),_vm._v(" "),_c('p',[_vm._v("拥有专业的售后服务团队，秉承“优质、高效，用心服务”的"),_c('br'),_vm._v("\n服务理念，不断提高客户的满意度")])])]),_vm._v(" "),_c('div',{staticClass:"com-detail"},[_c('div',{staticClass:"com-top-top"},[_c('h4',[_vm._v("联系我们")]),_vm._v(" "),_c('div',{staticClass:"com-line"})]),_vm._v(" "),_c('div',{staticClass:"cominfo"},[_c('h4',{staticClass:"small-tit"},[_vm._v("联系我们")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("EE0m")}}),_c('br'),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("XxfM")}}),_c('br')])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xmSA":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/congtactus.5c73fdf.png";

/***/ }),

/***/ "y7Yn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aboutcom_honor_vue__ = __webpack_require__("qrdm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34eb8594_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aboutcom_honor_vue__ = __webpack_require__("w69A");
function injectStyle (ssrContext) {
  __webpack_require__("TkMI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aboutcom_honor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34eb8594_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aboutcom_honor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yc8Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"techonlogy"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"tech-detail"},[_c('div',{staticClass:"tech-top-top"},[_c('h4',[_vm._v(_vm._s(_vm.tech[_vm.chalid].title))]),_vm._v(" "),_c('div',{staticClass:"tech-line"})]),_vm._v(" "),(_vm.chalid == 0 )?_c('div',{staticClass:"techinfo"},[_c('p',{staticClass:"com-content"},[_vm._v(" 公司服务领域分为三大块：")]),_vm._v(" "),_c('div',{staticClass:"tech-singleimg"},[_c('img',{attrs:{"src":_vm.techimg[0].imgsrc}})]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.techimg[0].smalltit))]),_vm._v(" "),_c('p',[_vm._v("系统集成（SI，System Integration），我们在系统工程科学方法的指导下，经过专业技术的不断进步和多年施 工经验的积累，能为您提供智能弱电系统\n\t\t\t\t\t\t集成、网络安全系统集成、数据中心与云平台等三大项目和20个子系统的专业服务。\n\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"tech-singleimg"},[_c('img',{attrs:{"src":_vm.techimg[1].imgsrc}})]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.techimg[1].smalltit))]),_vm._v(" "),_c('p',[_vm._v("软件与数据服务（Software and data services），思程科技是以自主知识产权产品开发为核心的双软企业，我公司采用了CMMI管理模式体系以及国际上先进、成熟的开发工具和语言，开发了许多满足客户实际需求的应用软件。\n\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"tech-singleimg"},[_c('img',{attrs:{"src":_vm.techimg[2].imgsrc}})]),_vm._v(" "),_c('p',[_vm._v("软件（SAAS）即服务是行业的发展趋势，提供应用类的软件服务是公司的发展方向，公司以软件开发为基础，向用户提供全方向的信息化业务方案\n\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"tech-singleimg"},[_c('img',{attrs:{"src":_vm.techimg[3].imgsrc}})]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.techimg[2].smalltit))]),_vm._v(" "),_c('p',[_vm._v("IT运维服务 (IT operation and maintenance services) ，思程科技以专业的技术力量和运维团队为客户提 供IT领域全面的咨询、实施、运维、迁移、培训五大类服务。\n\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"tech-singleimg"},[_c('img',{attrs:{"src":_vm.techimg[4].imgsrc}})])]):_vm._e(),_vm._v(" "),(_vm.chalid == 1 )?_c('div',{staticClass:"techinfo"},[_c('p',{staticClass:"com-content"},[_vm._v(" 公司以信息化技术为基础，深入行业需求，服务于各行业，以提供相关行业的信息化解决方案为整体方向，以项目建设、产品开发、项目运营等形式拓展业务。")]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.yewu[0].smalltit))]),_vm._v(" "),_c('p',[_vm._v("由专业的信息化项目经理落实项目建设，全程项目监管勘查、设计、施工、维护")]),_vm._v(" "),_c('div',{staticClass:"tech-singleimg"},[_c('img',{staticStyle:{"width":"35%"},attrs:{"src":_vm.yewu[0].imgsrc}})]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.yewu[1].smalltit))]),_vm._v(" "),_c('p',[_vm._v("以市场需求为导向，结合相关的行业经验，公司不断推进产品开发工作，以优质产品赢取市场。\n\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"tech-singleimg"},[_c('img',{attrs:{"src":_vm.yewu[1].imgsrc}})]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.yewu[2].smalltit))]),_vm._v(" "),_c('p',[_vm._v("根据用户的业务需求，发挥公司的技术优势与资本能力，承担相关的信息化建设并负责具体运营，达到共赢的目的。\n\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"tech-singleimg"},[_c('img',{staticStyle:{"width":"36%"},attrs:{"src":_vm.yewu[2].imgsrc}})])]):_vm._e(),_vm._v(" "),(_vm.chalid == 2 )?_c('div',{staticClass:"techinfo"},[_c('p',{staticClass:"com-content"},[_vm._v(" 公司主要涉及的技术领域有（1）弱电+网络通讯（2）数据与安全（3）云技术（4）物联网（5）应用软件")]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.jishu[0].smalltit))]),_vm._v(" "),_c('div',{staticClass:"tech-singleimg"},[_c('img',{staticStyle:{"width":"45%"},attrs:{"src":_vm.jishu[0].imgsrc}})]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.jishu[1].smalltit))]),_vm._v(" "),_c('div',{staticClass:"tech-singleimg"},[_c('img',{staticStyle:{"width":"60%"},attrs:{"src":_vm.jishu[1].imgsrc}})]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.jishu[2].smalltit))]),_vm._v(" "),_c('div',{staticClass:"tech-singleimg"},[_c('img',{staticStyle:{"width":"60%"},attrs:{"src":_vm.jishu[2].imgsrc}})]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.jishu[3].smalltit))]),_vm._v(" "),_c('p',{staticClass:"com-content"},[_vm._v(" 顾名思义，物联网就是物物相连的互联网。这有两层意思：其一，物联网的核心和基础仍然是互联网，是在互\n\t\t\t\t\t联网基础上的延伸和扩展的网络；其二，其用户端延伸和扩展到了任何物品与物品之间，进行信息交换和通信，也就\n\t\t\t\t\t是物物相息。物联网通过智能感知、识别技术与普适计算等通信感知技术，广泛应用于网络的融合中，也因此被称\n\t\t\t\t\t为继计算机、互联网之后世界信息产业发展的第三次浪潮。物联网是互联网的应用拓展，与其说物联网是网络，不\n\t\t\t\t\t如说物联网是业务和应用。因此，应用创新是物联网发展的核心，以用户体验为核心的创新2.0是物联网发展的灵魂。\n\t\t\t\t\t")]),_vm._v(" "),_c('h4',{staticClass:"small-tit"},[_vm._v(_vm._s(_vm.jishu[4].smalltit))]),_vm._v(" "),_c('p',{staticClass:"com-content"},[_vm._v(" 应用软件开发，思程科技是以自主知识产权产品开发为核心的双软企业，我司采用了CMMI管理模式体系\n\t\t\t\t\t以上国际上先进、成熟的开发工具和语言，开发了许多满足客户实际需求的应用软件，应用于政府、民政、医疗、金融等各行业，用户反应良好。\n\t\t\t\t\t")]),_vm._v(" "),_c('p',{staticClass:"com-content"},[_vm._v(" 思程科技的软件研发团队是由一批技术能力强、项目经验丰富的软件人才组成，具有多元化的技术路线，涵盖各主流开发\n\t\t\t\t\t\t语言，在.net和JAVA方面都有着丰富的项目和产品开发经验\n\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"tech-singleimg"},[_c('img',{attrs:{"src":_vm.jishu[4].imgsrc}})])]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"techonlogy-top"},[_c('img',{attrs:{"src":"/static/img/fuwu.jpg"}}),_vm._v(" "),_c('div',{staticClass:"bannerMask"},[_c('div')]),_vm._v(" "),_c('div',{staticClass:"com-tit"},[_c('span',[_c('img',{attrs:{"src":"/static/img/fuwuicon.png"}}),_c('b',[_vm._v("业务中心")])]),_vm._v(" "),_c('p',[_vm._v("致力于为政府、学校、医疗、公共事业、生产企业等各行业提"),_c('br'),_vm._v("\n供专业的信息化服务")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yfWl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Vheader'),_vm._v(" "),_c('router-view',{key:_vm.key}),_vm._v(" "),_c('Vfooter')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ynmX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/p8-5.599e606.jpg";

/***/ }),

/***/ "z2Ij":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/xls01.e3191a7.png";

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.21c4f408919ed7e359e8.js